{
  "ai": {
    "actions": {
      "addAttachments": "Ajouter des photos ou des fichiers"
    },
    "attachments": {
      "imageAlt": "Image",
      "remove": "Retirer"
    },
    "conversation": {
      "emptyDescription": "Lancez une conversation pour voir les messages ici",
      "emptyTitle": "Aucun message pour l’instant"
    },
    "core": {
      "placeholder": "Que voulez-vous savoir ?",
      "stop": "Arrêter",
      "submit": "Envoyer",
      "uploadFiles": "Importer des fichiers"
    },
    "sources": {
      "usedCount": "{count, plural, one {{count} source utilisée} other {{count} sources utilisées}}"
    },
    "tool": {
      "errorHeading": "Erreur",
      "parameters": "Paramètres",
      "statusAwaitingApproval": "En attente de validation",
      "statusCompleted": "Terminé",
      "statusDenied": "Refusé",
      "statusError": "Erreur",
      "statusPending": "En attente",
      "statusResponded": "Répondu",
      "statusRunning": "En cours"
    }
  },

  "auth": {
    "appleNativeSheet": {
      "appleFailed": "La connexion avec Apple a échoué. Réessayez dans un instant.",
      "appleInvalidResponse": "Apple a renvoyé une réponse illisible. Merci de réessayer.",
      "appleNotHandled": "Apple n’a pas pu traiter la demande de connexion. Merci de réessayer.",
      "appleNotInteractive": "Apple n’a pas pu afficher la fenêtre de connexion. Merci de réessayer.",
      "appleUnavailable": "Apple n’a pas pu lancer la connexion. Vérifiez que vous êtes connecté à votre compte Apple dans les Réglages d’iOS, puis réessayez."
    },
    "appleSignInButton": {
      "continue": "Continuer avec Apple",
      "errorFallback": "Une erreur est survenue lors de la connexion avec Apple",
      "signingIn": "Connexion…"
    },
    "authScreen": {
      "confirmPasswordLabel": "Confirmer le mot de passe",
      "confirmPasswordPlaceholder": "Saisissez à nouveau votre mot de passe",
      "errorPasswordTooShort": "Le mot de passe doit contenir au moins 8 caractères",
      "errorPasswordsMismatch": "Les mots de passe ne correspondent pas",
      "newPasswordLabel": "Nouveau mot de passe",
      "newPasswordPlaceholder": "8 caractères minimum",
      "passwordResetDescription": "Votre mot de passe a bien été réinitialisé.",
      "passwordResetTitle": "Mot de passe réinitialisé",
      "signIn": "Se connecter"
    },
    "errors": {
      "accountNotFound": "Compte introuvable",
      "changeEmailDisabled": "Le changement d’adresse e-mail est désactivé",
      "credentialAccountNotFound": "Compte d’identifiants introuvable",
      "emailAlreadyVerified": "L’adresse e-mail est déjà vérifiée",
      "emailCanNotBeUpdated": "L’adresse e-mail ne peut pas être modifiée",
      "emailMismatch": "Les adresses e-mail ne correspondent pas",
      "emailNotVerified": "Adresse e-mail non vérifiée",
      "failedToUnlinkLastAccount": "Vous ne pouvez pas dissocier votre dernier compte",
      "invalidEmail": "Adresse e-mail invalide",
      "invalidEmailOrPassword": "Adresse e-mail ou mot de passe incorrect",
      "invalidOtp": "Code à usage unique invalide",
      "invalidPassword": "Mot de passe incorrect",
      "invalidToken": "Jeton invalide",
      "linkedAccountAlreadyExists": "Ce compte associé existe déjà",
      "otpExpired": "Code à usage unique expiré",
      "passwordAlreadySet": "Cet utilisateur a déjà un mot de passe",
      "passwordTooLong": "Mot de passe trop long",
      "passwordTooShort": "Mot de passe trop court",
      "sessionExpired": "Session expirée. Reconnectez-vous pour effectuer cette action.",
      "sessionNotFresh": "Session trop ancienne",
      "socialAccountAlreadyLinked": "Ce compte social est déjà associé",
      "tokenExpired": "Jeton expiré",
      "tooManyAttempts": "Trop de tentatives",
      "tooManyRequests": "Trop de tentatives. Patientez un instant et réessayez.",
      "userAlreadyExists": "Cet utilisateur existe déjà.",
      "userAlreadyExistsUseAnotherEmail": "Cet utilisateur existe déjà. Utilisez une autre adresse e-mail.",
      "userAlreadyHasPassword": "Cet utilisateur a déjà un mot de passe. Saisissez-le pour supprimer le compte.",
      "userNotFound": "Utilisateur introuvable"
    },
    "filingExceptionNotice": {
      "worksFromDayOne": "Les messages des voyageurs, le calendrier, les tâches et l’assistant IA fonctionnent dès le premier jour."
    },
    "forgotPassword": {
      "backToSignIn": "Retour à la connexion",
      "codeLabel": "Code de réinitialisation",
      "descriptionCode": "Nous avons envoyé un code à {email}. Saisissez-le ci-dessous avec votre nouveau mot de passe.",
      "descriptionEmail": "Saisissez votre adresse e-mail et nous vous enverrons un code de réinitialisation à 6 chiffres",
      "emailLabel": "E-mail",
      "emailPlaceholder": "nom@exemple.fr",
      "errorCodeIncomplete": "Saisissez le code à 6 chiffres reçu par e-mail",
      "errorEmailRequired": "L’adresse e-mail est obligatoire",
      "resend": "Pas reçu de code ? Renvoyer",
      "resetting": "Réinitialisation…",
      "sendCode": "Envoyer le code",
      "submit": "Réinitialiser le mot de passe",
      "titleCode": "Saisir le code de réinitialisation",
      "titleEmail": "Mot de passe oublié"
    },
    "googleSignInButton": {
      "continue": "Continuer avec Google",
      "signingIn": "Connexion…"
    },
    "legalConsent": {
      "agreement": "En créant un compte, vous acceptez nos <terms>Conditions d’utilisation</terms> et notre <privacy>Politique de confidentialité</privacy>."
    },
    "oauthConsent": {
      "allow": "Autoriser l’accès",
      "allowing": "Autorisation…",
      "deny": "Refuser",
      "denying": "Refus…",
      "errorRequestInvalid": "Cette demande de connexion n’est plus valide. Fermez cet onglet et reconnectez-vous depuis votre application d’IA.",
      "errorSessionEnded": "Votre session Vidimo a pris fin. Reconnectez-vous, puis relancez la connexion depuis votre application d’IA.",
      "errorUnreachable": "Impossible de joindre Vidimo. Vérifiez votre connexion et réessayez.",
      "expiredDescription": "Cette demande de connexion est invalide ou a expiré. Fermez cet onglet et reconnectez-vous depuis votre application d’IA.",
      "expiredTitle": "Demande de connexion expirée",
      "goToSignIn": "Aller à la connexion",
      "guestsDetail": "coordonnées, statut des déclarations",
      "guestsLabel": "Voyageurs et déclarations",
      "loading": "Chargement…",
      "occupancyDetail": "indicateurs, chambres, équipe",
      "occupancyLabel": "Occupation et infos de l’établissement",
      "importHeading": "Importer vos réservations existantes",
      "importScope": "Les propriétaires et les gérants peuvent autoriser l’application d’IA à copier les réservations de votre système actuel vers un établissement encore en préparation dans Vidimo. Elle ne peut modifier ou annuler que les réservations importées de votre système actuel, et rien de ce qu’elle importe ne parvient aux voyageurs, aux canaux ni aux autorités.",
      "readOnlyHeading": "Accès en lecture seule à",
      "readOnlyScope": "Uniquement les données auxquelles votre rôle donne déjà accès dans Vidimo. L’application d’IA ne peut rien créer, modifier, envoyer ni supprimer.",
      "readOnlyScopeExceptImport": "Uniquement les données auxquelles votre rôle donne déjà accès dans Vidimo. À part importer des réservations, l’application d’IA ne peut rien créer, modifier, envoyer ni supprimer.",
      "readableItem": "<strong>{label}</strong><muted> : {detail}</muted>",
      "reservationsDetail": "réservations, dates, chambres libres",
      "reservationsLabel": "Réservations et disponibilités",
      "signInRequiredDescription": "Votre session Vidimo a pris fin. Connectez-vous, puis relancez la connexion depuis votre application d’IA.",
      "signInRequiredTitle": "Connexion requise",
      "signedInAs": "Connecté en tant que {email}. Vous pouvez vous déconnecter à tout moment depuis {name}.",
      "signedInAsUnnamed": "Connecté en tant que {email}. Vous pouvez vous déconnecter à tout moment depuis votre application d’IA.",
      "tasksDetail": "ménage et maintenance",
      "tasksLabel": "Tâches",
      "title": "Autoriser l’accès à vos données Vidimo ?",
      "touristTaxDetail": "montants dus et payés",
      "touristTaxLabel": "Taxe de séjour et soldes",
      "wantsToConnect": "<app>{name}</app> souhaite se connecter à votre compte Vidimo.",
      "wantsToConnectUnnamed": "Une application d’IA souhaite se connecter à votre compte Vidimo."
    },
    "resetPassword": {
      "backToSignIn": "Retour à la connexion",
      "description": "Saisissez votre nouveau mot de passe ci-dessous",
      "errorTokenMissing": "Jeton de réinitialisation invalide ou manquant",
      "resetting": "Réinitialisation…",
      "submit": "Réinitialiser le mot de passe",
      "title": "Réinitialiser le mot de passe"
    },
    "signIn": {
      "description": "Saisissez votre adresse e-mail pour vous connecter à votre compte",
      "emailLabel": "E-mail",
      "emailPlaceholder": "nom@exemple.fr",
      "errorCredentialsRequired": "L’adresse e-mail et le mot de passe sont obligatoires",
      "forgotPassword": "Mot de passe oublié ?",
      "noAccount": "Pas encore de compte ?",
      "passwordLabel": "Mot de passe",
      "passwordPlaceholder": "Saisissez votre mot de passe",
      "signUp": "Créer un compte",
      "signingIn": "Connexion…",
      "submit": "Se connecter",
      "title": "Connexion"
    },
    "signUp": {
      "creatingAccount": "Création du compte…",
      "description": "Inscrivez-vous pour commencer avec Vidimo",
      "emailLabel": "E-mail",
      "emailPlaceholder": "nom@exemple.fr",
      "errorCredentialsRequired": "L’adresse e-mail et le mot de passe sont obligatoires",
      "errorNameRequired": "Le nom d’affichage est obligatoire",
      "errorPasswordTooShort": "Le mot de passe doit contenir au moins 8 caractères",
      "haveAccount": "Vous avez déjà un compte ?",
      "nameLabel": "Nom d’affichage",
      "namePlaceholder": "Marie Dupont",
      "passwordHint": "8 caractères minimum",
      "passwordLabel": "Mot de passe",
      "passwordPlaceholder": "8 caractères minimum",
      "signIn": "Se connecter",
      "submit": "Créer un compte",
      "title": "Créer un compte"
    },
    "socialSignIn": {
      "divider": "Ou continuer avec"
    },
    "verifyEmail": {
      "backToSignIn": "Retour à la connexion",
      "continue": "Continuer",
      "errorLinkExpired": "Ce lien de vérification a expiré. Demandez-en un nouveau.",
      "errorLinkFailed": "Ce lien de vérification n’a pas fonctionné.",
      "errorLinkInvalid": "Ce lien de vérification n’est plus valide.",
      "errorLinkNotVerified": "Ce lien de vérification n’a pas fonctionné. Demandez-en un nouveau.",
      "errorNoSessionEmail": "Aucune adresse e-mail trouvée dans la session",
      "errorNotConfirmed": "Nous n’avons pas pu confirmer la vérification de votre adresse e-mail.",
      "errorTokenMissing": "Jeton de vérification invalide ou manquant",
      "failedTitle": "Échec de la vérification",
      "goToSignIn": "Aller à la connexion",
      "resend": "Renvoyer l’e-mail de vérification",
      "resent": "Envoyé : un nouveau lien vous attend dans votre boîte de réception.",
      "sendAnother": "En envoyer un autre",
      "successDescription": "Votre adresse e-mail a été vérifiée. Vous allez être connecté automatiquement.",
      "successTitle": "Adresse e-mail vérifiée",
      "unconfirmedDescription": "Vous êtes déconnecté, nous ne pouvons donc pas confirmer le résultat ici. Connectez-vous : si le lien a fonctionné, votre adresse e-mail est déjà vérifiée.",
      "unconfirmedTitle": "Vérifiez votre lien de vérification"
    }
  },

  "calendar": {
    "agendaData": {
      "arrival": "Arrivée",
      "balanceDue": "{amount} à régler",
      "departure": "Départ",
      "due": "Échéance {date}",
      "eta": "Arrivée prévue {time}",
      "guest": "Voyageur",
      "inHouse": "Sur place",
      "paid": "Payé",
      "until": "Jusqu’au {date}"
    },
    "calendarAgendaView": {
      "arrivals": "Arrivées",
      "departures": "Départs",
      "emptyDescription": "Aucune arrivée, aucun départ ni voyageur sur place le {date}.",
      "emptyDescriptionToday": "Aucune arrivée, aucun départ ni voyageur sur place aujourd’hui.",
      "emptyTitle": "Rien de prévu",
      "inHouse": "Sur place",
      "syncing": "Synchronisation de votre agenda…",
      "tasksFor": "Tâches pour {guestName}",
      "unassigned": "Non affectée",
      "unconfirmed": "Non confirmée"
    },
    "calendarAvailabilityBand": {
      "free": "Libre",
      "freeRoomsPerNight": "Chambres libres par nuit",
      "roomsFree": "{count, plural, one {chambre libre} other {chambres libres}}",
      "spokenDatePrefix": "{date} : "
    },
    "calendarLegend": {
      "markBase": "Prix de base",
      "markChanged": "Modifié à l’instant",
      "markChosen": "Sélectionné pour modification",
      "markChosenClosed": "Sélectionné, fermé à la vente",
      "markClosed": "Fermé à la vente",
      "markMinStay": "Séjour minimum",
      "markSeason": "Issu d’une saison",
      "markSet": "Défini pour cette nuit",
      "rates": "Tarifs",
      "reservations": "Réservations",
      "tapActivity": "Pour savoir qui a modifié quoi, allez dans les Paramètres de l’établissement, puis Équipe, Activité.",
      "tapDate": "Touchez une date pour modifier cette nuit pour tous les types de logement de l’établissement.",
      "tapNight": "Touchez une nuit pour la modifier.",
      "tapOtherRow": "Touchez une nuit sur une autre ligne pour ajouter ce type de logement.",
      "tapSpan": "Touchez une deuxième nuit sur la même ligne pour sélectionner une période.",
      "tasks": "Tâches",
      "title": "Légende"
    },
    "calendarPage": {
      "createFirstUnit": "Créer votre premier logement",
      "emptyDescription": "Ajoutez un logement à votre établissement pour suivre les réservations dans le calendrier.",
      "emptyTitle": "Aucun logement pour l’instant",
      "legend": "Légende du calendrier",
      "newReservation": "Nouvelle réservation",
      "newTask": "Nouvelle tâche",
      "tasksMissingTitle": "Tâches absentes du calendrier",
      "title": "Calendrier",
      "unavailableDescription": "Vidimo ne parvient pas à charger vos logements sur cet appareil. Touchez Réessayer : l’application sera rechargée.",
      "unavailableTitle": "Impossible d’afficher le calendrier pour le moment"
    },
    "calendarView": {
      "blockDates": "Bloquer des dates",
      "blockingHint": "Faites glisser le doigt sur la ligne d’une chambre pour bloquer les nuits voulues. Balayez les dates ou les noms des chambres pour faire défiler. Pour ouvrir une réservation, touchez d’abord « {done} ».",
      "doneBlocking": "Terminer le blocage",
      "errorBlockFailed": "Impossible de bloquer ces nuits. Réessayez.",
      "jumpToDate": "Aller à une date",
      "next": "Suivant",
      "noUnits": "Aucun logement à afficher",
      "previous": "Précédent",
      "staffEmptyDescription": "La vue Équipe affiche les tâches affectées et les absences de chaque membre.",
      "staffEmptyTitle": "Aucun membre de l’équipe à afficher",
      "syncing": "Synchronisation de votre calendrier…",
      "today": "Aujourd’hui",
      "unassignedLane": "À attribuer",
      "unknownProperty": "Établissement inconnu"
    },
    "calendarViewMenu": {
      "title": "Vue",
      "triggerLabel": "Vue : {view}"
    },
    "propertyEmptyState": {
      "acceptInvitation": "Accepter l’invitation",
      "back": "Retour",
      "createDescription": "Configurez un nouvel établissement pour gérer vos voyageurs et votre équipe.",
      "createInstead": "Créer plutôt un établissement",
      "createTitle": "Créer un établissement",
      "errorCreateFailed": "Impossible de créer l’établissement. Réessayez.",
      "getStartedDescription": "Créez un nouvel établissement ou rejoignez-en un avec un code d’invitation.",
      "getStartedTitle": "Pour commencer",
      "invitedAs": "Invité en tant que {role}",
      "invitedDescription": "{count, plural, one {Vous avez été invité dans un établissement. Acceptez pour commencer.} other {Vous avez été invité dans ces établissements. Acceptez-en un pour commencer.}}",
      "invitedTitle": "Vous êtes invité",
      "joinDescription": "Saisissez le code d’invitation reçu pour rejoindre votre équipe.",
      "joinTitle": "Rejoindre un établissement",
      "syncing": "Configuration de votre établissement…",
      "syncingSlow": "Cela prend plus de temps que d’habitude. Votre établissement est créé et apparaîtra dès que votre connexion aura rattrapé son retard.",
      "toastCreated": "Établissement créé"
    },
    "timelineData": {
      "away": "Absent"
    },
    "todayPage": {
      "nextDay": "Jour suivant",
      "pickDay": "Choisir un jour",
      "previousDay": "Jour précédent"
    },
    "transportSelector": {
      "changeTransport": "Changer de canal",
      "menuLabel": "Choisir le canal"
    },
    "unitReadinessControl": {
      "errorUpdateFailed": "Impossible de mettre à jour l’état de la chambre. Réessayez.",
      "hint": "Enregistré dès que vous le modifiez. Terminer une tâche de ménage le passe à Propre, et un départ le passe à Sale, sauf pour Hors service, que vous seul pouvez lever.",
      "label": "État",
      "outOfOrderHint": "Hors service empêche aussi d’attribuer de nouvelles réservations à cette chambre et suspend le code d’accès des personnes qui y séjournent déjà."
    }
  },

  "checkIn": {
    "guestRegistration": {
      "anotherGuest": "un autre voyageur",
      "heldByOther": "{documentNumber} est déjà utilisé par {holderName}."
    },
    "useRegistrationOutbox": {
      "deferred": "{count, plural, one {La déclaration de {guests} a été reprise par un autre compte connecté sur cet appareil. Elle sera transmise à la prochaine connexion de cet utilisateur ici.} other {Les déclarations de {guests} ont été reprises par d’autres comptes connectés sur cet appareil. Elles seront transmises à la prochaine connexion de ces utilisateurs ici.}}",
      "dropped": "{count, plural, one {Impossible de transmettre la déclaration de {guests}. Ouvrez la réservation pour la corriger.} other {Impossible de transmettre les déclarations de {guests}. Ouvrez les réservations pour les corriger.}}",
      "filed": "{count, plural, one {Une déclaration de voyageur en attente a été transmise.} other {# déclarations de voyageurs en attente ont été transmises.}}",
      "guestsOneNameAndOthers": "{first} et {count, plural, one {# autre} other {# autres}}",
      "guestsTwoNames": "{first} et {second}",
      "guestsTwoNamesAndOthers": "{first}, {second} et {count, plural, one {# autre} other {# autres}}",
      "guestsUnnamed": "{count, plural, one {un voyageur} other {# voyageurs}}"
    }
  },

  "common": {
    "countryPicker": {
      "emptyLabel": "Aucun pays ne correspond",
      "placeholder": "Choisir un pays",
      "searchLabel": "Rechercher un pays"
    },
    "dateRangePicker": {
      "nights": "{nights, plural, one {# nuit} other {# nuits}}",
      "placeholder": "Choisir les dates"
    },
    "detailsDrawer": {
      "close": "Fermer",
      "copyLinkLabel": "Copier le lien vers cette fiche",
      "edit": "Modifier"
    },
    "dialog": {
      "close": "Fermer"
    },
    "errors": {
      "generic": "Une erreur est survenue. Merci de réessayer.",
      "networkUnreachable": "Pas de connexion. Vérifiez votre réseau et réessayez.",
      "subscriptionRequired": "Cette action nécessite un abonnement actif, et cet établissement n’en a pas.",
      "unreadableNumber": "Saisissez un nombre comme {example, number}."
    },
    "insetForm": {
      "cancel": "Annuler",
      "save": "Enregistrer",
      "saving": "Enregistrement…"
    },
    "loading": "Chargement",
    "personCard": {
      "call": "Appeler",
      "callLabel": "Appeler {name}",
      "idOnFile": "Pièce d’identité enregistrée",
      "message": "Message",
      "openLabel": "Ouvrir {name}"
    },
    "phoneNumberInput": {
      "country": "Indicatif pays",
      "international": "International",
      "invalid": "Vérifiez le numéro et choisissez son pays avec le drapeau."
    },
    "picker": {
      "done": "Terminé",
      "noMatches": "Aucun résultat",
      "search": "Rechercher"
    }
  },

  "communications": {
    "connectRefusalDrafts": {
      "account_claimed": "Bonjour, j’essaie de connecter un compte qui est déjà relié à un autre établissement. Pouvez-vous m’aider ?",
      "number_claimed": "Bonjour, j’essaie de connecter un numéro qui est déjà relié à un autre établissement. Pouvez-vous m’aider ?",
      "property_preparing": "Bonjour, j’aimerais connecter un canal alors que mon établissement est encore en préparation. Pouvez-vous m’aider ?",
      "setup_broken": "Bonjour, la connexion d’un canal s’est bloquée en cours de configuration et l’application ne peut pas aller plus loin. Pouvez-vous m’aider ?",
      "subscription_required": "Bonjour, la connexion d’un canal demande un abonnement actif. Pouvez-vous m’aider ?"
    },
    "activeCallView": {
      "activeCall": "Appel en cours",
      "hangUp": "Raccrocher",
      "minimiseCall": "Réduire l’appel",
      "mute": "Couper le micro",
      "resume": "Reprendre",
      "roomStatus": "Chambre {unitCode} · {status}",
      "speakerOff": "Haut-parleur désactivé",
      "speakerOn": "Haut-parleur activé",
      "transfer": "Transférer",
      "unmute": "Réactiver le micro"
    },
    "aiChatListView": {
      "emptyDescription": "Lancez une nouvelle conversation avec votre assistant IA",
      "emptyTitle": "Aucune conversation IA",
      "newChat": "Nouvelle conversation"
    },
    "aiChatView": {
      "aiAssistant": "Assistant IA",
      "chooseProperty": "Choisir un établissement",
      "choosePropertyDescription": "L’assistant répond pour un établissement à la fois : choisissez celui qui vous intéresse.",
      "choosePropertyTitle": "Quel établissement ?",
      "emptyDescription": "Posez-moi vos questions sur les voyageurs, les réservations ou les tâches",
      "emptyTitle": "Comment puis-je vous aider ?",
      "errorAmbiguousScopeDetail": "L’assistant répond pour un établissement à la fois. Choisissez-en un dans l’en-tête et reposez votre question.",
      "errorAmbiguousScopeTitle": "Choisissez un établissement",
      "errorEmptyScopeDetail": "Votre périmètre ne comprend aucun établissement accessible. Élargissez-le depuis l’en-tête et réessayez.",
      "errorEmptyScopeTitle": "Rien dans le périmètre",
      "errorPausedDetailNative": "L’IA est incluse dans l’abonnement actif de cet établissement.",
      "errorPausedTitle": "L’IA est en pause",
      "errorSend": "Impossible d’envoyer votre message. Réessayez.",
      "errorTranscribe": "Impossible de transcrire votre enregistrement",
      "errorUnreachableDetail": "Vérifiez votre connexion et réessayez.",
      "errorUnreachableTitle": "L’assistant n’a pas pu répondre",
      "newChat": "Nouvelle conversation",
      "retry": "Réessayer",
      "retryTooltip": "Renvoyer le dernier message",
      "suggestionCheckIns": "Affiche les arrivées du jour",
      "suggestionMaintenance": "Des problèmes de maintenance ?",
      "suggestionOccupancy": "Quel était notre taux d’occupation le mois dernier ?"
    },
    "aiMessageParts": {
      "copied": "Copié dans le presse-papiers",
      "copyTooltip": "Copier le message",
      "errorCopy": "Impossible de copier le message",
      "moreActions": "Plus d’actions",
      "regenerate": "Régénérer",
      "sourceFallbackTitle": "Référence de réservation"
    },
    "aiPromptComposer": {
      "placeholder": "Posez votre question",
      "placeholderTranscribing": "Transcription…"
    },
    "callEventBubble": {
      "callEnded": "Appel terminé",
      "callWithDuration": "Appel · {duration}",
      "calling": "Appel en cours…",
      "incomingCall": "Appel entrant",
      "incomingCallRinging": "Appel entrant…",
      "missedCall": "Appel manqué",
      "ongoingCall": "Appel en cours · {duration}",
      "outgoingCall": "Appel sortant",
      "outgoingMissedCall": "Appel sortant sans réponse"
    },
    "callWaiting": {
      "accept": "Accepter",
      "callEnded": "Appel terminé",
      "callEndedWith": "Appel avec {name} terminé",
      "callOnHold": "Appel en attente",
      "decline": "Refuser",
      "endAndAccept": "Raccrocher et accepter",
      "holdAndAccept": "Mettre en attente et accepter",
      "onCall": "En appel",
      "onCallWith": "En appel avec {name}",
      "onHoldWith": "{name} en attente",
      "swap": "Échanger"
    },
    "chatHeader": {
      "back": "Retour",
      "badgeGuest": "Voyageur",
      "badgeInternal": "Interne",
      "badgeSupport": "Assistance",
      "call": "Appeler {name}",
      "linkReservation": "Lier une réservation",
      "openReservation": "Ouvrir la réservation",
      "unknownName": "Inconnu"
    },
    "chatInputBar": {
      "placeholder": "Écrivez un message…",
      "recordVoice": "Enregistrer un message vocal",
      "sendDocument": "Envoyer un document",
      "sendPhotoOrVideo": "Envoyer une photo ou une vidéo",
      "transcribing": "Transcription…"
    },
    "chatItem": {
      "chatWith": "Conversation avec {name}",
      "noMessages": "Aucun message pour l’instant",
      "unknownName": "Inconnu"
    },
    "chatMessageBubble": {
      "copied": "Copié dans le presse-papiers",
      "copyMessage": "Copier le message",
      "dismissReactionPicker": "Fermer le choix de réaction",
      "errorCopy": "Impossible de copier le message",
      "messagePlaceholder": "Message",
      "senderAndTime": "{sender} · {time}"
    },
    "chatView": {
      "emptyDescription": "Envoyez un message pour commencer la conversation",
      "emptyTitle": "Démarrer une conversation",
      "scrollToNewest": "Aller au message le plus récent"
    },
    "chatsTabBar": {
      "ai": "IA",
      "guests": "Voyageurs",
      "openDialer": "Ouvrir le clavier",
      "staff": "Équipe",
      "unread": "{count, plural, one {{count} non lu} other {{count} non lus}}"
    },
    "chatsView": {
      "emptyDescription": "Choisissez une conversation voyageur, équipe ou IA dans la liste",
      "emptyTitle": "Choisissez une conversation",
      "hideConversationList": "Masquer la liste des conversations",
      "showConversationList": "Afficher la liste des conversations"
    },
    "deliveryErrorCopy": {
      "genericFailure": "Impossible de distribuer ce message.",
      "instagramGeneric": "Impossible d’envoyer cette réponse sur Instagram.",
      "instagramLateReplyRefused": "Non envoyé : Instagram n’a pas encore autorisé Vidimo à répondre plus de 24 heures après le dernier message du voyageur.",
      "instagramNoIdentity": "Non envoyé : ce voyageur n’est pas joignable sur Instagram.",
      "instagramNotConnected": "Non envoyé : Instagram n’est pas connecté pour cet établissement. Reconnectez-le dans Paramètres > Messagerie.",
      "instagramUndeliverable": "Instagram n’a pas distribué ce message. Le voyageur a peut-être bloqué le compte ou supprimé la conversation.",
      "instagramWindowClosed": "Non envoyé : la fenêtre de réponse d’Instagram est fermée. Le voyageur doit vous écrire à nouveau.",
      "invalidNumber": "Le numéro de téléphone du voyageur semble invalide. Vérifiez ses coordonnées.",
      "optedOut": "Le voyageur a refusé les messages de ce numéro. L’envoi reste bloqué tant qu’il ne les accepte pas de nouveau.",
      "phoneUnreachable": "Le téléphone du voyageur est injoignable : il est peut-être éteint ou hors réseau. Réessayez plus tard.",
      "whatsappWindowClosed": "La fenêtre de réponse de 24 heures de WhatsApp est fermée. Recontactez le voyageur avec un modèle de message approuvé."
    },
    "dialerDrawer": {
      "call": "Appeler",
      "calling": "Appel en cours…",
      "cancel": "Annuler",
      "description": "Composez un numéro ou recherchez un voyageur existant.",
      "errorAlreadyInCall": "Vous êtes déjà en communication",
      "errorCallingUnsupported": "Les appels ne sont disponibles que dans l’application mobile",
      "errorPermissionRequest": "Impossible d’envoyer la demande d’autorisation. Réessayez.",
      "errorStartCall": "Impossible de lancer l’appel",
      "guest": "Voyageur",
      "noMatches": "Aucun résultat",
      "permissionRequestSent": "Demande d’autorisation envoyée via WhatsApp",
      "phoneNumber": "Numéro de téléphone",
      "phoneNumberPlaceholder": "Saisissez un numéro",
      "refusal": {
        "invalid_phone_number": "Ce numéro de téléphone n’est pas valide. Saisissez-le avec l’indicatif du pays, par exemple +33.",
        "whatsapp_not_connected": "Cet établissement n’a aucun numéro WhatsApp connecté. Connectez-en un dans les Paramètres, puis réessayez."
      },
      "requestCallPermission": "Demander l’autorisation d’appeler (WhatsApp)",
      "search": "Rechercher",
      "searchPlaceholder": "Nom ou numéro",
      "sending": "Envoi…",
      "staff": "Équipe",
      "title": "Passer un appel"
    },
    "entityShareCard": {
      "guestFallbackName": "Voyageur",
      "kindBooking": "Réservation",
      "kindGuest": "Voyageur",
      "kindTask": "Tâche",
      "noUpcomingStay": "Aucun séjour à venir",
      "sharedBooking": "A partagé une réservation",
      "sharedGuest": "A partagé un voyageur",
      "sharedTask": "A partagé une tâche",
      "stayDates": "{checkIn} – {checkOut}",
      "unassigned": "Non affectée",
      "unscheduled": "Non planifiée"
    },
    "guestChatDetails": {
      "erasedStaffSender": "Ancien membre de l’équipe",
      "errorAccountLoading": "Votre compte est encore en cours de chargement : réessayez dans un instant",
      "errorNoMembership": "Impossible de vérifier votre accès à cet établissement",
      "errorNoProperty": "Choisissez d’abord un établissement",
      "errorNotSent": "Impossible d’envoyer votre message. Réessayez.",
      "errorNotStarted": "Impossible de démarrer cette conversation. Réessayez.",
      "guestFallback": "Voyageur",
      "linkOnlyStaffDescription": "Les voyageurs ne peuvent pas l’ouvrir : il n’y a donc rien à envoyer.",
      "linkOnlyStaffTitle": "Ce lien ne fonctionne que dans les conversations d’équipe",
      "linkRemovedDescription": "Il ne fonctionne que dans les conversations d’équipe : le voyageur ne le verra pas.",
      "linkRemovedTitle": "Lien de fiche retiré"
    },
    "guestChatInputBar": {
      "waitingForGuest": "En attente d’un message du voyageur"
    },
    "guestChatListView": {
      "emptyDescription": "En attente de nouveaux messages de voyageurs",
      "emptyTitle": "Aucune conversation voyageur",
      "fallbackName": "Voyageur"
    },
    "guestChatMessageBubble": {
      "attachment": "Pièce jointe",
      "copyErrorForSupport": "Copier l’erreur pour l’assistance",
      "draftReply": "Rédiger une réponse",
      "drafting": "Rédaction…",
      "errorCopied": "Erreur copiée pour l’assistance",
      "errorCopyFailed": "Impossible de copier l’erreur",
      "retry": "Réessayer",
      "retrySendFailed": "Impossible de relancer l’envoi : merci de réessayer",
      "retryTranscriptionFailed": "Impossible de relancer la transcription : merci de réessayer",
      "showOriginal": "Afficher l’original",
      "showTranslation": "Afficher la traduction",
      "statusDelivered": "Distribué",
      "statusFailed": "Échec",
      "statusPending": "En attente",
      "statusRead": "Lu",
      "statusSent": "Envoyé",
      "translate": "Traduire",
      "translateMessage": "Traduire le message",
      "translating": "Traduction…"
    },
    "guestChatView": {
      "draftFailed": "Impossible de rédiger une réponse. Réessayez.",
      "placeholderCheckingAccess": "Vérification de votre accès…",
      "placeholderDiverted": "Répondre par {transport} : impossible d’envoyer par {divertedFrom}",
      "placeholderLoadingChannels": "Chargement des canaux…",
      "placeholderNoChannel": "Aucun canal ne peut encore envoyer ici",
      "placeholderReply": "Répondre au voyageur…",
      "placeholderUnreachable": "Le voyageur n’est joignable sur aucun canal",
      "voiceNoteFailed": "Impossible d’envoyer le message vocal"
    },
    "guestChats": {
      "linkFailed": "Impossible de lier cette conversation à la réservation.",
      "refusal": {
        "chat_not_found": "Cette conversation n’existe plus.",
        "no_room": "Aucun logement n’est attribué à cette réservation : impossible d’y ajouter un voyageur.",
        "party_full": "Cette réservation compte déjà tous les voyageurs attendus. Pour ajouter ce voyageur, augmentez d’abord le nombre d’adultes, d’enfants ou de bébés.",
        "reservation_not_active": "Cette réservation n’accepte plus de voyageurs.",
        "reservation_not_found": "Cette réservation n’existe plus."
      }
    },
    "guestDetails": {
      "age": "{age, plural, one {{age} an} other {{age} ans}}",
      "call": "Appeler",
      "guestInformation": "Informations du voyageur",
      "loadError": "Impossible de charger ce profil voyageur.",
      "merge": "Fusionner",
      "message": "Message",
      "notFoundDescription": "Ce voyageur appartient peut-être à un établissement qui n’est pas sélectionné. Changez d’établissement et réessayez.",
      "notFoundTitle": "Voyageur introuvable",
      "relatedBookings": "Réservations associées"
    },
    "guestDirectoryView": {
      "allStatuses": "Tous les statuts",
      "allUnits": "Tous les logements",
      "arrivalDates": "Dates d’arrivée",
      "callGuest": "Appeler {name}",
      "clear": "Effacer",
      "emptyDescription": "Les voyageurs apparaissent ici dès qu’ils réservent ou s’enregistrent.",
      "emptyTitle": "Aucun voyageur pour l’instant",
      "filteredCount": "{count, plural, one {{filtered} sur {count}} other {{filtered} sur {count}}}",
      "guestCount": "{count, plural, one {{count} voyageur} other {{count} voyageurs}}",
      "noMatchesDescription": "Aucun voyageur ne correspond à ces filtres.",
      "noMatchesTitle": "Aucun résultat",
      "openGuest": "Ouvrir {name}",
      "searchPlaceholder": "Nom, téléphone ou e-mail…",
      "statusFilterLabel": "Filtrer par statut de réservation",
      "syncing": "Synchronisation de vos voyageurs…",
      "title": "Voyageurs",
      "unitFilterLabel": "Filtrer par logement"
    },
    "guestReplyDeniedBar": {
      "cannotReply": "Votre rôle dans cet établissement ne permet pas de répondre aux voyageurs",
      "preparing": "Cet établissement est en préparation : son système actuel répond encore aux voyageurs"
    },
    "guestTransports": {
      "emailNotConfigured": "Le canal e-mail n’est pas encore configuré.",
      "inboundOnly": "Les messages {platform} arrivent ici, mais il n’est pas encore possible d’y répondre.",
      "instagramNotSetUp": "Instagram n’est pas encore configuré.",
      "smsNotConnected": "Aucun numéro SMS n’est encore connecté à cet établissement.",
      "smsUnavailable": "Les SMS ne sont pas encore disponibles.",
      "whatsAppNotConnected": "WhatsApp n’est pas encore connecté à cet établissement.",
      "whatsAppSettingUp": "WhatsApp est encore en cours de configuration. Cela prend généralement quelques minutes."
    },
    "inCallOverlay": {
      "activeCall": "Appel en cours",
      "expandActiveCall": "Agrandir l’appel en cours",
      "hangUp": "Raccrocher",
      "mute": "Couper le micro",
      "resume": "Reprendre",
      "speakerOff": "Haut-parleur désactivé",
      "speakerOn": "Haut-parleur activé",
      "unmute": "Réactiver le micro"
    },
    "incomingCallView": {
      "headerPhone": "Appel entrant · Téléphone",
      "headerWhatsApp": "Appel entrant · WhatsApp",
      "hintCheckingInToday": "Arrive aujourd’hui",
      "hintCheckingInTomorrow": "Arrive demain",
      "hintCheckingOutToday": "Part aujourd’hui",
      "hintCheckingOutTomorrow": "Part demain",
      "hintInDays": "{count, plural, one {Dans # jour} other {Dans # jours}}",
      "roomStatus": "Chambre {unit} · {status}",
      "roomStatusWithHint": "Chambre {unit} · {status} · {hint}",
      "unknownCaller": "Appelant inconnu"
    },
    "incomingStaffCallView": {
      "header": "Appel entrant · Interne",
      "internal": "Interne",
      "internalAtProperty": "Interne · {property}",
      "internalCall": "Appel interne"
    },
    "instagramWindowNotice": {
      "closed": "La fenêtre de réponse d’Instagram est fermée. Le voyageur doit vous écrire à nouveau avant que vous puissiez répondre.",
      "closesOn": "Instagram ferme cette conversation le {date}.",
      "neverMessaged": "Instagram n’autorise que les réponses. Le voyageur doit vous écrire en premier."
    },
    "linkReservationPicker": {
      "description": "Choisissez la réservation à lier à cette conversation. {name} rejoindra la liste des voyageurs de cette réservation.",
      "noReservations": "Aucune réservation à venir ou en cours à lier",
      "noSearchMatches": "Aucune réservation ne correspond à votre recherche",
      "searchPlaceholder": "Voyageur, référence ou logement…",
      "title": "Lier une réservation",
      "unnamedBooker": "Voyageur sans nom"
    },
    "loadEarlierMessages": {
      "label": "Charger les messages précédents"
    },
    "media": {
      "tooLarge": "Ce fichier est trop volumineux. Limite : {max}."
    },
    "mergeGuestPickerModal": {
      "descriptionNamed": "Fusionnez ce voyageur avec un autre profil. Choisissez le profil de destination : les informations de {name} y seront ajoutées.",
      "descriptionUnnamed": "Fusionnez ce voyageur avec un autre profil. Choisissez le profil de destination : les informations de ce voyageur y seront ajoutées.",
      "noOtherGuests": "Aucun autre voyageur à fusionner",
      "noSearchMatches": "Aucun voyageur ne correspond à votre recherche",
      "searchPlaceholder": "Rechercher par nom…",
      "suggestedByAi": "Suggéré par l’IA",
      "title": "Fusionner des voyageurs"
    },
    "messageAttachment": {
      "document": "Document",
      "photo": "Photo",
      "photoUnavailable": "Photo indisponible",
      "videoUnavailable": "Vidéo indisponible"
    },
    "messageContextMenu": {
      "dismissMenu": "Fermer le menu",
      "moreActions": "Plus d’actions",
      "react": "Réagir"
    },
    "messageReactionPicker": {
      "moreReactions": "Plus de réactions",
      "reactWith": "Réagir avec {emoji}"
    },
    "microphone": {
      "permissionMessage": "Pour passer et recevoir des appels, Vidimo a besoin d’accéder à votre micro. Touchez Réglages et activez Micro.",
      "permissionTitle": "Accès au micro requis",
      "settingsGuidance": "Ouvrez Paramètres > Applications > Vidimo et activez Micro."
    },
    "nativeListeners": {
      "errorCallFailed": "L’appel a échoué. Merci de réessayer."
    },
    "reactionPills": {
      "reaction": "{count, plural, one {Réaction {emoji}, {count}} other {Réaction {emoji}, {count}}}"
    },
    "recordingErrorBar": {
      "dismiss": "Fermer",
      "error": "Erreur",
      "retry": "Réessayer"
    },
    "sendAttachment": {
      "errorConnection": "Vérifiez votre connexion et réessayez.",
      "errorNotSent": "Impossible d’envoyer la pièce jointe",
      "refusal": {
        "outside_service_window": "WhatsApp n’autorise les pièces jointes que dans les 24 heures suivant le dernier message du voyageur. Envoyez-la par e-mail, ou envoyez un modèle pour rouvrir la conversation.",
        "outside_service_window_voice": "WhatsApp n’autorise les messages vocaux que dans les 24 heures suivant le dernier message du voyageur. Envoyez-le plutôt par e-mail.",
        "oversize": "{kind, select, image {Cette photo fait} video {Cette vidéo fait} voice {Ce message vocal fait} other {Ce fichier fait}} {size}. {transport, select, email {L’e-mail accepte {max}.} sms {Le MMS accepte {max}. Envoyez plutôt ce fichier par e-mail.} staff {Cette conversation accepte {max}.} whatsapp {WhatsApp accepte {max}. Envoyez plutôt ce fichier par e-mail.} other {Cette conversation accepte {max}. Envoyez plutôt ce fichier par e-mail.}}",
        "sms_no_media": "Les SMS ne peuvent pas contenir de pièces jointes. Passez cette conversation sur WhatsApp ou par e-mail.",
        "unsupported_channel": "Ce canal ne prend pas en charge les pièces jointes."
      },
      "rejectedTitle": "Envoi impossible ici",
      "rejectedType": "Impossible d’envoyer {type} dans une conversation.",
      "rejectedUnknownType": "Ce type de fichier ne peut pas être envoyé dans une conversation."
    },
    "staffChatDetails": {
      "groupChatFallbackName": "Conversation de groupe",
      "internal": "Interne",
      "manageMembers": "Gérez les membres dans les paramètres de l’établissement",
      "memberCount": "{count, plural, one {{count} membre} other {{count} membres}}",
      "noMembers": "Aucun membre dans cette conversation."
    },
    "staffChatDetailsPage": {
      "directMessageFallback": "Message privé",
      "errorNoMembership": "Impossible de retrouver votre adhésion à cet établissement",
      "errorNoSharedProperty": "Vous n’avez aucun établissement en commun avec cette personne",
      "errorNotSent": "Impossible d’envoyer votre message. Réessayez.",
      "errorNotStarted": "Impossible de démarrer cette conversation. Réessayez.",
      "errorSignedOut": "Connectez-vous pour envoyer des messages",
      "errorStillLoading": "Chargement en cours : réessayez dans un instant",
      "staffChatFallback": "Conversation d’équipe"
    },
    "staffChatListView": {
      "emptyDescription": "Lancez une conversation avec votre équipe",
      "emptyTitle": "Aucune conversation d’équipe"
    },
    "staffChatMessageBubble": {
      "attachmentPlaceholder": "Pièce jointe",
      "deleteMessage": "Supprimer le message",
      "deletedByOther": "Ce message a été supprimé",
      "deletedByYou": "Vous avez supprimé ce message",
      "retryTranscriptionFailed": "Impossible de relancer la transcription : merci de réessayer"
    },
    "staffChatView": {
      "cancel": "Annuler",
      "delete": "Supprimer",
      "deleteDialogDescription": "Il sera supprimé pour tous les participants. La conversation garde sa place dans le fil et indique qu’un message a été supprimé.",
      "deleteDialogTitle": "Supprimer ce message ?",
      "deleteFailed": "Impossible de supprimer le message",
      "replyPlaceholder": "Répondre à {name}…",
      "sendPlaceholder": "Envoyer un message…",
      "voiceNoteSendFailed": "Impossible d’envoyer le message vocal"
    },
    "staffDetails": {
      "activeTasks": "{count, plural, one {Tâche en cours ({count})} other {Tâches en cours ({count})}}",
      "call": "Appeler",
      "completedOn": "Terminée le {date}",
      "message": "Message",
      "noTasksAssigned": "Aucune tâche affectée",
      "recentlyCompleted": "Terminées récemment",
      "staffInformation": "Informations du membre"
    },
    "suggestionActions": {
      "arrivalUpdated": "Arrivée prévue mise à jour : {time}",
      "checkOutUpdated": "Départ mis à jour : {time}",
      "guestAdded": "{guestName} ajouté à la réservation",
      "guestAlreadyOnBooking": "{guestName} figurait déjà sur cette réservation ; sa conversation y est désormais liée",
      "missingLink": "Il manque à cette suggestion la conversation ou la réservation à lier.",
      "missingTimeChange": "Il manque à cette suggestion ce qu’il faut pour l’appliquer.",
      "noStayDate": "Cette réservation n’a pas de date sur laquelle placer l’heure.",
      "noTask": "Cette suggestion ne contient aucune tâche à créer.",
      "rateChangeMissing": "Cet avis ne précise plus la modification qu’il concernait.",
      "taskCreated": "Tâche créée : {title}"
    },
    "suggestionCard": {
      "accept": "Accepter",
      "dismiss": "Écarter",
      "dismissLabel": "Écarter : {title}"
    },
    "supportChatDetails": {
      "errorNotSent": "Impossible d’envoyer votre message. Réessayez."
    },
    "supportChatView": {
      "addPhoto": "Ajouter une photo",
      "dictate": "Dicter un message",
      "dictationFailed": "Nous n’avons pas entendu. Réessayez.",
      "dictationNeedsSubscription": "La dictée nécessite un abonnement actif. Vous pouvez toujours écrire.",
      "emptyDescription": "Dites-nous ce dont vous avez besoin, dans votre langue : par écrit, à voix haute ou avec une photo. Nous voyons depuis quel établissement et quel écran vous écrivez, inutile de l’expliquer.",
      "emptyTitle": "Écrire à l’équipe Vidimo",
      "photo": "Photo",
      "photoUnavailable": "Photo indisponible",
      "placeholder": "Écrire à l’équipe Vidimo…",
      "removePhoto": "Retirer la photo",
      "send": "Envoyer",
      "showOriginal": "Afficher l’original",
      "showTranslation": "Afficher la traduction",
      "stopDictating": "Arrêter la dictée",
      "supportSession": "En session d’assistance, répondez depuis le CRM.",
      "teamNameWithProperty": "Équipe Vidimo · {propertyName}",
      "transcribing": "Transcription…"
    },
    "supportReplyBanner": {
      "open": "Ouvrir"
    },
    "transcribe": {
      "failed": "Impossible de transcrire l’enregistrement. Merci de réessayer."
    },
    "transferPicker": {
      "empty": "Aucun autre membre de l’équipe de cet établissement vers qui transférer.",
      "title": "Transférer l’appel à"
    },
    "useGuestCall": {
      "errorAlreadyInCall": "Vous êtes déjà en communication",
      "errorNotStarted": "Impossible de lancer l’appel"
    },
    "useOpenChat": {
      "errorNoProperty": "Choisissez d’abord un établissement",
      "errorNoSharedProperty": "Vous n’avez aucun établissement en commun avec cette personne",
      "errorNotSwitched": "Impossible de passer à cet établissement",
      "errorSelf": "Vous ne pouvez pas vous écrire à vous-même",
      "errorStillLoading": "Chargement en cours : réessayez dans un instant",
      "switched": "Établissement changé",
      "switchedTo": "Vous êtes maintenant sur {name}"
    },
    "useShareAudienceGap": {
      "one": "{name} ne peut pas l’ouvrir",
      "people": "{count, plural, one {{count} personne ne peut pas l’ouvrir} other {{count} personnes ne peuvent pas l’ouvrir}}",
      "two": "{first} et {second} ne peuvent pas l’ouvrir"
    },
    "useVoiceRecording": {
      "micBlockedInBrowser": "L’accès au micro est bloqué. Autorisez-le dans les paramètres de votre navigateur et réessayez.",
      "micPermissionMessage": "Pour enregistrer un message vocal, Vidimo a besoin d’accéder à votre micro. Touchez Réglages et activez Micro.",
      "micUnavailable": "Impossible d’accéder au micro. Vérifiez les autorisations.",
      "transcriptionFailed": "Échec de la transcription",
      "transcriptionTimedOut": "La transcription a expiré. Vérifiez votre connexion et réessayez."
    },
    "voiceContext": {
      "errorNoActiveCall": "Aucun appel en cours à transférer",
      "errorNotHungUp": "Impossible de raccrocher. Réessayez.",
      "errorNotResumed": "Impossible de reprendre l’appel. Réessayez.",
      "errorNotSwitched": "Impossible de changer d’appel. Réessayez.",
      "errorNotTransferred": "Impossible de transférer l’appel. Réessayez.",
      "errorUnsupported": "Les appels ne sont disponibles que sur mobile"
    },
    "voiceNoteAttachment": {
      "noSpeech": "Aucune parole détectée",
      "pause": "Mettre en pause le message vocal",
      "play": "Lire le message vocal",
      "seek": "Avancer dans le message vocal",
      "transcribing": "Transcription…",
      "transcript": "Transcription",
      "transcriptUnavailable": "Transcription indisponible",
      "tryAgain": "Réessayer"
    }
  },

  "connect": {
    "connectScreen": {
      "contactSupport": "Contacter l’assistance",
      "returnToVidimo": "Revenir à Vidimo"
    },
    "instagramConnectResult": {
      "cancelled": {
        "detail": "La connexion a été annulée. Vous pouvez recommencer depuis Vidimo quand vous le souhaitez.",
        "title": "Instagram non connecté"
      },
      "connected": {
        "detail": "Votre fil et vos messages privés sont prêts. Revenez dans Vidimo pour continuer.",
        "title": "Instagram connecté"
      },
      "connectedElsewhere": {
        "detail": "Ce compte Instagram est déjà connecté à un autre établissement. Déconnectez-le d’abord là-bas, ou connectez un autre compte.",
        "title": "Déjà connecté ailleurs"
      },
      "expired": {
        "detail": "Ce lien de connexion n’est plus valide. Recommencez depuis l’application Vidimo.",
        "title": "Lien expiré"
      },
      "failed": {
        "detail": "Un problème est survenu lors de la connexion. Réessayez depuis l’application Vidimo.",
        "title": "Instagram non connecté"
      },
      "invalidLink": {
        "detail": "Il manque des informations dans ce lien de connexion. Recommencez depuis l’application Vidimo.",
        "title": "Lien invalide"
      },
      "subscriptionRequired": {
        "detail": "Un abonnement actif est nécessaire pour connecter un canal.",
        "title": "Abonnement requis"
      }
    },
    "whatsappConnect": {
      "expiredBody": "Par sécurité, ces liens de connexion ne sont valables que peu de temps, et celui-ci a expiré. Revenez dans Vidimo et recommencez depuis la carte WhatsApp, dans Messagerie. Aucun réglage de votre établissement n’a été modifié.",
      "expiredTitle": "Lien expiré",
      "failedBody": "Impossible de charger la configuration WhatsApp. Réessayez, ou recommencez depuis l’application Vidimo.",
      "failedTitle": "Une erreur est survenue",
      "loading": "Chargement…",
      "noNumberBody": "Revenez dans Vidimo, saisissez votre numéro sur la carte WhatsApp, dans Messagerie, puis relancez la connexion. Si la carte ne vous le demande pas, redémarrez d’abord Vidimo pour qu’il se mette à jour. Aucun réglage de votre établissement n’a été modifié.",
      "noNumberTitle": "Saisissez le numéro dans Vidimo",
      "openFromApp": "Cette page ne peut être ouverte que depuis l’application Vidimo.",
      "title": "Connecter WhatsApp",
      "tryAgain": "Réessayer",
      "unavailableBody": "La connexion WhatsApp n’est pas configurée dans cet environnement.",
      "unavailableTitle": "Non disponible ici"
    },
    "whatsappEmbeddedSignup": {
      "buttonContinue": "Continuer avec Facebook",
      "buttonFinishing": "Finalisation…",
      "buttonInPopup": "Continuez dans la fenêtre…",
      "buttonLoading": "Chargement…",
      "buttonTryAgain": "Réessayer",
      "cancelled": "L’inscription a été annulée. Vous pouvez recommencer quand vous le souhaitez.",
      "closeAnytime": "Vous pouvez fermer cette fenêtre à tout moment. Rien ne change dans votre établissement tant que la configuration WhatsApp n’est pas terminée.",
      "errorConnectFailed": "Impossible de terminer la connexion de WhatsApp. Rien n’a changé dans votre établissement. Réessayez.",
      "errorNoAccount": "Impossible de lire votre compte WhatsApp chez Meta. Merci de réessayer.",
      "errorUnconfirmed": "Impossible de confirmer que WhatsApp est connecté. Vérifiez dans Vidimo, sous Paramètres > Messagerie, avant de réessayer.",
      "expiredBody": "Ce lien de connexion a expiré avant la fin de l’inscription. Revenez dans Vidimo et recommencez depuis la carte WhatsApp, dans Messagerie. Aucun réglage de votre établissement n’a été modifié.",
      "introConnect": "Vous allez configurer la messagerie WhatsApp Business sur le <number>{phone}</number> pour <name>{property}</name>. L’inscription Meta prend quelques minutes et se déroule dans une fenêtre séparée.",
      "introReconnect": "La connexion WhatsApp de <name>{property}</name> sur le <number>{phone}</number> doit être confirmée à nouveau. L’inscription Meta prend quelques minutes et se déroule dans une fenêtre séparée.",
      "nextStepCheck": "WhatsApp vérifie votre numéro. Cela prend généralement quelques minutes.",
      "nextStepCode": "Si WhatsApp envoie un code à votre numéro par SMS ou par appel, saisissez-le sur la carte WhatsApp, dans Messagerie.",
      "nextStepsHeading": "La suite",
      "pendingBody": "WhatsApp configure le numéro de {property}.",
      "pendingTitle": "C’est fait, nous prenons le relais",
      "reload": "Recharger",
      "sdkUnavailableBody": "Si vous utilisez un bloqueur de contenu, désactivez-le pour cette page, puis rechargez-la. Rien n’a changé dans votre établissement.",
      "sdkUnavailableTitle": "L’inscription Meta ne s’est pas chargée",
      "stepConfirmCode": "Confirmez le code de vérification que Meta envoie à ce numéro. S’il arrive après la fermeture de cette page, saisissez-le dans l’application Vidimo.",
      "stepPickAccount": "Choisissez ou créez votre compte WhatsApp Business, puis indiquez ce même numéro. Vous le conservez, sans demande de portabilité.",
      "stepSignIn": "Connectez-vous avec le compte Facebook qui gère (ou gérera) votre entreprise.",
      "successBody": "Votre numéro WhatsApp Business est désormais lié à {property}.",
      "successTitle": "WhatsApp connecté",
      "thisProperty": "cet établissement",
      "titleReconnect": "Reconnecter WhatsApp"
    }
  },

  "labels": {
    "balanceDue": "{amount} à régler",
    "blockReason": {
      "maintenance": "Maintenance",
      "manual": "Fermé manuellement",
      "owner": "Séjour du propriétaire"
    },
    "blockReasonUnknown": "Fermé",
    "boardBasis": {
      "all_inclusive": "Tout compris",
      "bed_and_breakfast": "Logement et petit-déjeuner",
      "full_board": "Pension complète",
      "half_board": "Demi-pension",
      "room_only": "Logement seul"
    },
    "callStatus": {
      "connected": "Connecté",
      "connecting": "Connexion…",
      "onHold": "En attente",
      "reconnecting": "Reconnexion…",
      "ringing": "Sonnerie…"
    },
    "cancellationPolicyDescription": {
      "flexible": "Annulation gratuite jusqu’à 1 jour avant l’arrivée.",
      "moderate": "Annulation gratuite jusqu’à 5 jours avant l’arrivée.",
      "non_refundable": "Cette réservation n’est pas remboursable.",
      "strict": "Annulation gratuite jusqu’à 14 jours avant l’arrivée."
    },
    "cleaningKind": {
      "post-checkout": "Après départ",
      "pre-checkin-refresh": "Rafraîchissement avant arrivée",
      "turnover": "Rotation"
    },
    "drawerTitle": {
      "breakfast-service": "Petit-déjeuner",
      "guest": "Voyageur",
      "reservation-unit": "Réservation",
      "staff": "Membre de l’équipe",
      "staff-chat": "Participants",
      "task": "Tâche"
    },
    "guestIdentity": {
      "detail": {
        "authorityRejected": "L’autorité a rejeté les informations",
        "filedOtherYourself": "Vous avez fait l’autre déclaration vous-même",
        "noAutomaticFiling": "Vidimo ne se charge pas de cette déclaration",
        "otherFacility": "Déclaré sous un autre numéro RNO",
        "reconnectCredentials": "Reconnectez le compte de déclaration (identifiants à ressaisir)"
      },
      "status": {
        "actionNeeded": "Action requise",
        "fileManually": "À déclarer vous-même",
        "filedByYou": "Déclaré par vos soins",
        "filing": "Déclaration en cours",
        "idOnFile": "Pièce enregistrée",
        "noIdOnFile": "Aucune pièce enregistrée",
        "notCheckedIn": "Arrivée non enregistrée",
        "notFiledByVidimo": "Non déclaré par Vidimo",
        "notFiledYet": "Pas encore déclaré",
        "registered": "Déclaré",
        "rejected": "Rejeté",
        "reportCancelled": "Déclaration annulée",
        "submitted": "Transmis"
      }
    },
    "mealInclusion": {
      "complimentary": "Offert",
      "included": "Inclus dans le tarif"
    },
    "mealPlace": {
      "breakfast_area": "Salle du petit-déjeuner",
      "in_room": "En chambre",
      "takeaway_box": "Panier à emporter"
    },
    "regimeException": {
      "alloggiati-web": "Vidimo recueille au check-in en ligne les données de chaque voyageur pour Alloggiati Web ; leur transmission automatique est en cours de développement, et Vidimo ne peut pas encore établir ni transmettre vos statistiques ISTAT.",
      "declaration-meuble-de-tourisme": "Vidimo ne dépose pas votre déclaration de meublé de tourisme à votre place.",
      "eturizem": "Vidimo prépare vos déclarations eTurizem ; leur transmission automatique à l’AJPES est en cours de développement.",
      "evisitor": "Vidimo ne peut pas encore déclarer vos voyageurs dans eVisitor à votre place.",
      "imposta-di-soggiorno": "Vidimo ne calcule pas encore la taxe de séjour de votre Comune.",
      "istat-ross-1000": "Vidimo ne peut pas encore établir ni transmettre vos statistiques ISTAT à votre Région.",
      "ses-hospedajes": "Vidimo ne peut pas encore transmettre vos déclarations SES.Hospedajes à votre place.",
      "siba": "Vidimo ne peut pas encore transmettre vos bulletins SIBA à votre place."
    },
    "registrationCredentialField": {
      "alloggiati_web": {
        "idAppartamento": "ID de l’appartement",
        "password": "Mot de passe",
        "username": "Nom d’utilisateur",
        "wskey": "Clé du service web (WS Key)"
      },
      "eturizem": {
        "certificate": "Certificat numérique (.p12 / KDP)",
        "certificatePassword": "Mot de passe du certificat",
        "password": "Mot de passe du portail AJPES",
        "rno": "Numéro RNO",
        "username": "Nom d’utilisateur du portail AJPES"
      },
      "evisitor": {
        "password": "Mot de passe",
        "username": "Nom d’utilisateur"
      },
      "istat": {
        "password": "Mot de passe",
        "structureCode": "Code de la structure",
        "username": "Nom d’utilisateur"
      },
      "ses_hospedajes": {
        "clientCertificate": "Certificat client SSL",
        "clientCertificatePassword": "Mot de passe du certificat",
        "password": "Mot de passe",
        "username": "Nom d’utilisateur du service web"
      },
      "siba": {
        "accessKey": "Clé d’accès (Chave de Acesso)",
        "establishment": "Numéro d’établissement",
        "nipc": "Numéro fiscal (NIPC)"
      }
    },
    "registrationCredentialHelp": {
      "alloggiati_web": {
        "idAppartamento": "Uniquement si vous gérez plusieurs logements sous un même compte.",
        "username": "Délivré par votre Questura.",
        "wskey": "Générée dans Alloggiati Web. Chaque changement de mot de passe en exige une nouvelle, et une seule peut être générée par jour."
      },
      "eturizem": {
        "certificate": "Certificat numérique slovène qualifié, délivré à votre entreprise.",
        "certificatePassword": "Laissez vide si le certificat n’a pas de mot de passe.",
        "rno": "Le numéro d’identification que l’AJPES a attribué à cet hébergement dans le registre des établissements d’hébergement (RNO). Chiffres uniquement.",
        "username": "Le nom d’utilisateur (uporabniško ime) avec lequel vous vous connectez au portail AJPES, pas votre adresse e-mail. L’AJPES refuse une adresse e-mail ici. Il s’affiche en haut à droite du portail une fois connecté."
      },
      "evisitor": {
        "username": "Délivré par votre office de tourisme local."
      },
      "istat": {
        "structureCode": "Le code que votre région a attribué à cet établissement (par exemple B01205). Il identifie l’établissement dans chaque déclaration.",
        "username": "Délivré par l’office du tourisme de votre région, pas par l’ISTAT."
      },
      "ses_hospedajes": {
        "clientCertificate": "Uniquement si votre configuration auprès du Ministère exige un certificat client.",
        "clientCertificatePassword": "Laissez vide si le certificat n’a pas de mot de passe.",
        "username": "Le nom d’utilisateur du service web fourni par la Sede Electrónica. Il se termine par WS."
      },
      "siba": {
        "accessKey": "Envoyée par courrier ou par e-mail.",
        "establishment": "Attribué par l’UCFE lors de l’enregistrement du logement.",
        "nipc": "Numéro fiscal de l’unité d’hébergement."
      }
    },
    "registrationCredentialPlaceholder": {
      "ses_hospedajes": {
        "username": "ex. 1234567WS"
      }
    },
    "registrationField": {
      "arrivalDate": "Date d’arrivée",
      "birthCountry": "Pays de naissance",
      "birthPlace": "Lieu de naissance",
      "dateOfBirth": "Date de naissance",
      "departureDate": "Date de départ",
      "documentNumber": "Numéro du document",
      "documentType": "Type de document",
      "expiryDate": "Date d’expiration",
      "firstName": "Prénom",
      "issuingCountry": "Pays de délivrance",
      "lastName": "Nom",
      "nationality": "Nationalité",
      "personalNumber": "Numéro personnel / d’identité",
      "residenceAddress": "Adresse du domicile",
      "residenceCountry": "Pays de résidence",
      "sex": "Sexe",
      "stayPurpose": "Motif du séjour"
    },
    "registrationOption": {
      "documentType": {
        "id_card": "Carte d’identité",
        "other": "Autre",
        "passport": "Passeport"
      },
      "sex": {
        "F": "Femme",
        "M": "Homme"
      },
      "stayPurpose": {
        "business": "Affaires",
        "education": "Études",
        "family": "Famille",
        "medical": "Santé",
        "other": "Autre",
        "tourism": "Tourisme"
      }
    },
    "registrationSystem": {
      "alloggiati_web": {
        "authority": "Polizia di Stato (Questura locale)",
        "enrollmentSteps": {
          "enterCredentials": "Saisissez ci-dessous le nom d’utilisateur, le mot de passe et la WS Key.",
          "generateWsKey": "Connectez-vous et générez une clé de service web (WS Key). Chaque changement de mot de passe en exige une nouvelle, et une seule peut être générée par jour.",
          "requestAccount": "Demandez un compte Alloggiati Web à votre Questura. Vous recevez un nom d’utilisateur et un mot de passe."
        }
      },
      "eturizem": {
        "authority": "AJPES",
        "enrollmentSteps": {
          "checkAccess": "Vérifiez que ce compte a accès à eTurizem. L’AJPES l’accorde séparément : un compte du portail sans cet accès ne peut pas déclarer.",
          "enterCredentials": "Saisissez ce nom d’utilisateur et son mot de passe ci-dessous, importez le certificat, puis ajoutez le numéro RNO. Dans eTurizem, chaque fiche porte un numéro d’ordre (zaporedna številka prijave gosta) : Vidimo numérote les siennes à partir de {guestbookBase, number}. Le logiciel que vous utilisez aujourd’hui peut donc clôturer les séjours qu’il a déjà déclarés sans que l’un écrase les fiches de l’autre. Vidimo déclare les voyageurs qui arrivent à partir du jour où vous le connectez : dès ce jour, arrêtez l’envoi des nouvelles arrivées par votre ancien logiciel, sinon l’AJPES les enregistre deux fois.",
          "findUsername": "Retrouvez votre nom d’utilisateur du portail AJPES (uporabniško ime). C’est le nom choisi à la création du compte, pas votre adresse e-mail : l’AJPES refuse une adresse e-mail. Connectez-vous au portail AJPES : il s’affiche en haut à droite.",
          "obtainCertificate": "Procurez-vous un certificat numérique slovène qualifié (.p12 / KDP) délivré à votre entreprise.",
          "registerAccommodation": "Inscrivez votre hébergement au registre slovène des établissements d’hébergement (Register nastanitvenih obratov, RNO) auprès de l’AJPES. Le registre lui attribue un numéro d’identification : c’est votre numéro RNO."
        }
      },
      "evisitor": {
        "authority": "Office national croate du tourisme (office de tourisme local)",
        "enrollmentSteps": {
          "enterCredentials": "Saisissez-les ci-dessous.",
          "receiveCredentials": "Votre office de tourisme local vous délivre un nom d’utilisateur et un mot de passe eVisitor."
        }
      },
      "istat": {
        "authority": "Office régional des statistiques du tourisme (réseau ISTAT)",
        "enrollmentSteps": {
          "enterCredentials": "Saisissez le code de la structure, le nom d’utilisateur et le mot de passe.",
          "requestAccess": "Demandez au service tourisme de votre Région (Ufficio Turismo) un accès au service web. Il vous délivre le nom d’utilisateur et le mot de passe, et vous communique le code de la structure."
        }
      },
      "ses_hospedajes": {
        "authority": "Ministerio del Interior (Sede Electrónica)",
        "enrollmentSteps": {
          "enroll": "Inscrivez votre hébergement sur la Sede Electrónica et choisissez l’envoi par service web.",
          "obtainCertificate": "Si votre configuration l’exige, procurez-vous le certificat client SSL auprès du Ministère.",
          "receiveCredentials": "Vous recevez un nom d’utilisateur de service web (il se termine par WS) et un mot de passe."
        }
      },
      "siba": {
        "authority": "UCFE (Sistema de Segurança Interna)",
        "enrollmentSteps": {
          "enterCredentials": "Saisissez ci-dessous votre numéro fiscal, votre numéro d’établissement et votre clé d’accès.",
          "receiveAccessKey": "L’UCFE délivre la clé d’accès (Chave de Acesso) de cet établissement ; pour la remplacer, écrivez à siba@ssi.gov.pt.",
          "register": "Inscrivez votre unité d’hébergement auprès de l’UCFE comme utilisateur SIBA pour obtenir un numéro d’établissement."
        }
      }
    },
    "reservationSource": {
      "direct": "Direct",
      "other": "Autre"
    },
    "reservationStatus": {
      "cancelled": "Annulée",
      "checked_in": "En séjour",
      "checked_out": "Séjour terminé",
      "confirmed": "Confirmée",
      "declined": "Refusée",
      "no_show": "No-show",
      "requested": "Demandée"
    },
    "role": {
      "manager": "Gérant",
      "operator": "Agent de terrain",
      "owner": "Propriétaire",
      "receptionist": "Réceptionniste"
    },
    "roleDescription": {
      "manager": "S’occupe du quotidien. Peut administrer l’équipe, propriétaires exceptés.",
      "operator": "Personnel de terrain : ne voit que ses tâches et les réservations liées.",
      "owner": "Contrôle total : facturation, paramètres, suppression.",
      "receptionist": "S’occupe des voyageurs, des réservations et des tâches. Aucun droit d’administration."
    },
    "roomAmenity": {
      "10": "Peignoir",
      "105": "Plaques de cuisson",
      "107": "Téléphone",
      "11": "Articles de toilette offerts",
      "13": "Baignoire",
      "142": "Douche",
      "144": "Insonorisation",
      "146": "Table et chaises",
      "15": "Baignoire ou douche",
      "162": "Armoire / penderie",
      "166": "Climatisation réglable",
      "167": "Grille-pain",
      "18": "Télévision par câble",
      "19": "Machine à café / thé",
      "193": "Salle de bains commune",
      "2": "Climatisation",
      "210": "Télévision par satellite",
      "223": "Vue sur la montagne",
      "224": "Vue sur la mer",
      "228": "Chaussons",
      "245": "Piscine privée",
      "246": "Télévision à écran plat",
      "251": "Télévision",
      "259": "Films",
      "28": "Bureau",
      "3": "Réveil",
      "32": "Lave-vaisselle",
      "41": "Cheminée",
      "5": "Radio",
      "50": "Sèche-cheveux",
      "5017": "Balcon",
      "55": "Fer et planche à repasser",
      "59": "Cuisine",
      "61": "Coin cuisine",
      "68": "Micro-ondes",
      "69": "Minibar",
      "7": "Terrasse",
      "77": "Four",
      "85": "Salle de bains privative",
      "88": "Réfrigérateur",
      "92": "Coffre-fort"
    },
    "supportTeamName": "Équipe Vidimo",
    "taskAssignmentPreset": {
      "first_available": "Premier disponible",
      "specific_staff": "Une personne précise",
      "unassigned": "Ne pas affecter"
    },
    "taskFunction": {
      "check_in": "Arrivée",
      "check_out": "Départ",
      "cleaning": "Ménage",
      "concierge": "Conciergerie",
      "maintenance": "Maintenance"
    },
    "taskRuleTrigger": {
      "any": "Tous les ménages"
    },
    "taskStatus": {
      "cancelled": "Annulée",
      "completed": "Terminée",
      "in_progress": "En cours",
      "missed": "Manquée",
      "paused": "En pause",
      "pending": "À faire"
    },
    "transport": {
      "email": "E-mail",
      "phone": "Téléphone",
      "sms": "SMS"
    },
    "unitReadiness": {
      "clean": "Propre",
      "dirty": "Sale",
      "inspected": "Contrôlé",
      "out_of_order": "Hors service"
    },
    "unitType": {
      "apartment": "Appartement",
      "double": "Double",
      "family": "Familiale",
      "quadruple": "Quadruple",
      "single": "Simple",
      "studio": "Studio",
      "suite": "Suite",
      "triple": "Triple",
      "twin": "Lits jumeaux",
      "villa": "Villa"
    }
  },

  "meals": {
    "breakfastService": {
      "roomNotAssigned": "Chambre non attribuée"
    },
    "breakfastServiceBody": {
      "breakfastArea": "Salle du petit-déjeuner",
      "cancel": "Annuler",
      "complimentaryTag": "offert",
      "coverCount": "{count, plural, one {# couvert} other {# couverts}}",
      "done": "Terminé",
      "emptyBody": "Aucune personne présente cette nuit n’a de petit-déjeuner prévu le {date}.",
      "emptyTitle": "Pas de petit-déjeuner ce matin",
      "errorRoomNotUpdated": "Impossible de mettre à jour cette chambre. Réessayez.",
      "errorRoomsNotMoved": "Impossible de déplacer ces chambres. Réessayez.",
      "groupCount": "{count, plural, one {# chambre} other {# chambres}} · {covers}",
      "loading": "Chargement du petit-déjeuner",
      "movedTo": "{count, plural, one {# chambre} other {# chambres}} · {place, select, breakfast_area {salle du petit-déjeuner} in_room {en chambre} takeaway_box {panier à emporter} other {{place}}}",
      "roomsOnDate": "{count, plural, one {# chambre} other {# chambres}} · {date}",
      "rowLabel": "{room}, {covers}",
      "rowLabelServed": "{room}, {covers}, servi",
      "select": "Sélectionner",
      "selectedCount": "{count, plural, one {# sélectionnée} other {# sélectionnées}}",
      "serveInRoom": "Servir en chambre",
      "served": "Servi"
    },
    "breakfastSummaryRow": {
      "ariaLabel": "Petit-déjeuner, {covers, plural, one {# couvert} other {# couverts}} pour {rooms, plural, one {# chambre} other {# chambres}}",
      "inRoomCount": "{count, plural, one {# en chambre} other {# en chambre}}",
      "servedCount": "{count, plural, one {# servi} other {# servis}}",
      "title": "Petit-déjeuner · {count, plural, one {# chambre} other {# chambres}}"
    },
    "reservationBreakfastCard": {
      "chargeForMorning": "Facturer ce matin",
      "coversAt": "{count, plural, one {# couvert} other {# couverts}} · {place, select, breakfast_area {salle du petit-déjeuner} in_room {en chambre} takeaway_box {panier à emporter} other {{place}}}",
      "errorMorningNotUpdated": "Impossible de mettre à jour ce matin. Réessayez.",
      "givenBy": "Offert par {name}",
      "makeComplimentary": "Offrir",
      "makeComplimentaryHint": "Offrir : retiré de la note",
      "markNotTaken": "Marquer non pris",
      "markServed": "Marquer servi",
      "morningCount": "{count, plural, one {# matin} other {# matins}}",
      "notCharged": "Non facturé",
      "statusExpected": "Prévu",
      "statusNotTaken": "Non pris",
      "statusServed": "Servi",
      "title": "Petit-déjeuner",
      "unconfirmedCount": "{count, plural, one {# matin non confirmé} other {# matins non confirmés}}"
    }
  },

  "notifications": {
    "activityItem": {
      "acceptedBy": "Acceptée par {name}",
      "acceptedByStaff": "Acceptée par l’équipe",
      "dismissed": "Écartée"
    },
    "attention": {
      "activityFailed": "Nouvelle tentative automatique",
      "activityPending": "En file d’attente",
      "activitySubmitting": "Déclaration en cours",
      "severityAtRisk": "Échéance proche",
      "severityNeedsAction": "Action requise"
    },
    "filingAttentionSection": {
      "activityNotCheckedIn": "Arrivée non enregistrée : déclaration pas encore faite",
      "activityNotConfirmed": "Déclaration pas encore confirmée",
      "activitySubmitted": "Déclarée, en attente de confirmation par l’autorité",
      "checkIn": "Arrivée",
      "checkOut": "Départ",
      "deadlinePassed": "Échéance dépassée",
      "detailNoDeadline": "{activity}, et l’échéance légale de déclaration approche.",
      "detailWithDeadline": "{activity} · {relative}",
      "directionAtProperty": "{direction} · {property}",
      "title": "Déclaration des voyageurs"
    },
    "notificationMenu": {
      "activity": "Activité",
      "close": "Fermer les notifications",
      "emptyDescription": "Les actions suggérées et l’activité s’afficheront ici",
      "emptySearchDescription": "Essayez un autre terme",
      "errorApplyFailed": "Impossible d’appliquer cette suggestion. Elle n’est peut-être plus à jour.",
      "errorDismissFailed": "Impossible d’écarter cette suggestion. Réessayez.",
      "errorMissingMergeProfiles": "Il manque à cette suggestion les profils à fusionner.",
      "errorNotCleared": "Impossible d’effacer cette carte. Réessayez.",
      "errorNotClearedAfter": "{message}, mais impossible d’effacer cette carte. Réessayez.",
      "noActivity": "Aucune activité pour l’instant",
      "noPendingSuggestions": "Aucune suggestion en attente",
      "noResults": "Aucun résultat",
      "searchPlaceholder": "Rechercher dans les suggestions et l’activité…",
      "suggestedActions": "Actions suggérées",
      "title": "Notifications"
    },
    "notificationPrimer": {
      "decline": "Plus tard",
      "description": "Activez les notifications : Vidimo vous signalera les nouveaux messages des voyageurs et de l’équipe, les nouvelles réservations, les arrivées et les annulations, ainsi que les échéances de déclaration. Sans elles, vous ne l’apprendrez qu’à la prochaine ouverture de l’application.",
      "enable": "Activer les notifications",
      "title": "Sachez dès qu’un voyageur vous écrit"
    },
    "pushRegistration": {
      "androidChannelName": "Notifications"
    },
    "relativeDeadline": {
      "dueInDays": "{count, plural, one {échéance dans {count} j} other {échéance dans {count} j}}",
      "dueInHours": "{count, plural, one {échéance dans {count} h} other {échéance dans {count} h}}",
      "dueInMinutes": "{count, plural, one {échéance dans {count} min} other {échéance dans {count} min}}",
      "overdueByDays": "{count, plural, one {en retard de {count} j} other {en retard de {count} j}}",
      "overdueByHours": "{count, plural, one {en retard de {count} h} other {en retard de {count} h}}",
      "overdueByMinutes": "{count, plural, one {en retard de {count} min} other {en retard de {count} min}}"
    },
    "roomAttentionSection": {
      "assignRoom": "À attribuer",
      "noRoom": "Pas encore de chambre",
      "title": "Chambres non prêtes"
    },
    "statisticsAttentionSection": {
      "activityNotConfirmed": "Pas encore confirmée",
      "activitySubmitted": "Envoyée, en attente de confirmation par l’office",
      "title": "Déclarations statistiques"
    },
    "taxReturnAttentionSection": {
      "detail": "{amount} à payer au plus tard le {date}",
      "dueSoon": "Échéance proche",
      "overdue": "En retard",
      "title": "Taxe de séjour",
      "uncomputed": "{count, plural, one {# séjour non calculé} other {# séjours non calculés}}"
    },
    "timeOffProposalCard": {
      "confirm": "Confirmer",
      "dismiss": "Écarter",
      "errorMarkAway": "Impossible de marquer cette personne comme absente. Réessayez.",
      "markedAway": "{who} marqué absent",
      "markedAwayReleased": "{who} marqué absent · {count, plural, one {# tâche désaffectée} other {# tâches désaffectées}}",
      "markedAwayReleasedDescription": "Réaffectez-les depuis la colonne Non affectées des Tâches.",
      "review": "Examiner",
      "staffMemberFallback": "Membre de l’équipe",
      "viewSourceMessage": "Voir le message d’origine"
    }
  },

  "rates": {
    "controls": {
      "fewerLabel": "{label}, moins",
      "moreLabel": "{label}, plus"
    },
    "copy": {
      "board": {
        "noPrice": "Sans prix",
        "notKept": "Les nuits aussi lointaines ne sont pas conservées sur ce téléphone.",
        "pastMonth": "Les nuits aussi anciennes ne sont pas conservées sur ce téléphone.",
        "tapHint": "Touchez une nuit pour la modifier, ou une date pour modifier tous les types de logement.",
        "tapHintProperty": "Touchez une nuit pour la modifier, ou une date pour modifier tous les types de logement de {propertyName}."
      },
      "changeNights": {
        "bookedWhenClosing": "{count, plural, one {{count} de ces nuits a déjà des réservations. La fermeture ne bloque que les nouvelles réservations.} other {{count} de ces nuits ont déjà des réservations. La fermeture ne bloque que les nouvelles réservations.}}",
        "cancel": "Annuler",
        "chooseUnitType": "Choisissez au moins un type de logement.",
        "close": "Fermer",
        "fields": {
          "checkIn": "Arrivée",
          "checkOut": "Départ",
          "maximumStay": "Séjour maximum",
          "minimumStay": "Séjour minimum",
          "price": "Prix",
          "sale": "Vente"
        },
        "firstNight": "Première nuit",
        "firstThenLast": "Touchez la première nuit, puis la dernière",
        "lastNight": "Dernière nuit",
        "leaveAsIs": "Ne pas modifier",
        "minFromSeason": "Selon la saison",
        "nothingToSend": "Choisissez ce que vous voulez modifier.",
        "priceFor": "Prix à appliquer pour {unitTypeName}",
        "priceToSet": "Prix à appliquer",
        "priceUseSeasonOrBase": "Prix de saison ou de base",
        "saveLabel": "Enregistrer",
        "setAPrice": "Fixer un prix à la place",
        "tapForSpan": "Touchez une deuxième nuit pour une période.",
        "tapToWiden": "Touchez une deuxième nuit pour une période, ou une autre ligne pour l’ajouter.",
        "title": "Modifier les nuits",
        "toWord": "au",
        "useSeasonOrBaseInstead": "Utiliser plutôt le prix de saison ou de base",
        "was": "Avant : {reads}."
      },
      "changes": {
        "sendAgain": "Renvoyer",
        "showTheseNights": "Afficher ces nuits",
        "status": "Statut",
        "taskId": "Référence du canal",
        "title": "Modifications de tarifs",
        "undo": "Annuler cette modification",
        "whatChanged": "Ce qui a changé",
        "whatWasSent": "Ce qui a été envoyé",
        "who": {
          "automatic": "Automatique",
          "automaticAt": "Automatique, {time}",
          "bySupport": "Assistance Vidimo pour le compte de {actor}",
          "inTheApp": "{name}, {time}, dans l’application",
          "onBehalf": "{agent} (assistance Vidimo) pour le compte de {actor}",
          "unknown": "Inconnu"
        }
      },
      "delivery": {
        "awaitingFullSync": "Envoi avec la prochaine synchronisation complète",
        "notConnected": "Aucun site de réservation n’est connecté : la modification reste dans Vidimo",
        "notMapped": "Non envoyé : ce type de logement n’est pas relié à vos canaux",
        "notSent": "Non envoyé à vos canaux",
        "passedUnanswered": "Ces nuits sont passées sans confirmation de vos canaux",
        "sending": "Envoi à vos canaux",
        "sent": "Envoyé à vos canaux",
        "sentAt": "Envoyé à vos canaux à {time}",
        "unmapped": "{count, plural, one {{unitTypes} n’est pas relié à vos canaux, il n’a donc pas été envoyé.} other {{unitTypes} ne sont pas reliés à vos canaux, ils n’ont donc pas été envoyés.}}"
      },
      "discard": {
        "body": "Vous avez choisi des nuits ou saisi une valeur. Abandonner cette modification ?",
        "discard": "Abandonner",
        "forTapOn": "Commencer une modification sur {propertyName} ? Ce que vous avez saisi ici sera perdu.",
        "keep": "Continuer la modification"
      },
      "editor": {
        "closedOn": "{of, plural, one {Nuits fermées : {on} sur {of}} other {Nuits fermées : {on} sur {of}}}",
        "detailsKept": "Le détail d’une modification est conservé 90 jours.",
        "lastChanged": "Dernière modification par {who}, {when}.",
        "notAllowedOn": "{of, plural, one {Nuits non autorisées : {on} sur {of}} other {Nuits non autorisées : {on} sur {of}}}",
        "varies": "Variable"
      },
      "errors": {
        "belowLowest": "Le prix plancher pour {unitTypeName} est de {price}.",
        "conflict": "Ces nuits ont été modifiées sur un autre appareil depuis votre dernier affichage. Vérifiez-les, puis renvoyez.",
        "lowestNotAbove0": "Saisissez un prix plancher supérieur à 0.",
        "lowestOverBase": "Le prix plancher ne peut pas dépasser le tarif de base.",
        "offline": "Vous êtes hors ligne : rien n’a été enregistré. Enregistrez de nouveau une fois reconnecté.",
        "priceAbove0": "Saisissez un prix supérieur à 0.",
        "priceToType": "Saisissez le prix à appliquer.",
        "priceUnreadable": "Saisissez un prix comme {example, number}.",
        "pricedUnder": "{which, select, nights {{nights, plural, one {{nights} nuit de {unitTypeName} a un prix inférieur à {amount}. Augmentez-le d’abord, puis fixez le prix plancher.} other {{nights} nuits de {unitTypeName} ont un prix inférieur à {amount}. Augmentez-les d’abord, puis fixez le prix plancher.}}} seasons {{seasons, plural, one {{seasons} saison de {unitTypeName} a un prix inférieur à {amount}. Augmentez-le d’abord, puis fixez le prix plancher.} other {{seasons} saisons de {unitTypeName} ont un prix inférieur à {amount}. Augmentez-les d’abord, puis fixez le prix plancher.}}} other {{nights, plural, one {{nights} nuit} other {{nights} nuits}} et {seasons, plural, one {{seasons} saison} other {{seasons} saisons}} de {unitTypeName} ont un prix inférieur à {amount}. Augmentez-les d’abord, puis fixez le prix plancher.}}",
        "staysContradict": "Le séjour minimum dépasse le séjour maximum : aucun séjour ne peut commencer cette nuit."
      },
      "heldBack": {
        "basePrice": "Le prix de base est déjà de {price} : rien ne change pour {unitTypeName}.",
        "seasonMinimum": "Le minimum de la saison est déjà de {nights} : rien ne change.",
        "seasonPrice": "La saison {seasonName} donne déjà {price} : rien ne change pour {unitTypeName}.",
        "seasonPriceUnnamed": "Le prix de saison est déjà de {price} : rien ne change pour {unitTypeName}."
      },
      "hold": {
        "sendNow": "Envoyer maintenant",
        "waiting": "{changes, plural, one {{changes} modification part} other {{changes} modifications partent}} vers vos canaux dans {seconds, plural, one {{seconds} s} other {{seconds} s}}"
      },
      "night": {
        "allowed": "Autorisé",
        "checkIn": "Arrivée",
        "checkOut": "Départ",
        "closed": "Fermé",
        "fallBackToBase": "Utiliser le prix de base ({price})",
        "fallBackToSeason": "Utiliser la saison {name} ({price})",
        "maximumStay": "Séjour maximum",
        "minFromSeason": "{count, plural, one {{count} selon la saison} other {{count} selon la saison}}",
        "minimumStay": "Séjour minimum",
        "noLimit": "Sans limite",
        "noMinimum": "Sans minimum",
        "notAllowed": "Non autorisé",
        "notForSale": "Sans prix, donc fermé à la vente",
        "open": "Ouvert",
        "price": "Prix",
        "priceFromBase": "Prix de base",
        "priceFromBaseAt": "Prix de base ({price})",
        "priceFromSeason": "Saison {name}",
        "priceFromSeasonAt": "Saison {name} ({price})",
        "priceRange": "{low}–{high}",
        "priceSetForNight": "Fixé pour cette nuit",
        "priceSetForNights": "Fixé pour ces nuits",
        "sale": "Vente",
        "seeTheChange": "Voir la modification.",
        "unitsFree": "{total, plural, one {Logements libres : {free} sur {total}} other {Logements libres : {free} sur {total}}}"
      },
      "nights": "{count, plural, one {{count} nuit} other {{count} nuits}}",
      "planned": {
        "checkInAllowed": "{position, select, first {Arrivée autorisée} other {arrivée autorisée}}",
        "checkInNotAllowed": "{position, select, first {Arrivée non autorisée} other {arrivée non autorisée}}",
        "checkOutAllowed": "{position, select, first {Départ autorisé} other {départ autorisé}}",
        "checkOutNotAllowed": "{position, select, first {Départ non autorisé} other {départ non autorisé}}",
        "chooseNights": "Choisissez les nuits à modifier",
        "chooseSomething": "Choisissez ce que vous voulez modifier",
        "chooseUnitType": "Choisissez au moins un type de logement",
        "close": "{position, select, first {Fermer} other {fermer}}",
        "maxStay": "{position, select, first {{nights, plural, one {Fixer le séjour maximum à {nights} nuit} other {Fixer le séjour maximum à {nights} nuits}}} verb {{nights, plural, one {fixer le séjour maximum à {nights} nuit} other {fixer le séjour maximum à {nights} nuits}}} other {{nights, plural, one {séjour maximum à {nights} nuit} other {séjour maximum à {nights} nuits}}}}",
        "maxStayCleared": "{position, select, first {Pas de séjour maximum} other {pas de séjour maximum}}",
        "minStay": "{position, select, first {{nights, plural, one {Fixer le séjour minimum à {nights} nuit} other {Fixer le séjour minimum à {nights} nuits}}} verb {{nights, plural, one {fixer le séjour minimum à {nights} nuit} other {fixer le séjour minimum à {nights} nuits}}} other {{nights, plural, one {séjour minimum à {nights} nuit} other {séjour minimum à {nights} nuits}}}}",
        "minStayCleared": "{position, select, first {Séjour minimum selon la saison} other {séjour minimum selon la saison}}",
        "price": "{position, select, first {Fixer le prix à {price}} verb {fixer le prix à {price}} other {prix à {price}}}",
        "priceCleared": "{position, select, first {Utiliser le prix de saison ou de base} other {utiliser le prix de saison ou de base}}",
        "reopen": "{position, select, first {Rouvrir} other {rouvrir}}",
        "sentence": "{changes} pour {unitTypes}, {span} ({count, plural, one {{count} nuit} other {{count} nuits}})."
      },
      "sent": {
        "checkInAllowed": "arrivée autorisée",
        "checkInNotAllowed": "arrivée non autorisée",
        "checkOutAllowed": "départ autorisé",
        "checkOutNotAllowed": "départ non autorisé",
        "closed": "fermé",
        "maxStay": "{nights, plural, one {séjour max. {nights} nuit} other {séjour max. {nights} nuits}}",
        "maxStayCleared": "pas de séjour maximum",
        "minStay": "{nights, plural, one {séjour min. {nights} nuit} other {séjour min. {nights} nuits}}",
        "minStayCleared": "séjour min. selon la saison",
        "priceCleared": "retour au prix de saison ou de base",
        "reopened": "rouvert"
      },
      "summary": {
        "closedFor": "Fermé {span} pour {unitTypes}",
        "line": "{unitTypes} : {fields}, {span}",
        "lineNights": "{unitTypes} : {fields}, {span} ({count, plural, one {{count} nuit} other {{count} nuits}})",
        "reopenedFor": "Rouvert {span} pour {unitTypes}",
        "undone": "Annulé : {body}",
        "unitTypesHeadline": "{types, plural, one {{types} type de logement, {span}} other {{types} types de logement, {span}}}",
        "unitsFreeHeadline": "Disponibilités envoyées",
        "unitsFreeLine": "{free, plural, one {{unitType} {free}, {span}} other {{unitType} {free}, {span}}}",
        "unitsFreeSent": "Disponibilités envoyées : {lines}. {trigger, select, nightly_refresh {Actualisation nocturne.} other {Après une réservation ou un blocage.}}"
      },
      "toast": {
        "nothingConnected": "Aucun site de réservation n’est connecté : cela modifie vos tarifs dans Vidimo uniquement.",
        "saved": "Enregistré",
        "undo": "Annuler",
        "undone": "Annulé",
        "waiting": "Votre dernière modification est encore en cours d’enregistrement. Réessayez dans un instant."
      },
      "viewMenu": {
        "rates": "Tarifs",
        "staff": "Équipe",
        "units": "Logements"
      },
      "words": {
        "and": "{head} et {last}",
        "sentences": "{head}. {next}",
        "series": "{head}, {next}"
      }
    },
    "rateChangeDetailPage": {
      "awaitingFullSync": "{what} : vos canaux ne les ont pas encore confirmés ; ils seront transmis lors de la prochaine synchronisation complète.",
      "changedLine": "{unitType}, {span} ({count}) : {changes}",
      "copied": "Copié",
      "copy": "Copier",
      "copyFailed": "Copie impossible",
      "fieldCheckIn": "arrivée",
      "fieldCheckOut": "départ",
      "fieldMaxStay": "séjour maximum",
      "fieldMinStayArrival": "séjour minimum à l’arrivée",
      "fieldMinStayThrough": "séjour minimum (toutes nuits)",
      "fieldPrice": "prix",
      "fieldSale": "vente",
      "fieldUnitsFree": "logements libres",
      "loading": "Chargement…",
      "noValueChanged": "Aucune valeur modifiée",
      "notFound": "Modification introuvable.",
      "notSent": "{what} : vos canaux ne les ont pas acceptés.",
      "notSentBecauseConnection": "Vidimo n’avait plus accès à cet établissement sur vos canaux.",
      "notSentBecauseValues": "Vérifiez ces valeurs, puis renvoyez-les.",
      "passedUnanswered": "{what} : vos canaux ne les ont pas confirmés avant que ces nuits ne soient passées.",
      "pushedLine": "{unitType} {span} : {fields}",
      "saved": "Enregistré {time}.",
      "sending": "{what} : envoi en cours.",
      "sent": "{what}, envoyés à vos canaux",
      "sentAt": "{what}, envoyés à vos canaux à {time}",
      "taskIdAwaiting": "{taskId} : disponible après l’envoi",
      "wasNow": "{field} : {before}, désormais {after}",
      "whatRates": "Tarifs et règles",
      "whatUnitsFree": "Logements libres"
    },
    "ratesBoard": {
      "cellLabel": "{rowName}, {day} : {price}",
      "cellLabelClosed": "{rowName}, {day} : {price}, fermé",
      "dateTapLabel": "Tous les types de logement le {day}",
      "dateTapPropertyLabel": "Tous les types de logement de {propertyName} le {day}",
      "units": "{count, plural, one {# logement} other {# logements}}"
    },
    "ratesView": {
      "emptyDescription": "Ajoutez des logements à cet établissement avant de fixer des prix.",
      "emptyTitle": "Aucun logement pour l’instant",
      "nextMonth": "Mois suivant",
      "previousMonth": "Mois précédent",
      "thisMonth": "Ce mois-ci"
    }
  },

  "reservations": {
    "assignUnitSelect": {
      "checking": "Recherche des logements libres…",
      "errorNotAssigned": "Impossible d’attribuer ce logement. Réessayez.",
      "errorUnitTaken": "Un autre séjour occupe déjà ce logement certaines de ces nuits. Choisissez un autre logement.",
      "noneFree": "Aucun logement libre sur tout le séjour",
      "placeholder": "Attribuer un logement"
    },
    "cancelReservationAction": {
      "cancelAction": "Annuler la réservation",
      "cancelAndRelease": "Annuler et libérer l’empreinte",
      "cancelBody": "La réservation de {guestName} est annulée et le logement est libéré pour ces nuits.",
      "cancelHoldNote": "L’empreinte de {amount} sur la carte de {guestName} est libérée immédiatement. C’est irréversible : pour facturer des dégâts ou des frais d’annulation tardive, encaissez d’abord l’empreinte depuis la note du séjour.",
      "cancelTitle": "Annuler cette réservation ?",
      "cancelToast": "Réservation annulée",
      "cancelToastReleased": "Réservation annulée · empreinte libérée",
      "checkingHold": "{guestName} : vérification d’une éventuelle empreinte sur sa carte…",
      "declineAction": "Refuser la demande",
      "declineAndRelease": "Refuser et libérer l’empreinte",
      "declineBody": "La demande de {guestName} est refusée et le logement reste libre pour ces nuits.",
      "declineHoldNote": "L’empreinte de {amount} sur la carte de {guestName} est libérée immédiatement. C’est irréversible.",
      "declineTitle": "Refuser cette demande ?",
      "declineToast": "Demande refusée",
      "declineToastReleased": "Demande refusée · empreinte libérée",
      "errorCancel": "Impossible d’annuler la réservation. Réessayez.",
      "errorDecline": "Impossible de refuser la demande. Réessayez.",
      "errorUndoCancel": "Impossible de revenir en arrière. La réservation reste annulée.",
      "errorUndoDecline": "Impossible de revenir en arrière. La demande reste refusée.",
      "keepIt": "La garder",
      "undo": "Annuler"
    },
    "checkInInviteCard": {
      "deliveryBounced": "Rejeté : l’adresse ne l’a pas accepté",
      "deliveryComplained": "Signalé comme spam par le destinataire",
      "deliveryDelivered": "Distribué",
      "deliverySent": "Envoyé, en attente de confirmation",
      "deliverySuppressed": "Non tenté : l’adresse figure sur une liste d’exclusion",
      "errorNotSent": "Impossible d’envoyer l’invitation",
      "errorPreview": "Impossible de charger l’aperçu",
      "noInvitation": "Aucune invitation pour cette réservation",
      "notSentYet": "Aucune invitation n’a encore été envoyée pour cette réservation.",
      "previewEmail": "Aperçu de l’e-mail",
      "sendAgain": "Renvoyer",
      "sendInvitation": "Envoyer l’invitation",
      "sentTo": "Envoyée à {email} le {date}{count, plural, =0 {} =1 {} one {} other { ({count} fois)}}.",
      "sentToast": "Invitation à l’enregistrement envoyée à {email}",
      "title": "Invitation à l’enregistrement",
      "unavailableNoDates": "Ajoutez d’abord les dates d’arrivée et de départ.",
      "unavailableNoEmail": "Cette réservation ne comporte pas d’adresse e-mail.",
      "unavailableNotActive": "Cette réservation est annulée : il n’y a rien à envoyer.",
      "unavailableNotFound": "Réservation introuvable."
    },
    "checkInLinkCard": {
      "copied": "Copié",
      "copy": "Copier",
      "description": "Envoyez-le à votre voyageur : son enregistrement s’ouvre sans aucune connexion. L’aperçu vous montre ce qu’il voit.",
      "errorCreate": "Impossible de créer le lien d’enregistrement",
      "errorNotCopied": "Impossible de copier le lien",
      "noLink": "Aucun lien pour cette réservation",
      "preview": "Aperçu",
      "title": "Lien d’enregistrement en ligne",
      "toastCopied": "Lien copié",
      "unavailableNoDates": "Ajoutez d’abord les dates d’arrivée et de départ.",
      "unavailableNotActive": "Cette réservation est annulée : il n’y a pas d’enregistrement possible.",
      "unavailableNotFound": "Réservation introuvable."
    },
    "checkInsSection": {
      "checkInLaterArrival": "Enregistrer une autre arrivée",
      "guests": "{count, plural, one {# voyageur} other {# voyageurs}}",
      "title": "Arrivées"
    },
    "checkInView": {
      "arrived": "Arrivés ensemble",
      "back": "Retour",
      "checkedInAt": "Arrivée enregistrée le {when}",
      "checkedInAtBy": "Arrivée enregistrée le {when} par {name}",
      "checkIn": "Enregistrer l’arrivée",
      "checkInAndSend": "Enregistrer et envoyer à {register}",
      "checkInMore": "Enregistrer d’autres voyageurs",
      "done": "Terminé",
      "errorAdultsUnknown": "Indiquez le nombre d’adultes de la réservation avant d’enregistrer l’arrivée.",
      "errorBookingChanged": "Cette réservation a été modifiée sur un autre appareil. Vérifiez à nouveau qui est là, puis envoyez.",
      "errorIdMissing": "{names} : aucune pièce d’identité enregistrée pour ce séjour. Scannez la pièce, puis renvoyez.",
      "errorNotActive": "Cette réservation n’accepte plus d’enregistrement d’arrivée.",
      "errorNotSent": "L’arrivée n’a pas été envoyée. Réessayez.",
      "errorNotWaiting": "{names} : arrivée déjà enregistrée, ou ne figure plus sur la réservation. Vérifiez la liste et renvoyez.",
      "errorTooEarly": "Il est trop tôt : vous pourrez enregistrer l’arrivée de ces voyageurs à partir du jour d’arrivée de la réservation.",
      "everyoneCheckedIn": "L’arrivée de tous les voyageurs de cette réservation est enregistrée. Scannez ou saisissez la pièce de toute autre personne présente.",
      "idMissing": "{count, plural, one {Aucune pièce d’identité n’est encore enregistrée pour {names}.} other {Aucune pièce d’identité n’est encore enregistrée pour {names}.}}",
      "missing": "Cet enregistrement d’arrivée n’est pas sur cet appareil.",
      "needsConnection": "Une connexion est nécessaire pour envoyer un enregistrement d’arrivée.",
      "nobodyLinked": "Aucun voyageur n’est encore rattaché à cette réservation. Scannez ou saisissez la pièce de chaque voyageur présent, ou enregistrez simplement l’arrivée de la réservation.",
      "recordTitle": "Arrivée",
      "scanId": "Scanner une pièce",
      "stillSyncing": "Cet enregistrement d’arrivée a été envoyé mais n’est pas encore synchronisé sur cet appareil. Il s’affichera ici dès que ce sera fait.",
      "title": "Enregistrer l’arrivée",
      "typeId": "Saisir à la main",
      "whoIsHere": "Qui est là"
    },
    "collectPaymentSheet": {
      "amountLabel": "Montant ({currency})",
      "channelWarning": "Cette réservation vient d’un canal qui encaisse généralement le prix du séjour. Le facturer à nouveau ferait payer le voyageur deux fois : n’encaissez que les extras.",
      "copied": "Copié",
      "copy": "Copier",
      "createLink": "Créer un lien de paiement",
      "creating": "Création…",
      "errorCopy": "Copie impossible : sélectionnez le lien et copiez-le manuellement.",
      "errorCreateLink": "Impossible de créer le lien. Réessayez.",
      "errorNoAmount": "Saisissez un montant à encaisser.",
      "holdNotice": "Le montant est bloqué sur la carte du voyageur : l’argent reste le sien et rien n’est débité tant que vous ne l’encaissez pas. Vidimo maintient l’empreinte jusqu’au départ du voyageur et vous prévient si ce n’est pas possible.",
      "linkCopied": "Lien de paiement copié",
      "pendingUntilPaid": "La ligne apparaît en attente sur la note jusqu’à ce que le voyageur ait payé.",
      "presetBalance": "Solde total",
      "presetDeposit": "Acompte de 30 %",
      "presetTouristTax": "Taxe de séjour",
      "sendHoldLink": "Envoyez-le au voyageur. Il crée une empreinte sur sa carte : l’argent reste le sien jusqu’à ce que vous l’encaissiez.",
      "sendLink": "Envoyez-le au voyageur. La note se met à jour dès qu’il paie.",
      "title": "Encaisser un paiement"
    },
    "confirmMoneyAction": {
      "cancel": "Annuler",
      "working": "En cours…"
    },
    "editGuestForm": {
      "avatarAlt": "Voyageur",
      "backToGuests": "Retour aux voyageurs",
      "emailLabel": "E-mail",
      "emailPlaceholder": "voyageur@exemple.fr (obligatoire sans nom ni téléphone)",
      "errorNotSaved": "Impossible d’enregistrer le voyageur. Réessayez.",
      "firstNameLabel": "Prénom",
      "firstNamePlaceholder": "Prénom (facultatif avec téléphone ou e-mail)",
      "lastNameLabel": "Nom",
      "lastNamePlaceholder": "Nom (facultatif avec téléphone ou e-mail)",
      "nationalityLabel": "Nationalité",
      "nationalityPlaceholder": "Choisir une nationalité",
      "notFound": "Voyageur introuvable",
      "phoneLabel": "Téléphone",
      "phonePlaceholder": "(obligatoire sans nom)",
      "saved": "Informations du voyageur enregistrées.",
      "title": "Modifier le voyageur"
    },
    "editReservationForm": {
      "accessibilityLabel": "Accessibilité",
      "accessibilityPlaceholder": "ex. rez-de-chaussée de préférence, accès fauteuil roulant",
      "adultsLabel": "Adultes",
      "arrivalTimeLabel": "Heure d’arrivée prévue",
      "backToCalendar": "Retour au calendrier",
      "beforeCreating": "Avant de créer",
      "beforeSaving": "Avant d’enregistrer",
      "boardLabel": "Formule",
      "boardPlaceholder": "Non renseignée",
      "channelCancelledNote": "Annulée sur {source} : seul le canal peut la rétablir",
      "channelDatesNote": "Les dates sont gérées par {source} : modifiez-les là-bas et elles se synchroniseront ici",
      "channelManagedNote": "Synchronisée depuis {source}. Les dates du séjour et les annulations se gèrent sur le canal et se synchronisent automatiquement ; les informations du voyageur, les notes et le logement restent modifiables ici.",
      "checkInTimeLabel": "Heure d’arrivée",
      "checkOutTimeLabel": "Heure de départ",
      "checkingAvailability": "Vérification des disponibilités…",
      "childrenLabel": "Enfants",
      "create": "Créer",
      "datesLabel": "Arrivée – Départ",
      "dietaryLabel": "Régime alimentaire",
      "dietaryPlaceholder": "ex. panier d’accueil végétarien, allergie aux fruits à coque",
      "emailLabel": "E-mail",
      "emailPlaceholder": "marie@exemple.fr",
      "errorAdultsRequired": "Indiquez le nombre d’adultes pour enregistrer l’arrivée d’un voyageur",
      "errorCheckInDateRequired": "La date d’arrivée est obligatoire",
      "errorCheckInTimeInvalid": "L’heure d’arrivée doit être une heure comme 13:00",
      "errorCheckOutBeforeCheckIn": "Le départ doit être postérieur à l’arrivée",
      "errorCheckOutDateRequired": "La date de départ est obligatoire",
      "errorCheckOutTimeRequired": "L’heure de départ est obligatoire",
      "errorFirstNameRequired": "Le prénom du voyageur est obligatoire",
      "errorNotCreated": "Impossible de créer cette réservation. Vos informations sont toujours là : réessayez.",
      "errorNotSaved": "Impossible d’enregistrer cette réservation. Vos modifications sont toujours là : réessayez.",
      "errorPropertyRequired": "L’établissement est obligatoire",
      "errorRoomRequired": "Choisissez une chambre pour cette réservation",
      "firstNameLabel": "Prénom",
      "firstNamePlaceholder": "Marie",
      "groupBookingNote": "Cette réservation porte sur plusieurs logements ; le changement de logement n’est pas encore possible ici",
      "guestHeading": "Voyageur",
      "hasPetsLabel": "Voyage avec un animal",
      "infantsLabel": "Bébés",
      "lastNameLabel": "Nom",
      "lastNamePlaceholder": "Dupont",
      "notFound": "Réservation introuvable",
      "petNotesLabel": "Notes sur l’animal",
      "petNotesPlaceholder": "ex. 1 petit chien (Filou)",
      "phoneLabel": "Téléphone",
      "propertyLabel": "Établissement",
      "propertyLocked": "L’établissement ne peut plus être modifié une fois la réservation créée",
      "propertyPlaceholder": "Choisir un établissement",
      "save": "Enregistrer",
      "statusLabel": "Statut",
      "stayDetailsHeading": "Détails du séjour",
      "titleEdit": "Modifier la réservation",
      "titleNew": "Nouvelle réservation",
      "toastCreated": "Réservation créée.",
      "toastSaved": "Réservation enregistrée.",
      "unitConflict": "Ce logement est déjà réservé du {checkIn} au {checkOut}. Modifiez les dates ou choisissez un autre logement.",
      "unitConflictBy": "Ce logement est déjà réservé par {name} du {checkIn} au {checkOut}. Modifiez les dates ou choisissez un autre logement.",
      "unitConflictByWithRef": "Ce logement est déjà réservé par {name} du {checkIn} au {checkOut} (réf. {reference}). Modifiez les dates ou choisissez un autre logement.",
      "unitConflictWithRef": "Ce logement est déjà réservé du {checkIn} au {checkOut} (réf. {reference}). Modifiez les dates ou choisissez un autre logement.",
      "unitLabel": "Logement",
      "unitPlaceholder": "Choisir une chambre",
      "unitsFree": "{free, plural, one {{free} libre sur {total}} other {{free} libres sur {total}}}"
    },
    "guestRegistrationStatus": {
      "authorityQuote": "« {reason} »",
      "authorityQuoteAt": "– {when}",
      "cancelAction": "Annuler cette déclaration",
      "cancelConfirm": "Annuler la déclaration",
      "cancelHint": "Uniquement si ce voyageur ne séjourne pas ici : absence (no-show) ou déclaration faite pour le mauvais établissement. C’est définitif.",
      "cancelKeep": "Conserver la déclaration",
      "cancelTitle": "Annuler cette déclaration auprès de {authority} ?",
      "cancelledToast": "Déclaration annulée auprès de {authority}.",
      "cancelledWith": "Déclaration annulée auprès de {authority}",
      "cancelledWithOn": "Déclaration annulée auprès de {authority} le {when}",
      "errorCancel": "Impossible d’annuler la déclaration. Réessayez.",
      "errorCancelRefused": "La déclaration n’a pas été annulée.",
      "errorDownloadReceipt": "Impossible de télécharger le récépissé. Réessayez.",
      "errorMarkFiled": "Impossible de marquer la déclaration. Réessayez.",
      "errorRetry": "Impossible de relancer la déclaration. Réessayez.",
      "errorRetryFailedAgain": "La déclaration a de nouveau échoué.",
      "fixAndRefile": "Corriger et redéclarer",
      "headlineAuthRefused": "{authority} a refusé les identifiants de cet établissement",
      "headlineAuthUnused": "Les identifiants {authority} de cet établissement n’ont pas pu être utilisés",
      "headlineFiledByHost": "Vous avez fait vous-même l’autre déclaration de ce voyageur auprès de {authority}",
      "headlineIncomplete": "{authority} n’a pas pu finaliser cette déclaration",
      "headlineMissingData": "{authority} demande des informations absentes de cette déclaration",
      "headlineNoConnector": "Vidimo ne se charge pas de cette déclaration auprès de {authority}",
      "headlineNotReached": "Cette déclaration n’est pas parvenue à {authority}",
      "headlineOtherFacility": "{authority} a enregistré ce voyageur sous un autre numéro RNO",
      "headlineUnattributed": "{authority} a peut-être déjà reçu cette déclaration",
      "headlineValidation": "{authority} a rejeté cette déclaration",
      "lastTried": "Dernière tentative {when}",
      "legalDeadline": "Échéance légale · {deadline}",
      "markFiledAction": "Marquer comme faite manuellement",
      "markFiledConfirm": "Marquer comme faite",
      "markFiledDescription": "Uniquement si ce voyageur est déjà déclaré auprès de {authority} : vous l’avez déclaré vous-même, ou vous l’avez trouvé sur le portail. Vidimo ne transmettra plus cette déclaration.",
      "markFiledNotYet": "Pas encore",
      "markFiledTitle": "Marquer cette déclaration comme faite ?",
      "markedFiledToast": "Déclaration marquée comme faite.",
      "nextStepAuth": "Reconnectez le compte de l’établissement (identifiants à ressaisir), puis réessayez.",
      "nextStepFiledByHost": "Faites aussi celle-ci vous-même avant l’échéance, puis marquez-la comme faite ici.",
      "nextStepMissingData": "Complétez les informations manquantes, puis enregistrez pour redéclarer.",
      "nextStepNoConnector": "Déclarez vous-même ce voyageur auprès de l’autorité avant l’échéance, puis marquez la déclaration comme faite ici.",
      "nextStepOtherFacility": "Si le voyageur a bien séjourné dans l’hébergement auquel ce numéro RNO est attribué, terminez sa fiche sous ce numéro sur le portail de l’autorité. Sinon, annulez-la et déclarez le voyageur sous le numéro actuel. Marquez ensuite la déclaration comme faite ici. Si le numéro RNO de cet établissement a été modifié par erreur, rétablissez-le, puis réessayez.",
      "nextStepTransient": "Nouvelle tentative automatique.",
      "nextStepUnattributed": "Nous avons transmis la déclaration de ce voyageur, sans pouvoir confirmer que l’autorité l’a enregistrée. Vérifiez sur son portail : si ce voyageur y figure, touchez « Marquer comme faite manuellement » ; sinon, touchez « Réessayer ».",
      "nextStepValidation": "Corrigez les informations ci-dessous et enregistrez : Vidimo renverra la déclaration.",
      "notFiledByVidimoBody": "Vidimo n’a fait aucune déclaration pour ce voyageur et ce séjour. Si vous l’avez déclaré vous-même, sa déclaration se trouve sur le portail de l’autorité.",
      "notFiledYetBody": "Rien n’a encore été envoyé pour ce séjour.",
      "openPortal": "Ouvrir {authority}",
      "receipt": "Récépissé",
      "receiptCheckInAria": "Télécharger le récépissé de la déclaration d’arrivée",
      "receiptCheckOutAria": "Télécharger le récépissé de la déclaration de départ",
      "reconnectCredentials": "Reconnecter le compte",
      "reportAccepted": "Acceptée le {when}",
      "reportAfterCheckIn": "Sera envoyée dès l’enregistrement de l’arrivée du voyageur",
      "reportCancelledOn": "Annulée le {when}",
      "reportCheckIn": "Déclaration d’arrivée",
      "reportCheckOut": "Déclaration de départ",
      "reportEntryAria": "Déclaration à {authority} pour {name} : {status}",
      "reportFiledByYou": "Déclarée par vos soins",
      "reportNeedsYou": "Intervention requise",
      "reportScheduled": "Prévue le {when}",
      "reportSending": "Envoi en cours",
      "reportSent": "Envoyée le {when}, en attente de confirmation",
      "reportTo": "Déclaration à {authority}",
      "retry": "Réessayer",
      "retrySubmittedToast": "Déclaration transmise.",
      "withdrawDescription": "{authority} marquera la fiche comme annulée : ce voyageur ne sera plus déclaré comme séjournant ici. À utiliser lorsqu’il ne séjourne pas ici : absence (no-show) ou séjour déclaré pour le mauvais établissement. Ce retrait est définitif depuis Vidimo, et Vidimo ne déclarera plus ce voyageur ensuite.",
      "withdrawnBody": "La fiche reste dans le registre de l’autorité, marquée comme annulée. Ce voyageur n’est pas déclaré comme séjournant ici."
    },
    "mergeConfirmView": {
      "cancel": "Annuler",
      "confirm": "Confirmer la fusion",
      "description": "Les informations de {source} seront ajoutées au profil de {target}.",
      "source": "Source",
      "target": "Cible",
      "title": "Confirmer la fusion"
    },
    "registrationScreen": {
      "correctDetails": "Corriger les informations",
      "idDocument": "Pièce d’identité",
      "noIdOnFile": "Aucune pièce d’identité enregistrée pour l’instant.",
      "scanAgain": "Scanner à nouveau le document",
      "scanId": "Scanner une pièce",
      "stayLine": "{property} · {dates}",
      "title": "Fiche du voyageur",
      "typeId": "Saisir à la main"
    },
    "reservationFolioCard": {
      "add": "Ajouter",
      "addCharge": "Ajouter une prestation",
      "addChargeTitle": "Ajouter une prestation",
      "amountPlaceholder": "Montant ({currency})",
      "balanceDue": "Reste à payer",
      "breakfastControlLabel": "Le petit-déjeuner se règle sur les matins du séjour : aller à Petit-déjeuner",
      "breakfastControlTitle": "Se règle sur les matins du séjour, dans Petit-déjeuner",
      "cancel": "Annuler",
      "capture": "Encaisser",
      "captureConfirm": "Encaisser {amount}",
      "captureDescription": "{amount} passe de la carte du voyageur à votre compte Stripe. C’est la totalité de l’empreinte : vous pourrez la rembourser ensuite, mais pas encaisser le reste plus tard.",
      "captureTitle": "Encaisser cette empreinte ?",
      "chargeKind": "Type de prestation",
      "chipFailed": "échoué",
      "chipHoldExpired": "empreinte expirée",
      "chipOnHold": "empreinte",
      "chipPending": "en attente",
      "chipRefunded": "remboursé",
      "chipReleased": "libérée",
      "collectPayment": "Encaisser un paiement",
      "collectedByChannelName": "Encaissé par {channel}",
      "complimentary": "Offert",
      "descriptionPlaceholder": "Description",
      "errorChargeNotAdded": "Impossible d’ajouter la prestation. Réessayez.",
      "errorChargeRemoveRolledBack": "Impossible de supprimer la prestation. Elle est de retour sur la note.",
      "errorEnterAmount": "Saisissez un montant",
      "errorMoneyActionFailed": "L’opération n’a pas abouti. Réessayez.",
      "errorPaymentNotRecorded": "Impossible d’enregistrer le paiement. Réessayez.",
      "errorPaymentRemoveRolledBack": "Impossible de supprimer le paiement. Il est de retour sur la note.",
      "fromChannel": "Depuis le canal",
      "fromChannelName": "Depuis {channel}",
      "holdCaptured": "Empreinte encaissée",
      "holdReleased": "Empreinte libérée",
      "inTheRate": "Inclus dans le tarif",
      "kindAccommodation": "Hébergement",
      "kindAdjustment": "Ajustement",
      "kindDiscount": "Remise",
      "kindFee": "Frais",
      "kindTax": "Taxe",
      "methodBankTransfer": "Virement bancaire",
      "methodCard": "Carte bancaire",
      "methodCash": "Espèces",
      "methodChannelCollected": "Encaissé par le canal",
      "methodDeposit": "Acompte",
      "methodGiftVoucher": "Bon cadeau",
      "methodOther": "Autre",
      "noCharges": "Aucune prestation pour l’instant.",
      "notTaken": "Non pris",
      "partyAdults": "{count, plural, one {# adulte} other {# adultes}}",
      "partyAdultsAndChildren": "{adults, plural, one {# adulte} other {# adultes}} · {children, plural, one {# enfant} other {# enfants}}",
      "partyChildren": "{count, plural, one {# enfant} other {# enfants}}",
      "partyCovers": "{count, plural, one {# couvert} other {# couverts}}",
      "paymentMethod": "Moyen de paiement",
      "quantityPlaceholder": "Qté",
      "rateAdultsAndChildren": "Adultes {adult} · Enfants {child}",
      "ratePerPerson": "{amount} par personne",
      "record": "Enregistrer",
      "recordPayment": "Enregistrer un paiement",
      "recordPaymentTitle": "Enregistrer un paiement",
      "referencePlaceholder": "Référence (facultatif)",
      "refund": "Rembourser",
      "refundConfirm": "Rembourser {amount}",
      "refundDescription": "{amount} est reversé au voyageur depuis votre compte Stripe. Stripe ne rend pas ses frais de traitement en cas de remboursement.",
      "refundIssued": "Remboursement effectué",
      "refundTitle": "Rembourser ce paiement ?",
      "release": "Libérer",
      "releaseConfirm": "Libérer {amount}",
      "releaseDescription": "L’empreinte de {amount} sur la carte du voyageur est libérée et vous ne pourrez plus l’encaisser. En poser une nouvelle implique de demander au voyageur de payer à nouveau.",
      "releaseTitle": "Libérer cette empreinte ?",
      "removeCharge": "Supprimer la prestation",
      "removePayment": "Supprimer le paiement",
      "title": "Note du séjour",
      "total": "Total",
      "touristTax": "Taxe de séjour",
      "voucherCodePlaceholder": "Code du bon (facultatif)"
    },
    "reservationSummary": {
      "guest": "Voyageur"
    },
    "reservationTaxCard": {
      "filedThrough": "Déclaration via {system}",
      "guestNumber": "Voyageur {number}",
      "guestShare": "{band} · {nights, plural, one {# nuit} other {# nuits}}",
      "needsBirthDates": "{count, plural, =0 {Ajoutez les dates de naissance des voyageurs} one {Ajoutez la date de naissance d’un voyageur} other {Ajoutez les dates de naissance de # voyageurs}}",
      "needsCategory": "Choisissez la catégorie de l’établissement",
      "needsGuests": "Indiquez le nombre de voyageurs pour voir cette taxe",
      "needsIntegration": "Configurez {system} pour voir cette taxe",
      "needsMunicipality": "Choisissez la commune de l’établissement pour voir cette taxe",
      "needsPrice": "Ajoutez le prix de l’hébergement pour voir cette taxe",
      "needsRegistration": "Configurez la déclaration des voyageurs pour voir cette taxe",
      "noLines": "Aucune taxe de séjour n’a encore été calculée pour ce séjour.",
      "notCovered": "Pas encore prise en charge",
      "paysFree": "Exonération",
      "paysFull": "Taux plein",
      "paysHalf": "Demi-tarif",
      "paysPercent": "{percent} du taux",
      "ratePercent": "{percent} du prix, dans la limite de {cap}",
      "ratePerNight": "{rate} par nuit",
      "ratePerNightFrom": "À partir du {date} : {rate} par nuit",
      "rateWithSurcharge": "{rate} + {surcharge} {label}",
      "title": "Taxe de séjour",
      "zone": "Tarif pour {zone}"
    },
    "reservationTaxNote": {
      "add": "Ajouter une note fiscale",
      "cancel": "Annuler",
      "edit": "Modifier",
      "help": "Ce que l’équipe sait de la taxe de séjour de cette réservation et que celle-ci n’indique pas, par ex. une prescription de cure présentée par le voyageur. Seule l’équipe voit cette note.",
      "label": "Note fiscale",
      "placeholder": "ex. Le voyageur a présenté une prescription de cure de son médecin",
      "save": "Enregistrer la note",
      "saveFailed": "Impossible d’enregistrer la note fiscale. Réessayez."
    },
    "reservationUnitDetails": {
      "adults": "{count, plural, one {{count} adulte} other {{count} adultes}}",
      "blockedChannelCancelled": "Annulée sur le canal : seul le canal peut la rétablir.",
      "blockedPermission": "Vous n’avez pas l’autorisation de modifier le statut de cette réservation.",
      "blockedPreparing": "Cet établissement est en préparation : son système actuel gère encore ce séjour. Impossible pour l’instant de le modifier, de l’annuler ou d’envoyer un lien d’enregistrement ici.",
      "boardLabel": "Formule",
      "bookedVia": "Réservé via",
      "bookerTitle": "Titulaire de la réservation",
      "bookingReference": "Numéro de réservation",
      "call": "Appeler",
      "callAriaLabel": "Appeler {name}",
      "checkInLabel": "Arrivée",
      "checkOutLabel": "Départ",
      "children": "{count, plural, one {{count} enfant} other {{count} enfants}}",
      "copyRoomLinkLabel": "Copier un lien vers la chambre {room}",
      "duration": "{count, plural, one {{count} nuit} other {{count} nuits}}",
      "durationLabel": "Durée",
      "expectedArrivalLabel": "Arrivée prévue",
      "guestSummary": "{occupancy} · {count, plural, one {pièces d’identité enregistrées : {idsOnFile} sur {count}} other {pièces d’identité enregistrées : {idsOnFile} sur {count}}}",
      "guestsTitle": "Voyageurs",
      "houseRulesAccepted": "Accepté le {date}",
      "houseRulesLabel": "Règlement intérieur",
      "infants": "{count, plural, one {{count} bébé} other {{count} bébés}}",
      "moreGuestsExpected": "{count, plural, one {{count} autre voyageur attendu} other {{count} autres voyageurs attendus}}",
      "notGiven": "Non indiqué",
      "notOnBookingYet": "Pas encore sur la réservation · scannez sa pièce d’identité pour l’ajouter",
      "notSpecified": "Non précisé",
      "occupancyLabel": "Occupation",
      "openGuestLabel": "Ouvrir {name}",
      "reportSummary": "{count, plural, one {Voyageurs déclarés à {authority} : {accepted} sur {count}} other {Voyageurs déclarés à {authority} : {accepted} sur {count}}}",
      "reservationInformation": "Informations de réservation",
      "room": "Chambre {room}",
      "scanBooker": "Scanner une pièce",
      "scanBookerAriaLabel": "Scanner la pièce d’identité de {name}",
      "scanId": "Scanner une pièce",
      "specialRequest": "Demande particulière",
      "taskWithUnit": "{task} · Logement {unit}",
      "tasksTitle": "Tâches",
      "typeId": "Saisir à la main",
      "unassigned": "{count, plural, one {Non attribué} other {# non attribués}}",
      "unitLabel": "Logement",
      "unitsLabel": "Logements",
      "unknownUnit": "Logement inconnu",
      "unscheduled": "Non planifiée"
    },
    "stayAction": {
      "checkIn": "Check-in",
      "checkInGuest": "Check-in de {guestName}",
      "checkOut": "Check-out",
      "checkOutGuest": "Check-out de {guestName}"
    },
    "unitOptions": {
      "booked": "Réservé"
    },
    "useStayAction": {
      "errorNotUpdated": "Impossible de mettre à jour le séjour. Réessayez."
    }
  },

  "settings": {
    "accessSection": {
      "checkInModeInPerson": "En personne",
      "checkInModeInPersonDescription": "L’équipe enregistre l’arrivée des voyageurs. Si l’établissement déclare ses voyageurs aux autorités, un voyageur dont personne n’enregistre l’arrivée n’est jamais déclaré automatiquement, et vous êtes prévenu avant l’échéance.",
      "checkInModeLabel": "Arrivée des voyageurs",
      "checkInModeSelf": "Arrivée autonome",
      "checkInModeSelfDescription": "Les voyageurs entrent seuls, sans être accueillis par l’équipe. Si l’établissement déclare ses voyageurs aux autorités, ceux dont l’équipe n’a pas enregistré l’arrivée sont déclarés le jour d’arrivée prévu.",
      "doorCode": "Code d’accès",
      "doorCodeDescription": "Les voyageurs reçoivent un code de clavier le jour de l’arrivée",
      "label": "Mode d’accès",
      "lockbox": "Boîte à clés",
      "lockboxDescription": "Les voyageurs récupèrent la clé dans une boîte à code",
      "placeholder": "Choisir un mode d’accès",
      "receptionCloses": "Fermeture de la réception",
      "receptionOpens": "Ouverture de la réception",
      "smartLock": "Serrure connectée",
      "smartLockDescription": "Les voyageurs ouvrent avec un code ou une application",
      "staffedReception": "Réception avec personnel",
      "staffedReceptionDescription": "Les voyageurs récupèrent les clés à la réception"
    },
    "account": {
      "interfaceLanguage": {
        "automatic": "Automatique ({language})",
        "description": "Les menus, boutons et écrans s’affichent dans cette langue.",
        "title": "Langue de l’interface"
      }
    },
    "accountDeletion": {
      "genericFailure": "Impossible de supprimer votre compte. Réessayez.",
      "protectedAccount": "Ce compte est protégé et ne peut pas être supprimé.",
      "soleOwner": "{properties} n’{count, plural, one {a} other {ont}} aucun autre propriétaire que vous. Avant de supprimer votre compte, nommez un autre propriétaire ou supprimez {count, plural, one {l’établissement} other {les établissements}}."
    },
    "accountPassword": {
      "genericFailure": "Impossible de définir votre mot de passe. Réessayez.",
      "sessionStale": "Par sécurité, déconnectez-vous puis reconnectez-vous avant de définir un mot de passe."
    },
    "accountView": {
      "appearanceDescription": "Les changements s’appliquent immédiatement sur cet appareil.",
      "appearanceTitle": "Apparence",
      "errorNameRequired": "Le nom est obligatoire",
      "errorPhotoNotSaved": "Impossible d’enregistrer votre photo. Réessayez.",
      "hapticsDescription": "Une courte vibration quand une arrivée, un scan ou une rotation est validé, pour garder les yeux sur le voyageur. S’applique immédiatement sur cet appareil.",
      "hapticsTitle": "Retour haptique",
      "hapticsToggle": "Vibrer à chaque confirmation",
      "languageArabic": "Arabe",
      "languageDefault": "Par défaut (anglais)",
      "languageChinese": "Chinois",
      "languageEnglish": "Anglais",
      "languageFrench": "Français",
      "languageGerman": "Allemand",
      "languageItalian": "Italien",
      "languageJapanese": "Japonais",
      "languagePortuguese": "Portugais",
      "languageSlovenian": "Slovène",
      "languageSpanish": "Espagnol",
      "nameDescription": "Visible par votre équipe et sur les messages que vous envoyez.",
      "namePlaceholder": "Saisissez votre nom",
      "nameTitle": "Nom complet",
      "phoneDescription": "Votre numéro professionnel.",
      "phoneTitle": "Numéro de téléphone",
      "photoAlt": "Profil",
      "photoCaption": "Touchez pour changer la photo de profil",
      "subtitle": "Gérez votre profil et vos informations",
      "themeDark": "Sombre",
      "themeLight": "Clair",
      "themeSystem": "Système",
      "title": "Compte",
      "translationLanguageDescription": "Les messages dans d’autres langues sont traduits dans celle-ci.",
      "translationLanguageTitle": "Langue de traduction"
    },
    "addressSection": {
      "countryLabel": "Pays",
      "hint": "Recherchez et sélectionnez l’adresse de l’établissement. Elle sert à le situer et à renseigner le pays.",
      "label": "Adresse",
      "placeholder": "Rechercher l’adresse de l’établissement…"
    },
    "availabilityDisplay": {
      "availableDuring": "Disponible {summary}",
      "awayOn": "Absent le {date}",
      "awayRange": "Absent {range}",
      "awayThrough": "Absent jusqu’au {end}",
      "awayToday": "Absent aujourd’hui",
      "awayTomorrow": "Absent demain",
      "outsideAvailability": "Hors disponibilité"
    },
    "breakfastPage": {
      "adult": "Adulte",
      "child": "Enfant",
      "errorSave": "Impossible d’enregistrer les paramètres du petit-déjeuner. Réessayez.",
      "from": "De",
      "inclusionCharged": "Payant",
      "inclusionChargedDetail": "Facturé aux voyageurs, sauf pour les séjours dont la formule inclut le petit-déjeuner.",
      "inclusionComplimentary": "Offert",
      "inclusionComplimentaryDetail": "Gratuit pour tous les voyageurs, quel que soit le tarif réservé. Rien n’apparaît sur la note.",
      "inclusionIncluded": "Inclus dans le tarif",
      "inclusionLabel": "Mode de paiement",
      "placeLabel": "Servi habituellement",
      "priceHint": "Par personne et par matin, en {currency}. L’âge enfant vient de la réservation : un séjour issu d’un canal suit la règle d’âge de ce canal.",
      "priceLabel": "Prix",
      "save": "Enregistrer",
      "saved": "Enregistré",
      "serveBreakfast": "Servir le petit-déjeuner",
      "serveBreakfastHint": "Désactivé, aucun matin n’est prévu et rien n’apparaît dans Aujourd’hui.",
      "serviceHint": "Les voyageurs voient ces horaires. Le lieu de service peut être modifié pour chaque chambre le matin même.",
      "serviceLabel": "Service",
      "title": "Petit-déjeuner",
      "unavailableDescription": "Vidimo ne parvient pas à les charger sur cet appareil. Touchez Réessayer : l’application sera rechargée.",
      "unavailableTitle": "Impossible de modifier les paramètres du petit-déjeuner pour le moment",
      "until": "À"
    },
    "cancellationSection": {
      "flexible": "Flexible",
      "hint": "{policyDescription} Les voyageurs qui réservent sur votre page publique la voient avant de payer, et les remboursements la suivent.",
      "label": "Conditions d’annulation",
      "moderate": "Modérée",
      "nonRefundable": "Non remboursable",
      "placeholder": "Choisir les conditions d’annulation",
      "strict": "Stricte"
    },
    "channelCards": {
      "announced": "Connectez {label} pour synchroniser les disponibilités et les prix dans les deux sens, et recevoir les nouvelles réservations directement dans Vidimo.",
      "cancel": "Annuler",
      "comingSoon": "Les connexions {label} arrivent bientôt.",
      "connectButton": "Connecter {label}",
      "connectTitle": "Connecter {label}",
      "connecting": "Connexion…",
      "continue": "Continuer",
      "errorConnect": "Impossible de connecter le canal. Réessayez.",
      "errorOpenSetup": "Impossible d’ouvrir la configuration du canal. Réessayez.",
      "errorSync": "Impossible de synchroniser. Réessayez.",
      "explainerLogin": "Vous terminerez sur une page de configuration sécurisée : gardez vos identifiants {label} à portée de main.",
      "explainerOwnerOnly": "Seul le compte propriétaire de l’annonce peut connecter {label}, pas un co-hôte.",
      "explainerSync": "Vos disponibilités et vos prix restent synchronisés avec {label} dans les deux sens, et les nouvelles réservations arrivent dans Vidimo.",
      "noUnits": "Ajoutez d’abord un logement à cet établissement.",
      "opening": "Ouverture…",
      "setUpChannels": "Configurer {label}",
      "syncAction": "Synchroniser disponibilités et prix",
      "syncDone": "Disponibilités et prix resynchronisés avec {label}.",
      "syncSlow": "{label} répond lentement. La synchronisation se terminera automatiquement.",
      "syncStarted": "Synchronisation lancée. Elle se terminera en arrière-plan.",
      "syncing": "Synchronisation…",
      "warnings": {
        "delayed": "La synchronisation prend du retard. Nous réessayons automatiquement, vous n’avez rien à faire.",
        "ourSide": "Un problème est survenu de notre côté avec ce canal. Notre équipe a été alertée.",
        "unlinkedRoom": "Une nouvelle réservation n’a pas pu être rattachée à vos logements. Vérifiez la configuration de ce canal."
      },
      "whichUnits": "Quels logements sont publiés sur {label} ?"
    },
    "cleaningChecklistEditor": {
      "addStep": "Ajouter une étape",
      "alwaysLast": "· toujours en dernier",
      "guestNeedsHint": "Les besoins des voyageurs indiqués dans la réservation, comme un lit bébé ou un animal, sont ajoutés juste avant la vérification finale.",
      "listFull": "{count, plural, one {Une liste de contrôle contient au maximum # étape.} other {Une liste de contrôle contient au maximum # étapes.}}",
      "moveDown": "Descendre l’étape {position}",
      "moveUp": "Monter l’étape {position}",
      "remove": "Supprimer l’étape {position}",
      "saveList": "Enregistrer la liste de contrôle",
      "saving": "Enregistrement…",
      "stepBlank": "Complétez cette étape ou supprimez-la.",
      "stepLabel": "Étape {position}",
      "stepLength": "{length} / {max}",
      "stepPlaceholder": "Décrivez l’étape",
      "stepTooLong": "{count, plural, one {{count} caractère de trop.} other {{count} caractères de trop.}}",
      "unsavedChanges": "Modifications non enregistrées"
    },
    "cleaningPage": {
      "allRooms": "Toutes les chambres",
      "assignHeading": "Qui reçoit la tâche",
      "discard": "Abandonner",
      "discardDescription": "Cette liste de contrôle contient des modifications non enregistrées. Si vous changez de liste maintenant, elles seront perdues.",
      "discardDescriptionReload": "Vous avez des modifications non enregistrées. Si vous rechargez l’application maintenant, elles seront perdues.",
      "discardTitle": "Abandonner vos modifications ?",
      "errorReset": "Impossible de modifier la liste de contrôle. Réessayez.",
      "errorSave": "Impossible d’enregistrer la liste de contrôle. Réessayez.",
      "giveOwnList": "Créer une liste de contrôle propre à {unitName}",
      "hintPostCheckout": "Un voyageur est parti et personne n’arrive ce jour-là.",
      "hintRefresh": "La réception prépare la chambre, déjà nettoyée, juste avant l’arrivée de chaque voyageur.",
      "hintTurnover": "Un voyageur part et un autre arrive le même jour.",
      "inheritedPostCheckoutFromProperty": "Pour le ménage après départ, {unitName} utilise la liste de contrôle de l’établissement :",
      "inheritedPostCheckoutFromStandard": "Pour le ménage après départ, {unitName} utilise la liste de contrôle standard :",
      "inheritedPreCheckinRefreshFromProperty": "Pour le rafraîchissement avant arrivée, {unitName} utilise la liste de contrôle de l’établissement :",
      "inheritedPreCheckinRefreshFromStandard": "Pour le rafraîchissement avant arrivée, {unitName} utilise la liste de contrôle standard :",
      "inheritedTurnoverFromProperty": "Pour la rotation, {unitName} utilise la liste de contrôle de l’établissement :",
      "inheritedTurnoverFromStandard": "Pour la rotation, {unitName} utilise la liste de contrôle standard :",
      "intro": "Ces réglages déterminent à qui va chaque tâche de ménage créée par Vidimo, et la liste d’étapes qu’elle reçoit à sa création. La personne que vous affectez à la main l’emporte toujours, et les tâches déjà créées gardent leur affectation et leurs étapes d’origine.",
      "keepEditing": "Continuer à modifier",
      "kindLabel": "Type de ménage",
      "loading": "Chargement de vos listes de contrôle…",
      "ownListCreated": "{name} a désormais sa propre liste de contrôle. Modifiez-la ci-dessous.",
      "refreshError": "Impossible de modifier le réglage du rafraîchissement avant arrivée. Réessayez.",
      "refreshHint": "La réception prépare chaque chambre après son ménage, juste avant l’arrivée du voyageur. Seules les réservations ajoutées dans Vidimo une fois ce réglage activé sont concernées.",
      "refreshLabel": "Rafraîchissement avant chaque arrivée",
      "resetLabelProperty": "Utiliser la liste de contrôle de l’établissement",
      "resetLabelStandard": "Revenir à la liste de contrôle standard",
      "resetToProperty": "{name} utilise désormais la liste de contrôle de l’établissement.",
      "resetToStandard": "Retour à la liste de contrôle standard.",
      "saveAndSwitch": "Enregistrer et continuer",
      "saveFirstDescription": "Cette liste de contrôle contient des modifications non enregistrées. Enregistrez-les avant de changer de liste, ou abandonnez-les.",
      "saveFirstTitle": "Enregistrer vos modifications ?",
      "saved": "Liste de contrôle enregistrée. Les tâches de ménage que Vidimo créera désormais l’utiliseront.",
      "scopeHint": "Ne créez une liste de contrôle propre à une chambre que si celle-ci a des particularités, comme un balcon ou un jacuzzi.",
      "scopeLabel": "S’applique à",
      "stepsHeading": "Liste de contrôle",
      "thisRoom": "Cette chambre",
      "title": "Ménage",
      "unavailableDescription": "Vidimo ne parvient pas à charger vos listes de contrôle sur cet appareil. Touchez Réessayer : l’application sera rechargée.",
      "unavailableTitle": "Impossible de modifier les listes de contrôle pour le moment",
      "undo": "Annuler"
    },
    "createPage": {
      "created": "Établissement créé",
      "createdPendingSync": "Établissement créé. Il apparaîtra dès que votre connexion aura rattrapé son retard.",
      "description": "Configurez un nouvel établissement pour gérer vos voyageurs et votre équipe.",
      "errorNotCreated": "Impossible de créer l’établissement. Réessayez.",
      "title": "Créer un établissement"
    },
    "createPropertyForm": {
      "addressHint": "Recherchez et sélectionnez l’adresse pour situer l’établissement et renseigner le pays. Vous pourrez ajouter l’adresse plus tard.",
      "addressLabel": "Adresse",
      "addressNoCountry": "Cette adresse n’indique pas de pays. Choisissez-le ci-dessous.",
      "addressPlaceholder": "Rechercher l’adresse de l’établissement…",
      "cancel": "Annuler",
      "countryHint": "Détermine la déclaration des voyageurs, la taxe de séjour et la TVA de l’établissement.",
      "countryLabel": "Pays *",
      "countryPlaceholder": "Choisir le pays",
      "nameLabel": "Nom de l’établissement *",
      "namePlaceholder": "Saisissez le nom de l’établissement",
      "submit": "Continuer"
    },
    "credentialHealth": {
      "accepted": "{system} a accepté votre connexion et une fiche de test le {checkedAt}. La vérification ne déclare rien.",
      "badge": {
        "enterAgain": "À ressaisir",
        "keyRefused": "Clé refusée",
        "noAnswer": "Pas de réponse",
        "refusedAccount": "Compte refusé",
        "signInRefused": "Connexion refusée",
        "works": "Compte opérationnel"
      },
      "enterAgain": "Depuis le {since}, Vidimo ne peut pas utiliser les identifiants enregistrés : rien n’a été envoyé à {system}. Saisissez-les à nouveau.",
      "keyRefused": "Depuis le {since}, {system} refuse cette clé : « {key} ».{said} Générez-en une nouvelle, puis saisissez-la via « Mettre à jour les identifiants ». {help}",
      "noAnswer": "{system} n’a pas répondu à la vérification de Vidimo le {checkedAt}.{streak} Vidimo vérifiera de nouveau sous 24 heures.",
      "recordRefused": "Votre connexion fonctionne. Le {checkedAt}, {system} a refusé la fiche de test de Vidimo : c’est à nous de corriger, pas à vous.{said} Rien n’a été déclaré.",
      "refusedAccount": "Depuis le {since}, {system} accepte la connexion mais refuse la vérification pour ce compte.{said} Vérifiez que le service web est activé pour ce compte et que le numéro d’appartement ou de compte ci-dessous est correct.",
      "said": " Réponse : « {message} ».",
      "signInRefused": "Depuis le {since}, {system} refuse la connexion avec ces identifiants.{said} Vérifiez le nom d’utilisateur et le mot de passe.",
      "streak": " Aucune réponse exploitable depuis le {since}.",
      "unanswered": "Le {checkedAt}, {system} a renvoyé une erreur au lieu d’une réponse : « {message} ».{streak} Vidimo vérifiera de nouveau sous 24 heures."
    },
    "customDomainView": {
      "addDomain": "Ajouter le domaine",
      "copied": "Copié dans le presse-papiers",
      "copyRecordValue": "Copier la valeur de l’enregistrement {type}",
      "dnsInstructions": "Ajoutez ces enregistrements chez votre registraire de domaine. La propagation DNS peut prendre quelques minutes.",
      "domainAdded": "Domaine ajouté : configurez les enregistrements DNS pour le vérifier",
      "domainLabel": "Votre domaine",
      "domainLive": "Votre domaine est en ligne",
      "domainPlaceholder": "votre-hotel.fr",
      "domainRemoved": "Domaine personnalisé supprimé",
      "errorAdd": "Impossible d’ajouter le domaine",
      "errorCopy": "Impossible de copier dans le presse-papiers",
      "errorRemove": "Impossible de supprimer le domaine",
      "intro": "Publiez le site Places de votre établissement sur votre propre domaine, par exemple <example>www.votre-hotel.fr</example>. Les voyageurs ne voient jamais l’adresse vidimo.app.",
      "loadFailedBody": "Vérifiez votre connexion et réessayez.",
      "loadFailedTitle": "Impossible de charger les paramètres du domaine",
      "openSite": "Ouvrir le site",
      "primary": "principal",
      "remove": "Supprimer",
      "retry": "Réessayer",
      "siteLiveBody": "Les voyageurs peuvent vous trouver sur {url}.",
      "siteLiveTitle": "Votre site est en ligne",
      "statusActive": "Actif",
      "statusError": "Erreur",
      "statusPendingDns": "DNS en attente",
      "statusVerifying": "Vérification",
      "stillWaiting": "Toujours en attente du DNS : cela peut prendre quelques minutes",
      "title": "Domaine personnalisé",
      "verificationFailedBody": "Vérifiez les enregistrements DNS ci-dessous et réessayez.",
      "verificationFailedTitle": "Échec de la vérification",
      "verify": "Vérifier"
    },
    "deleteAccountSection": {
      "confirmPhrase": "supprimer définitivement",
      "description": "Supprimez définitivement votre compte et vos données personnelles, y compris votre profil, vos messages dans les conversations d’équipe et votre accès à tous les établissements dont vous êtes membre. Cette action est irréversible.",
      "errorLoad": "Impossible de vérifier ce compte. Vérifiez votre connexion et réessayez.",
      "errorNotDeleted": "Impossible de supprimer votre compte. Réessayez.",
      "errorOffline": "Vous êtes hors ligne : ce compte ne peut pas être vérifié pour le moment.",
      "title": "Supprimer le compte"
    },
    "deleteConfirmDialog": {
      "cancel": "Annuler",
      "confirmNamePrompt": "Pour confirmer, saisissez : <strong>{entityName}</strong>",
      "confirmPhrasePrompt": "Pour confirmer la suppression de <strong>{entityName}</strong>, saisissez <strong>« {expectedValue} »</strong>",
      "deleting": "Suppression…",
      "placeholder": "Saisissez « {expectedValue} »"
    },
    "deleteDangerSection": {
      "checking": "Vérification…"
    },
    "disconnectIntegration": {
      "cancel": "Annuler",
      "disconnect": "Déconnecter",
      "disconnected": "{channel} déconnecté",
      "disconnecting": "Déconnexion…",
      "error": "Impossible de déconnecter {channel}. Réessayez.",
      "title": "Déconnecter {channel} ?"
    },
    "editableSettingCard": {
      "errorNotSaved": "Impossible d’enregistrer. Réessayez.",
      "save": "Enregistrer",
      "saved": "Enregistré",
      "saving": "Enregistrement…"
    },
    "emailPreviewSheet": {
      "frameTitle": "Aperçu de l’e-mail",
      "loading": "Chargement…",
      "sampleNote": "Un exemple, avec le nom et l’adresse de votre établissement. Les dates, le voyageur et le numéro de réservation sont fictifs.",
      "subject": "Objet",
      "title": "Aperçu"
    },
    "facilityNumber": {
      "addedWithLogin": "Vous saisirez le « {field} » lors de la configuration de la connexion ci-dessous.",
      "elsewhere": "D’après le registre, le numéro saisi dans « {field} » correspond à un établissement de la commune de {other}, pas de celle-ci. Vérifiez le numéro ou la commune de l’hébergement.",
      "errorSave": "Impossible d’enregistrer le « {field} ». Réessayez.",
      "listed": "Inscrit au registre pour cette commune.",
      "listedNamed": "Au registre, ce numéro correspond à {name}.",
      "neededForTax": "Dans votre commune, la taxe de séjour dépend de l’emplacement de votre hébergement, de son type ou de son exploitant. Vidimo a besoin de ce numéro pour la calculer.",
      "notListed": "Aucun établissement actif de cette commune ne figure au registre sous le numéro saisi dans « {field} ». Un établissement inscrit aujourd’hui n’y figure qu’à partir du lendemain.",
      "registerIncomplete": "Le registre n’en dit pas encore assez sur cet établissement pour calculer sa taxe de séjour. Vidimo affiche la taxe dès que c’est le cas.",
      "save": "Enregistrer",
      "saved": "« {field} » enregistré",
      "saving": "Enregistrement…"
    },
    "guestPortalForm": {
      "cancel": "Annuler",
      "errorNotSaved": "Impossible d’enregistrer le portail voyageur. Réessayez.",
      "intro": "Les voyageurs lisent ces informations sur leur page séjour, et les brouillons de réponse de l’IA s’en servent. Les brouillons ne connaissent jamais le mot de passe Wi-Fi ni les codes d’accès.",
      "parking": "Parking",
      "parkingSummary": "{count, plural, =0 {Pas encore configuré} one {# place} other {# places}}",
      "save": "Enregistrer",
      "subtitle": "Ce que les voyageurs lisent sur leur page séjour",
      "title": "Portail voyageur"
    },
    "guestPortalPage": {
      "title": "Portail voyageur"
    },
    "guestPreviewPage": {
      "desktopUnavailable": "L’aperçu s’ouvre dans l’application web et les applications pour téléphone et tablette.",
      "title": "Voir comme un voyageur"
    },
    "guestRegistryPage": {
      "bornOn": "né(e) le {date}",
      "document": "{type} {number}",
      "documentIdCard": "Carte d’identité",
      "documentOther": "Document",
      "documentPassport": "Passeport",
      "documentWithIssuer": "{type} {number} ({country})",
      "emptyDescription": "Les voyageurs apparaissent ici dès leur arrivée enregistrée.",
      "emptyFilteredDescription": "Aucune entrée du registre ne correspond à ces filtres.",
      "emptyTitle": "Aucune entrée",
      "errorLoad": "Impossible de charger le registre. Réessayez.",
      "loadMore": "Afficher plus",
      "loadingMore": "Chargement…",
      "noDocument": "Aucun document",
      "occupancy": "{adults, plural, one {# ad.} other {# ad.}}",
      "occupancyUnknownAdults": "? ad.",
      "occupancyUnknownAdultsWithChildren": "? ad. · {children, plural, one {# enf.} other {# enf.}}",
      "occupancyWithChildren": "{adults, plural, one {# ad.} other {# ad.}} · {children, plural, one {# enf.} other {# enf.}}",
      "title": "Registre des voyageurs"
    },
    "guestRegistryParams": {
      "statusAll": "Tous les séjours",
      "statusCheckedIn": "Sur place",
      "statusCheckedOut": "Partis"
    },
    "guestRegistryRegistryFilterBar": {
      "allTime": "Toutes les dates",
      "count": "{count, plural, one {{count} entrée} other {{count} entrées}}",
      "countPartial": "{shown} sur {total, plural, one {{total} entrée} other {{total} entrées}}",
      "customRange": "Période personnalisée",
      "exportCsv": "Exporter en CSV",
      "exporting": "Export…",
      "intro": "Le registre légal des personnes hébergées, établi à l’arrivée. Les entrées ne peuvent qu’être ajoutées : les consulter ou les exporter ne les modifie jamais.",
      "rangePlaceholder": "Choisir une période",
      "searchPlaceholder": "Rechercher un voyageur…",
      "statusFilterLabel": "Filtrer par statut du séjour",
      "yearFilterLabel": "Filtrer par année"
    },
    "guestRegistryUseGuestRegistry": {
      "errorExport": "Impossible d’exporter le registre.",
      "errorLoadMore": "Impossible de charger plus d’entrées."
    },
    "houseRulesSection": {
      "houseInfoHint": "Le fonctionnement du logement : chauffage, poubelles, appareils, heures de silence.",
      "houseInfoLabel": "Infos du logement",
      "houseInfoPlaceholder": "Le chauffage se règle sur le panneau près de la porte.\nLes poubelles sortent le mardi soir.",
      "houseRulesHint": "Une règle par ligne. Les voyageurs les lisent dans leur portail et les acceptent une fois lors de l’enregistrement ; laissez vide pour passer cette étape.",
      "houseRulesLabel": "Règlement intérieur",
      "houseRulesPlaceholder": "Interdiction de fumer dans tout le bâtiment.\nSilence de 22 h à 8 h.",
      "localTipsHint": "Vos bonnes adresses : restaurants, transports, incontournables.",
      "localTipsLabel": "Bonnes adresses",
      "localTipsPlaceholder": "Le meilleur café : la boulangerie au coin de la rue.\nLe bus 6 va directement à la vieille ville."
    },
    "importsPage": {
      "applyChange": "Utiliser la version {source}",
      "brief": "{guest} · {dates} · {rooms}",
      "briefBlock": "Chambre bloquée · {dates} · {rooms}",
      "briefCancelled": "{brief} · annulée",
      "candidate": "Réservation {number} (import précédent)",
      "changes": "{added, plural, one {# ajoutée} other {# ajoutées}} · {amended, plural, one {# mise à jour} other {# mises à jour}} · {cancelled, plural, one {# annulée} other {# annulées}} · {unchanged, plural, one {# inchangée} other {# inchangées}}",
      "current": "Dans Vidimo",
      "detail": "{field} : {value}",
      "detailNone": "non renseigné",
      "details": {
        "adults": "Adultes",
        "amountMinor": "Montant total",
        "children": "Enfants",
        "email": "E-mail",
        "infants": "Bébés",
        "notes": "Remarques",
        "phone": "Téléphone",
        "reason": "Motif",
        "source": "Provenance",
        "status": "Statut"
      },
      "emptyDescription": "Vidimo gère déjà cet établissement : aucune réservation ne peut donc y être importée. Les imports ne concernent qu’un établissement encore en préparation.",
      "emptyTitle": "Aucune réservation importée",
      "errorLoad": "Impossible de charger vos imports. Réessayez dans un instant.",
      "held": "{count, plural, one {# réservation attend votre décision} other {# réservations attendent votre décision}}",
      "heldReason": {
        "host_changed": "Vous avez modifié la réservation {number} dans Vidimo, ou saisi des fiches voyageurs sur une chambre que {source} ne lui attribue plus, et {source} l’a modifiée depuis. Votre version est conservée jusqu’à ce que vous décidiez.",
        "host_deleted": "Vous avez supprimé la réservation {number} dans Vidimo, et {source} l’a modifiée depuis. Elle reste supprimée jusqu’à ce que vous décidiez.",
        "possible_match": "La réservation {number} dans {source} correspond peut-être à une réservation qu’un import précédent a ajoutée sous un autre numéro. Elle n’a pas été ajoutée : rien n’est en double."
      },
      "heldRoomRemoved": "Sa chambre a été supprimée de Vidimo : la version {source} ne peut pas être utilisée ici.",
      "heldUntilNext": "Décidez avant que votre application d’IA ne lance son prochain import : celui-ci clôt ces décisions en attente et vous interroge de nouveau sur les réservations qui restent incertaines.",
      "how": {
        "connect": "Ajoutez Vidimo à Claude ou à ChatGPT comme connecteur, et laissez cochée l’option « {importLabel} » quand Vidimo vous demande votre autorisation.",
        "copied": "Copié",
        "copy": "Copier le prompt",
        "copyFailed": "Impossible de copier. Sélectionnez le prompt et copiez-le vous-même.",
        "guide": "Lire le guide",
        "paste": "Collez ce prompt dans une nouvelle conversation. Votre application d’IA vous aide à ajouter ce qui manque, vous pose quelques questions et copie les réservations.",
        "prompt": "Je veux copier mes réservations du système que j’utilise aujourd’hui vers mon établissement Vidimo {property}. Avant toute chose, vérifiez que vous disposez des deux éléments nécessaires. S’il en manque un, arrêtez-vous, dites-moi lequel et guidez-moi pour le mettre en place.\n\n1. Les outils de Vidimo, comme getImportPlaybook. S’ils vous manquent, c’est que Vidimo est soit désactivé pour cette conversation, soit pas encore ajouté à cette application. Demandez-moi d’abord de regarder dans les connecteurs de cette application : si Vidimo y figure, je l’active. Sinon, aidez-moi à l’ajouter comme connecteur personnalisé avec l’adresse {connectorUrl}. Dans Claude, c’est Customize, Connectors, Add, Add custom connector. Dans ChatGPT, c’est Plugins, Add, Add custom MCP server. Si mon interface n’est pas en anglais, donnez-moi les intitulés tels qu’ils s’affichent chez moi. Quand Vidimo me le demande, je me connecte et je laisse cochée l’option « {importLabel} ». Dites-moi ensuite de démarrer une nouvelle conversation et de coller à nouveau ce prompt, car une conversation ne dispose que des connecteurs présents à son ouverture. Si vous pouvez ouvrir des pages web, les étapes figurent aussi sur {guideUrl}.\n\n2. Un navigateur que vous pouvez utiliser pour moi, dans lequel je me connecte à mon système et dont vous lisez les pages, comme Claude in Chrome ou le Work mode de ChatGPT. La recherche web ne suffit pas, car mon système exige que je sois connecté. Si vous ne pouvez pas en utiliser un dans cette conversation, dites-moi comment en obtenir un dans cette application.\n\nUne fois que vous avez les deux, appelez getImportPlaybook et suivez-le.",
        "signIn": "Dans le navigateur qu’utilise votre application d’IA, ouvrez votre système actuel et connectez-vous.",
        "title": "Importez vos réservations avec votre application d’IA"
      },
      "ignore": "Ne pas l’ajouter",
      "intro": "Chaque import lancé par votre application d’IA, comparé aux totaux de votre système actuel lorsqu’il les affiche.",
      "introUndo": "Tant que cet établissement est en préparation, vous pouvez annuler un import pour supprimer les réservations qu’il a ajoutées.",
      "keep": "Conserver l’import",
      "keepDeleted": "La laisser supprimée",
      "keepMine": "Garder la mienne",
      "matches": "Conforme à {source} : les réservations de chaque mois et les nuits de chaque chambre concordent.",
      "mismatch": "Ne correspond pas à {source}",
      "missingInVidimo": "{room}, {nights} : nuits occupées dans {source}, libres dans Vidimo",
      "monthDifference": "{month}, arrivées dans {source} : {pms}, dans Vidimo : {vidimo}",
      "noTotals": "Les totaux de {source} n’ont pas été envoyés avec cet import : Vidimo ne peut donc pas confirmer que rien n’a été oublié. Comparez-le vous-même avec {source}.",
      "notInPms": "{room}, {nights} : nuits occupées dans Vidimo, libres dans {source}",
      "notSent": "{count, plural, one {# réservation d’un import précédent ne figurait pas dans celui-ci. Elle a été laissée telle quelle, sans être annulée.} other {# réservations d’imports précédents ne figuraient pas dans celui-ci. Elles ont été laissées telles quelles, sans être annulées.}}",
      "problems": "{count, plural, one {# point à vérifier, signalé par votre application d’IA à la fin de l’import} other {# points à vérifier, signalés par votre application d’IA à la fin de l’import}}",
      "proposed": "Dans {source}",
      "resolveFailed": "Impossible d’enregistrer votre choix. Réessayez dans un instant.",
      "resolveRefused": "Ce choix ne peut pas être appliqué tel quel : la réservation a changé depuis, ne correspond plus à ses dates ou à ses chambres, ou supprimerait des fiches voyageurs que vous avez saisies sur une chambre. Vérifiez la réservation dans Vidimo, puis choisissez à nouveau.",
      "restore": "Restaurer depuis {source}",
      "runTitle": "Depuis {source}",
      "sameBooking": "C’est cette réservation",
      "separateBooking": "Ajouter comme nouvelle réservation",
      "status": {
        "finished": "Terminé",
        "open": "Import en cours",
        "undone": "Annulé"
      },
      "stillImporting": "Import en cours. Une fois terminé, il sera comparé aux totaux de {source} si votre application d’IA peut les envoyer.",
      "title": "Réservations importées",
      "superseded": "Un import plus récent depuis {source} s’est terminé entre-temps : la vérification de celui-ci n’est plus valable. Consultez le plus récent.",
      "totals": "{source} : {pmsBookings, plural, one {# réservation} other {# réservations}} par date d’arrivée, {pmsNights, plural, one {# nuit occupée} other {# nuits occupées}}. Vidimo : {vidimoBookings, plural, one {# réservation} other {# réservations}}, {vidimoNights, plural, one {# nuit occupée} other {# nuits occupées}}.",
      "totalsFrom": "Comparé aux totaux du système {source} arrêtés au {date}.",
      "undo": "Annuler l’import",
      "undoAmended": "Les modifications qu’il a apportées aux réservations ajoutées par des imports précédents sont conservées.",
      "undoBody": "Cette action supprime de Vidimo ce que cet import a copié depuis {source} : {reservations, plural, =1 {la réservation} one {# réservation} other {les # réservations}}{blocks, plural, =0 {} one { et # chambre bloquée} other { et # chambres bloquées}}. Rien ne change dans {source}, et les réservations que vous avez créées vous-même ou que d’autres imports ont ajoutées sont conservées.",
      "undoFailed": "Impossible d’annuler l’import. Réessayez dans un instant.",
      "undoGuestDetails": "{count, plural, one {# des réservations importées comporte des fiches voyageurs que vous avez saisies : ces fiches seront supprimées aussi, mais les profils voyageurs sont conservés.} other {# des réservations importées comportent des fiches voyageurs que vous avez saisies : ces fiches seront supprimées aussi, mais les profils voyageurs sont conservés.}}",
      "undoNothingAdded": "Rien de ce que cet import a ajouté ne se trouve plus dans Vidimo : l’annuler ne supprime rien. Il est marqué comme annulé, et les décisions qu’il attendait encore de vous sont closes.",
      "undoOpenBody": "Cet import est toujours en cours. L’annuler l’arrête et supprime de Vidimo toutes les réservations qu’il a copiées depuis {source}, {reservations} à ce stade. Rien ne change dans {source}, et les réservations que vous avez créées vous-même ou que d’autres imports ont ajoutées sont conservées.",
      "undoRefusedActive": "Vidimo gère désormais cet établissement : un import ne peut donc plus être annulé. Modifiez ses réservations une par une.",
      "undoTitle": "Annuler cet import ?",
      "undone": "Import annulé : {reservations, plural, one {# réservation supprimée} other {# réservations supprimées}}{blocks, plural, =0 {} one { et # chambre bloquée supprimée} other { et # chambres bloquées supprimées}}.",
      "undoneOn": "Annulé le {date}. Les réservations qu’il avait ajoutées ont été supprimées.",
      "unknownRoom": "Une chambre supprimée"
    },
    "infoEdit": {
      "errorNotDeleted": "Impossible de supprimer l’établissement. Réessayez."
    },
    "inviteMemberDrawer": {
      "emailHint": "Nous lui enverrons par e-mail un lien pour rejoindre l’équipe, avec un code d’invitation à saisir dans l’application.",
      "emailLabel": "E-mail",
      "emailPlaceholder": "nom@exemple.fr",
      "errorFailed": "Échec de l’invitation",
      "noPermission": "Vous n’avez pas l’autorisation d’inviter des membres dans cet établissement.",
      "roleLabel": "Rôle",
      "submit": "Envoyer l’invitation",
      "submitPending": "Envoi…",
      "title": "Inviter un membre"
    },
    "joinPage": {
      "description": "Saisissez le code d’invitation reçu pour rejoindre votre équipe.",
      "title": "Rejoindre un établissement"
    },
    "joinPropertyForm": {
      "cancel": "Annuler",
      "codeLabel": "Code d’invitation",
      "codePlaceholder": "Saisissez votre code d’invitation",
      "submit": "Rejoindre"
    },
    "linkError": {
      "alreadyLinkedToDifferentUser": "Ce compte est déjà connecté à un autre compte Vidimo. Déconnectez-le d’abord de celui-ci.",
      "emailDoesNotMatch": "Ce compte utilise une autre adresse e-mail. Vous ne pouvez connecter qu’un compte avec la même adresse que celui-ci.",
      "emailNotFound": "Ce fournisseur n’a pas communiqué d’adresse e-mail : impossible de le rattacher à ce compte.",
      "generic": "Impossible de connecter ce compte. Réessayez.",
      "unableToLinkAccount": "Impossible de connecter ce compte. Vérifiez que son adresse e-mail est validée chez le fournisseur, puis réessayez."
    },
    "linkSocialAccount": {
      "linkFailed": "Impossible d’associer votre compte {provider}"
    },
    "membersAvailability": {
      "notFound": "Membre introuvable"
    },
    "membersMembers": {
      "errorNotResent": "Impossible de renvoyer l’invitation. Réessayez.",
      "errorNotWithdrawn": "Impossible de retirer l’invitation. Réessayez.",
      "resent": "Invitation renvoyée à {email}",
      "withdrawn": "Invitation retirée"
    },
    "connectRefusal": {
      "account_claimed": "Ce compte est déjà relié à un autre établissement : impossible de le connecter ici.",
      "contactSupport": "Contacter l’assistance",
      "number_claimed": "Ce numéro est déjà relié à un autre établissement : impossible de le connecter ici.",
      "numberClaimedBy": "Ce numéro est déjà relié à {property} : impossible de le connecter ici.",
      "property_preparing": "Cet établissement est en préparation : rien ne peut encore être connecté. Une connexion pourrait reprendre un service que votre système actuel assure.",
      "setup_broken": "La configuration est bloquée et ne peut pas être terminée ici. L’équipe Vidimo peut s’en charger.",
      "subscription_required": "Un abonnement actif est nécessaire pour connecter un canal."
    },
    "messagingCards": {
      "addressCopied": "Adresse copiée",
      "checking": "Vérification…",
      "codeAccepted": "Code accepté. Finalisation de la connexion.",
      "codeHint": "WhatsApp l’envoie par SMS ou par appel automatique. Il peut mettre quelques minutes à arriver.",
      "codeLabel": "Saisissez le code envoyé par WhatsApp",
      "codeLabelSentTo": "Saisissez le code envoyé au {e164}",
      "comingSoon": "Bientôt",
      "connectFailed": "Impossible de se connecter. Réessayez.",
      "connectInstagram": "Connecter Instagram",
      "connectWhatsApp": "Connecter WhatsApp",
      "copyEmailAddress": "Copier l’adresse e-mail",
      "disconnectInstagramDescription": "Les nouveaux messages privés n’arriveront plus dans Vidimo, et le compte est libéré pour être connecté de nouveau ici ou sur un autre établissement. Vos conversations existantes restent dans Messages.",
      "disconnectWhatsAppDescription": "Les messages des voyageurs vers ce numéro n’arriveront plus dans Vidimo. Vos conversations existantes restent dans Messages.",
      "emailDescription": "Les voyageurs peuvent écrire à cette adresse. Les réponses arrivent ici, dans Messages : aucune configuration, aucun transfert.",
      "errorCode": "Ce code n’a pas fonctionné. Vérifiez-le et réessayez.",
      "errorConnectInstagram": "Impossible de lancer la connexion Instagram",
      "errorCopyAddress": "Impossible de copier l’adresse",
      "errorLinkPhone": "Impossible d’associer le numéro. Réessayez.",
      "errorReachWhatsApp": "Impossible de joindre WhatsApp. Réessayez dans un instant.",
      "errorStartConnection": "Impossible de lancer la connexion. Réessayez.",
      "instagramConnected": "Le fil et les messages privés sont connectés.",
      "instagramPitch": "Affichez votre fil et répondez aux messages privés depuis la boîte de réception.",
      "instagramReplyRule": "Instagram ne vous permet de répondre qu’après un premier message du voyageur.",
      "linkPhone": "Associer le téléphone",
      "linking": "Association…",
      "manageWhatsApp": "Gérer dans WhatsApp Business",
      "number": "Numéro : <number>{e164}</number>",
      "numberConnected": "Numéro connecté : <number>{e164}</number>",
      "numberConnecting": "Numéro en cours de connexion : <number>{e164}</number>",
      "opening": "Ouverture…",
      "phoneLinked": "Numéro de téléphone associé",
      "phoneNumberLabel": "Numéro de téléphone (E.164)",
      "phoneSubtitle": "Appels et SMS Twilio pour cet établissement",
      "reconnectInstagram": "Reconnecter Instagram",
      "reconnecting": "Reconnexion…",
      "retryConnection": "Relancer la connexion",
      "senderOffline": {
        "displayNameRejected": "WhatsApp n’a pas approuvé le nom d’affichage de ce numéro. Choisissez un autre nom dans WhatsApp Manager, puis relancez la connexion.",
        "numberReassigned": "Ce numéro est désormais enregistré sur un autre compte WhatsApp : les messages des voyageurs n’arrivent plus dans cet établissement.",
        "numberRemoved": "Ce numéro a été retiré de WhatsApp Business. Relancez la connexion pour le configurer à nouveau.",
        "policyRestricted": "WhatsApp a restreint ce numéro pour non-respect de sa politique commerciale. Consultez WhatsApp Manager pour savoir quoi corriger.",
        "unrecognised": "WhatsApp a désactivé ce numéro. Relancez la connexion pour le configurer à nouveau, ou consultez WhatsApp Manager pour plus de détails."
      },
      "statusActive": "Actif",
      "submit": "Valider",
      "twilioSidLabel": "SID du numéro Twilio (facultatif)",
      "update": "Mettre à jour",
      "whatsAppEmpty": "Connectez un numéro WhatsApp Business pour recevoir les messages des voyageurs dans cet établissement.",
      "whatsAppNumberHeld": "WhatsApp retient encore ce numéro. Déconnectez-le, puis connectez-le à nouveau.",
      "whatsAppNumberHint": "Indiquez ce même numéro lors de l’inscription Meta, à l’étape suivante.",
      "whatsAppNumberLabel": "Numéro WhatsApp",
      "whatsAppReconnected": "WhatsApp reconnecté",
      "whatsAppSettingUp": "Généralement quelques minutes. Vous pouvez quitter cet écran : la configuration se termine toute seule.",
      "whatsAppSettingUpTitle": "Configuration de votre numéro avec WhatsApp",
      "whatsAppSubtitle": "Les messages des voyageurs sur le numéro de l’établissement",
      "whatsAppUnavailable": "La connexion de WhatsApp n’est pas disponible dans cet environnement."
    },
    "loadErrorRetry": {
      "retry": "Réessayer"
    },
    "municipalitySection": {
      "countryPending": "Le pays de l’établissement vient de changer. Ses communes s’afficheront ici dès que la modification sera parvenue à Vidimo.",
      "loadFailed": "Impossible de charger la commune. Vérifiez votre connexion.",
      "noCountry": "Ajoutez d’abord l’adresse et le pays de l’établissement dans <link>Général</link>.",
      "noMatch": "Aucune commune ne correspond",
      "notListed": "Vidimo ne dispose pas encore de la liste des communes de ce pays.",
      "pickFailed": "Impossible d’enregistrer la commune. Réessayez.",
      "placeholder": "Choisir une commune",
      "retired": "Cette commune ne figure plus sur la liste officielle. Choisissez celle qui l’a remplacée.",
      "retry": "Réessayer",
      "searchFailed": "Impossible de rechercher. Vérifiez votre connexion.",
      "searchLabel": "Rechercher une commune",
      "searching": "Recherche…",
      "source": "{method, select, host {Choisie par vous} address_register {D’après votre adresse} other {Définie pour cet établissement}}",
      "title": "Commune",
      "typeToSearch": "Saisissez un nom pour rechercher"
    },
    "notificationsView": {
      "complianceDescription": "Les déclarations de voyageurs bloquées qui vous attendent, avec le motif et l’échéance, ainsi que les voyageurs dont l’arrivée n’est pas encore enregistrée à l’approche de l’échéance",
      "complianceLabel": "Échéances de déclaration",
      "messagesDescription": "Nouveaux messages des voyageurs et de votre équipe",
      "messagesLabel": "Messages",
      "reservationsDescription": "Nouvelles réservations, arrivées, annulations et empreintes bancaires expirées avant le départ",
      "reservationsLabel": "Réservations",
      "tasksDescription": "Tâches qui vous sont confiées, chambres libres pour le ménage ou à rafraîchir, et chambres dont vous faites le ménage, pas encore prêtes pour une arrivée",
      "tasksLabel": "Tâches",
      "title": "Notifications"
    },
    "operationalState": {
      "badge": "En préparation",
      "blocked": "Cet établissement est en préparation : Vidimo ne le gère pas encore. Votre système actuel s’occupe toujours de ses réservations et de ses voyageurs.",
      "description": "Votre système actuel le gère encore. Configurez-le et explorez librement : rien de ce que vous faites ici ne parvient encore aux voyageurs, aux canaux ni aux autorités.",
      "importBookings": "Importer vos réservations",
      "noConnections": "Les canaux, WhatsApp, Instagram et les numéros de téléphone ne peuvent pas être connectés.",
      "noFilings": "Aucune déclaration de voyageurs ni de statistiques n’est transmise.",
      "noGuestContact": "Les voyageurs ne reçoivent ni messages, ni liens d’enregistrement, ni demandes de paiement.",
      "noReservations": "Les réservations ne peuvent être ni créées, ni modifiées, ni annulées.",
      "privateWebsite": "Votre site et votre page de réservation restent privés.",
      "title": "Cet établissement est en préparation"
    },
    "parkingEditor": {
      "addParking": "Ajouter un parking",
      "addPhotos": "Ajouter des photos",
      "cancel": "Annuler",
      "checkOnMap": "Vérifier sur la carte",
      "delete": "Supprimer ce parking",
      "directionsLabel": "Accès",
      "directionsPlaceholder": "Entrée par la rue de la République. Prenez un ticket à la barrière ; nous le validons à la réception.",
      "errorUpload": "Impossible d’importer cette photo.",
      "linkErrorNoLocation": "Aucun emplacement trouvé dans ce lien. Dans Google Maps, placez un repère sur l’endroit, touchez Partager et collez ce lien ici.",
      "linkErrorNotGoogle": "Seuls les liens Google Maps fonctionnent ici. Ouvrez l’endroit dans Google Maps, touchez Partager et collez ce lien.",
      "linkErrorTooLong": "{count, plural, one {Ce lien est trop long pour être conservé (plus de {count} caractère). Placez plutôt un repère dans Google Maps et partagez-le.} other {Ce lien est trop long pour être conservé (plus de {count} caractères). Placez plutôt un repère dans Google Maps et partagez-le.}}",
      "linkErrorUnreadable": "Impossible de lire ce lien. Vérifiez votre connexion et réessayez.",
      "locationLabel": "Emplacement",
      "mapsLinkHint": "Pour un endroit sans adresse, placez un repère dans Google Maps et collez son lien. Facultatif : laissez vide si les indications d’accès suffisent.",
      "mapsLinkLabel": "Lien Google Maps",
      "mapsLinkPlaceholder": "Ou collez un lien Google Maps",
      "nameLabel": "Nom",
      "namePlaceholder": "Parking de la place Bellecour",
      "photoAlt": "Parking {number}",
      "photosHint": "{count, plural, one {L’entrée, la barrière ou la place : jusqu’à # photo. Les captures d’écran fonctionnent aussi.} other {L’entrée, la barrière ou la place : jusqu’à # photos. Les captures d’écran fonctionnent aussi.}}",
      "photosLabel": "Photos",
      "pinnedAt": "Repère à {latitude}, {longitude}",
      "removeLocation": "Retirer l’emplacement",
      "removePhoto": "Retirer la photo {number}",
      "save": "Enregistrer",
      "searchAddress": "Rechercher une adresse",
      "searchDifferentAddress": "Rechercher une autre adresse",
      "uploading": "Import…",
      "useLink": "Utiliser le lien"
    },
    "parkingEditorPage": {
      "deleted": "{label} supprimé.",
      "deleting": "Suppression…",
      "errorDelete": "Impossible de supprimer le parking. Réessayez.",
      "errorRestore": "Impossible de restaurer le parking. Ajoutez-le de nouveau.",
      "errorSave": "Impossible d’enregistrer le parking. Réessayez.",
      "newTitle": "Nouveau parking",
      "notFound": "Ce parking a été supprimé ou n’a jamais existé.",
      "saved": "Parking enregistré.",
      "title": "Parking",
      "undo": "Annuler"
    },
    "parkingPage": {
      "add": "Ajouter un parking",
      "emptyDescription": "Ajoutez le garage, la rue ou le terrain qu’utilisent vos voyageurs, avec l’accès et une photo de l’entrée.",
      "emptyTitle": "Aucun parking pour l’instant",
      "errorReorder": "Impossible de modifier l’ordre. Réessayez.",
      "intro": "Indiquez aux voyageurs où garer leur voiture. Ils le voient avant leur arrivée, pour préparer le trajet, et pendant tout leur séjour.",
      "loading": "Chargement de vos parkings…",
      "moveDown": "Descendre {label}",
      "moveUp": "Monter {label}",
      "photoCount": "{count, plural, one {{count} photo} other {{count} photos}}",
      "pinnedLocation": "Emplacement repéré",
      "title": "Parking"
    },
    "passwordDialog": {
      "cancel": "Annuler",
      "changeDescription": "Saisissez votre mot de passe actuel, puis choisissez-en un nouveau. Vous restez connecté ici ; vos autres appareils sont déconnectés.",
      "changeSubmit": "Changer le mot de passe",
      "changeTitle": "Changer le mot de passe",
      "confirmPasswordLabel": "Confirmer le nouveau mot de passe",
      "confirmPasswordPlaceholder": "Saisissez à nouveau votre mot de passe",
      "currentPasswordLabel": "Mot de passe actuel",
      "errorCurrentRequired": "Saisissez votre mot de passe actuel",
      "errorMismatch": "Les mots de passe ne correspondent pas",
      "errorNotSaved": "Impossible d’enregistrer votre mot de passe. Réessayez.",
      "errorTooShort": "Le mot de passe doit contenir au moins {count, plural, one {# caractère} other {# caractères}}",
      "newPasswordLabel": "Nouveau mot de passe",
      "newPasswordPlaceholder": "{count, plural, one {# caractère} other {# caractères}} minimum",
      "setDescription": "Choisissez un mot de passe pour pouvoir aussi vous connecter avec votre adresse e-mail. Vos modes de connexion actuels continuent de fonctionner.",
      "setSubmit": "Définir le mot de passe",
      "setTitle": "Définir un mot de passe",
      "submitPending": "Enregistrement…"
    },
    "paymentsCard": {
      "subtitle": "Encaissez les paiements par carte des voyageurs sur votre propre compte Stripe",
      "subtitleSettles": "Stripe · règlement en {currency}",
      "subtitleSettlesAccountCurrency": "Stripe · règlement dans la devise de votre compte",
      "title": "Paiements par carte"
    },
    "paymentsPage": {
      "title": "Paiements"
    },
    "paymentsView": {
      "checkAgain": "Vérifier à nouveau",
      "checkingWithStripe": "Vérification auprès de Stripe",
      "connectStripe": "Connecter un compte Stripe",
      "continueStripeSetup": "Poursuivre la configuration Stripe",
      "depositChargeBody": "Encaissez le montant d’avance. Il arrive sur votre solde Stripe ; pour le restituer, il faut le rembourser.",
      "depositChargeLabel": "Débiter",
      "depositHoldBody": "Bloquez le montant sur la carte du voyageur sans le prélever. Encaissez ce dont vous avez besoin ou libérez le reste. Vidimo maintient l’empreinte jusqu’au départ.",
      "depositHoldLabel": "Empreinte sur la carte",
      "depositsTitle": "Acomptes et cautions",
      "description": "Encaissez les paiements par carte des voyageurs sur votre propre compte Stripe. L’argent vous est versé directement : Vidimo ne prend aucune commission.",
      "errorLoad": "Impossible de charger les paramètres",
      "errorOpenStripe": "Impossible d’ouvrir Stripe",
      "errorReachStripe": "Impossible de joindre Stripe",
      "errorSave": "Impossible d’enregistrer",
      "finishingSetup": "Finalisation de la configuration avec Stripe. Cela prend généralement quelques secondes.",
      "loadFailed": "Impossible de charger vos paramètres de paiement. Votre compte Stripe et les paiements déjà encaissés ne sont pas concernés.",
      "offHint": "Laissez désactivé pour continuer à saisir les paiements à la main, comme aujourd’hui.",
      "openStripe": "Ouvrir Stripe",
      "payoutsEnabled": "Les virements sont activés.",
      "payoutsEnabledSettles": "Les virements sont activés. Règlement en {currency}.",
      "payoutsNotEnabled": "Les virements ne sont pas encore activés.",
      "payoutsNotEnabledSettles": "Les virements ne sont pas encore activés. Règlement en {currency}.",
      "statusActive": "Prêt à encaisser",
      "statusDisabled": "Désactivé par Stripe",
      "statusNotStarted": "Non connecté",
      "statusPending": "Configuration inachevée",
      "statusRestricted": "Action requise",
      "stripeAccount": "Compte Stripe",
      "stripeDashboardHint": "Les remboursements, virements et litiges se gèrent dans votre propre tableau de bord Stripe.",
      "title": "Paiements par carte",
      "tryAgain": "Réessayer",
      "unavailable": "L’encaissement par carte n’est pas encore disponible dans cet environnement."
    },
    "propertyActivityView": {
      "emptyDescription": "Les modifications des tarifs, réservations, tâches et voyageurs s’afficheront ici au fil de l’eau.",
      "emptyTitle": "Rien pour l’instant",
      "errorLoad": "Impossible de lire l’activité. Tirez pour réessayer.",
      "intro": "Qui a modifié les tarifs, réservations, tâches et voyageurs ici, et quand. Pour les tarifs, vous voyez si vos canaux les ont acceptés.",
      "loading": "Chargement…",
      "ratesChanged": "Tarifs ou règles modifiés : {nights}",
      "ratesChangedSpan": "Tarifs ou règles modifiés : {nights}, {span}",
      "title": "Activité",
      "unitsFreeUpdated": "Disponibilités mises à jour : {nights}",
      "unitsFreeUpdatedSpan": "Disponibilités mises à jour : {nights}, {span}"
    },
    "propertyBlocksView": {
      "emptyDescription": "Rien n’est fermé à la vente. Ajoutez un blocage ci-dessus pour fermer des dates.",
      "emptyTitle": "Aucune date bloquée",
      "errorAdd": "Impossible d’ajouter le blocage. Réessayez.",
      "errorRemoveRolledBack": "Impossible de supprimer le blocage. Il a été rétabli.",
      "everyUnitType": "Tous les logements {unitType}",
      "firstNight": "Première nuit",
      "fromSource": "· depuis {source}",
      "intro": "Fermez des nuits à la vente sans réservation : séjour du propriétaire, maintenance ou fermeture manuelle. Les nuits bloquées ne sont plus vendues ici ni sur vos canaux connectés.",
      "lastNight": "Dernière nuit",
      "reason": "Motif",
      "removeBlock": "Supprimer le blocage commençant le {firstNight}",
      "submit": "Bloquer les dates",
      "targetLabel": "Quoi bloquer",
      "targetPlaceholder": "Choisir un logement ou un type de logement",
      "title": "Dates bloquées",
      "unknownUnit": "Logement inconnu"
    },
    "propertyColorPicker": {
      "customPlaceholder": "#RRGGBB (personnalisée)",
      "hint": "Repère visuel utilisé dans toute l’application pour identifier cet établissement. Laissez vide pour choisir automatiquement une couleur fixe à partir de l’identifiant de l’établissement.",
      "label": "Couleur",
      "reset": "Revenir à l’automatique",
      "swatchLabel": "Choisir la couleur {color}"
    },
    "propertyEmailsView": {
      "bookingConfirmationDescription": "Envoyé quand un voyageur réserve et paie sur votre propre site. Les réservations reçues par un canal sont confirmées par ce canal, pas par nous.",
      "bookingConfirmationLabel": "Confirmation de réservation",
      "checkInInviteDescription": "Envoyée une fois, dès réception d’une réservation, pour inviter le voyageur à s’enregistrer en ligne. La désactiver vous prive aussi, avant l’arrivée, des informations voyageurs nécessaires à vos déclarations.",
      "checkInInviteLabel": "Invitation à l’enregistrement",
      "errorNotLoaded": "Impossible de charger vos paramètres d’e-mail",
      "errorNotSaved": "Impossible d’enregistrer. Réessayez.",
      "errorPreviewNotLoaded": "Impossible de charger l’aperçu",
      "intro": "Ces e-mails partent automatiquement vers vos voyageurs, depuis l’adresse de votre établissement : une réponse vous parvient donc dans Messages. Touchez Aperçu sur l’un d’eux pour voir ce que reçoit votre voyageur.",
      "paymentsNeeded": "Rien à envoyer pour l’instant : cet e-mail part quand un voyageur paie sur votre propre site, ce qui nécessite d’abord de configurer les <link>paiements par carte</link>.",
      "preview": "Aperçu",
      "signInLinkNote": "Les voyageurs peuvent aussi demander un lien de connexion pour leur séjour. Il s’agit d’un voyageur qui veut retrouver sa propre réservation : ce lien est donc toujours envoyé. Ce que vous écrivez vous-même dans Messages part quand vous l’envoyez.",
      "title": "E-mails aux voyageurs"
    },
    "propertyForm": {
      "avatarFallbackName": "Établissement",
      "cancel": "Annuler",
      "confirmPhrase": "supprimer",
      "deleteDescription": "Supprimez définitivement cet établissement et toutes ses données associées (logements, réservations, tâches). Les liens de paiement en attente cesseront de fonctionner et les empreintes sur les cartes des voyageurs seront libérées : encaissez d’abord ce qui doit l’être. Cette action est irréversible.",
      "deleteTitle": "Supprimer l’établissement",
      "descriptionHint": "Cette description sera visible par les voyageurs et les utilisateurs",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Décrivez cet établissement",
      "errorNotSaved": "Impossible d’enregistrer l’établissement. Réessayez.",
      "imageCaption": "Touchez pour changer l’image de l’établissement",
      "nameLabel": "Nom de l’établissement",
      "namePlaceholder": "Saisissez le nom de l’établissement",
      "readOnlyNotice": "Cet établissement n’a pas d’abonnement actif : ses informations ne peuvent pas être modifiées.",
      "save": "Enregistrer",
      "shortCodeHintAuto": "Rempli automatiquement à partir du nom de l’établissement. Saisissez-en un autre pour le remplacer ; videz le champ pour revenir au remplissage automatique.",
      "shortCodeHintManual": "Sert d’étiquette compacte dans les calendriers et les badges. Videz ce champ pour suivre automatiquement le nom de l’établissement.",
      "shortCodeLabel": "Code court",
      "subtitle": "Gérez les informations et l’image de l’établissement",
      "title": "Général"
    },
    "propertyIntegrationsView": {
      "communicationSubtitle": "Canaux de {name}",
      "communicationTitle": "Communication avec les voyageurs",
      "distributionSubtitle": "Où {name} reçoit des réservations",
      "distributionTitle": "Canaux de distribution",
      "loading": "Chargement…",
      "paymentsSubtitle": "Comment {name} est payé",
      "paymentsTitle": "Paiements"
    },
    "propertyMembersView": {
      "cancelInvitation": "Annuler l’invitation",
      "codeCopied": "Code d’invitation copié",
      "copyCode": "Copier le code d’invitation",
      "errorCodeNotCopied": "Copie impossible : sélectionnez le code pour le copier manuellement.",
      "invite": "Inviter",
      "invitedAs": "Invité en tant que {role}",
      "memberCount": "{count, plural, one {# membre} other {# membres}}",
      "moreActions": "Plus d’actions",
      "noMatches": "Aucun membre ne correspond à votre recherche.",
      "pendingInvitations": "Invitations en attente",
      "removeConfirm": "Retirer {name} de {property} ?",
      "removeFromProperty": "Retirer de l’établissement",
      "resend": "Renvoyer",
      "searchPlaceholder": "Rechercher un membre…",
      "title": "Membres"
    },
    "propertyNotFound": {
      "notFound": "Établissement introuvable",
      "syncing": "Synchronisation de l’établissement…"
    },
    "propertyPhotosView": {
      "addPhotos": "Ajouter des photos",
      "added": "{count, plural, one {Photo ajoutée} other {# photos ajoutées}}",
      "addedSome": "{total, plural, one {{added} sur # photo ajoutée.} other {{added} sur # photos ajoutées.}}",
      "addedSomeWithReason": "{total, plural, one {{added} sur # photo ajoutée. {reason}} other {{added} sur # photos ajoutées. {reason}}}",
      "descriptionHint": "Lue à voix haute par les lecteurs d’écran, c’est le seul texte que les moteurs de recherche reçoivent pour cette image.",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "ex. La terrasse au coucher du soleil",
      "emptyDescription": "Ajoutez des photos de l’établissement et de ses chambres. D’ici là, votre page publique n’apparaît pas dans les résultats de recherche.",
      "emptyTitle": "Aucune photo pour l’instant",
      "errorDescriptionNotSaved": "Impossible d’enregistrer la description",
      "errorNotAdded": "Impossible d’ajouter la photo",
      "errorNotMoved": "Impossible de déplacer la photo",
      "errorNotRemoved": "Impossible de supprimer la photo",
      "errorNotReordered": "Impossible de réorganiser les photos",
      "intro": "Elles apparaissent sur la page publique de votre établissement. La première ouvre la galerie et sert d’aperçu quand la page est partagée.",
      "mainGallery": "Galerie principale",
      "moveEarlier": "Avancer",
      "moveLater": "Reculer",
      "removePhoto": "Supprimer la photo",
      "removed": "Photo supprimée",
      "showsOn": "Affichée sur",
      "title": "Photos",
      "uploading": "Import…"
    },
    "propertyRatesView": {
      "addSeason": "Ajouter une saison",
      "basePerNight": "Base / nuit",
      "cancel": "Annuler",
      "editSeason": "Modifier la saison {name}",
      "editingSeason": "Modification de « {name} »",
      "ensureFailedDescription": "Impossible de créer vos plans tarifaires. Vérifiez votre connexion et réessayez.",
      "ensureFailedTitle": "Impossible de configurer la tarification",
      "errorBaseRateRolledBack": "Impossible d’enregistrer le prix par nuit. Réessayez.",
      "errorFloorRolledBack": "Impossible d’enregistrer le prix plancher. Réessayez.",
      "errorRemoveSeasonRolledBack": "Impossible de supprimer la saison. Elle a été rétablie.",
      "errorSaveSeason": "Impossible d’enregistrer la saison. Réessayez.",
      "firstNight": "Première nuit",
      "floorHint": "Aucune nuit, saison ou tarif de base ne peut descendre en dessous.",
      "floorLabel": "Prix plancher",
      "floorOwnerOnly": "Seul le propriétaire peut le modifier.",
      "intro": "Fixez un tarif de base par type de logement et tarifez des périodes avec les saisons. Les modifications se synchronisent avec vos canaux connectés.",
      "lastNight": "Dernière nuit",
      "minStay": "Séjour min.",
      "minStayPlaceholder": "Aucun",
      "noFloor": "Aucun prix plancher défini",
      "noFloorChoice": "Aucun prix plancher",
      "noSeasons": "Aucune saison. Les nuits suivent le tarif de base ci-dessus.",
      "noUnitsDescription": "Ajoutez des logements à cet établissement avant de fixer des prix.",
      "noUnitsTitle": "Aucun logement pour l’instant",
      "none": "Aucun",
      "noneFor": "{label}, aucun",
      "notSet": "Non défini",
      "occupancyReduction": "Par voyageur en moins",
      "occupancyReductionHint": "Déduit du prix par nuit pour chaque voyageur en dessous de la capacité du type de logement. Réservations directes uniquement ; les canaux sont vendus au tarif plein.",
      "openRates": "Voir et modifier les prix par nuit",
      "pricePerNight": "Prix / nuit",
      "pricePlaceholder": "Base",
      "priority": "Priorité",
      "removeSeason": "Supprimer la saison {name}",
      "saveChanges": "Enregistrer les modifications",
      "savedFloor": "Enregistré : {amount}",
      "savedNoFloor": "Enregistré : aucun prix plancher",
      "seasonBaseRate": "tarif de base",
      "seasonDates": "du {start} au {end}",
      "seasonLabel": "Saison",
      "seasonMinStay": "{count, plural, one {· min. {count} nuit} other {· min. {count} nuits}}",
      "seasonOccupancyReduction": "· −{amount} par voyageur en dessous de la capacité (direct)",
      "seasonPlaceholder": "Été 2027",
      "seasonPriority": "· priorité {priority}",
      "seasonShortStaySurcharge": "{count, plural, one {· +{amount} en dessous de {count} nuit (direct)} other {· +{amount} en dessous de {count} nuits (direct)}}",
      "seasonsExplain": "Une saison fixe le prix d’une période à la place du tarif de base, et une nuit modifiée dans le Calendrier garde son propre prix. <link>Comment fonctionnent les saisons</link>",
      "seasonsHeading": "Saisons",
      "seasonsPriorityHint": "La priorité la plus haute l’emporte quand les périodes se chevauchent",
      "settingUp": "Configuration…",
      "shortStayUnder": "Séjour court en dessous de",
      "surcharge": "Supplément",
      "surchargeHint": "Ajouté à un séjour plus court que le nombre de nuits ci-dessus. Réservations directes uniquement : les canaux reçoivent un tarif unique par nuit et ne peuvent pas l’exprimer.",
      "title": "Tarification",
      "tryAgain": "Réessayer",
      "useBaseRate": "Utiliser le tarif de base ({price})"
    },
    "propertyRegistrationView": {
      "asksBeforeSubmitting": "Vos identifiants restent enregistrés. Vidimo vous demandera votre accord avant de transmettre quoi que ce soit avec eux.",
      "checkAgainAfter": "Vous pourrez vérifier de nouveau après {time}.",
      "checkBusy": "Une vérification est déjà en cours.",
      "checkFailed": "Impossible de lancer la vérification. Merci de réessayer.",
      "checkNow": "Vérifier maintenant",
      "checkRefused": "Ces identifiants ont été refusés. Mettez-les à jour pour vérifier de nouveau.",
      "checkTooOften": "Trop de vérifications. Réessayez plus tard.",
      "checking": "Vérification…",
      "confirmDisconnect": "Déconnecter ces identifiants ? Nous les supprimerons de votre compte.",
      "confirmDisconnectChecked": "Déconnecter ces identifiants ? Nous les supprimerons de votre compte et cesserons de les vérifier.",
      "confirmDisconnectFiling": "Déconnecter ces identifiants ? Nous cesserons de déclarer auprès de ce système jusqu’à votre reconnexion.",
      "confirmDisconnectWaiting": "Déconnecter ces identifiants ? Nous les supprimerons de votre compte, et la configuration ne rouvrira pas avant que la transmission automatique soit prête.",
      "connectToCheck": "Connecter pour vérifier",
      "connectToCheckLine": "Connectez votre compte maintenant et Vidimo vérifie qu’il fonctionne. La vérification ne déclare rien.",
      "credentialsDisconnected": "Identifiants déconnectés",
      "credentialsStay": "Vos identifiants restent enregistrés et nous commencerons les transmissions dès que ce sera prêt.",
      "disconnect": "Déconnecter",
      "disconnecting": "Déconnexion…",
      "errorDisconnect": "Impossible de déconnecter. Merci de réessayer.",
      "errorLoadCredentials": "Impossible de charger les identifiants.",
      "fileEachGuestYourself": "Déclarez vous-même chaque voyageur avant l’échéance.",
      "filesFrom": "Vidimo déclare les voyageurs qui arrivent à partir du {date}. Les séjours antérieurs qu’il n’a pas pris en charge sont à déclarer par vos soins.",
      "inPreparationConnector": "Vidimo prépare vos déclarations {system} ; leur transmission automatique est en cours de développement.",
      "onFileSecret": "{label} : ••••",
      "onFileValue": "{label} : {value}",
      "setUp": "Configurer",
      "setupOpensLater": "La configuration des identifiants s’ouvrira ici dès que ce sera prêt.",
      "tryAgain": "Réessayer",
      "updateCredentials": "Mettre à jour les identifiants"
    },
    "propertySettingsView": {
      "activityDescription": "Qui a modifié les tarifs et les réservations, et quand",
      "activityTitle": "Activité",
      "blockedDatesDescription": "Fermez des nuits à la vente pour un séjour du propriétaire, de la maintenance ou une fermeture manuelle",
      "blockedDatesTitle": "Dates bloquées",
      "breakfastDescription": "Horaires, prix et lieu de service",
      "breakfastTitle": "Petit-déjeuner",
      "cleaningDescription": "À qui va chaque tâche de ménage, et la liste d’étapes qu’elle reçoit à sa création",
      "cleaningTitle": "Ménage",
      "complianceDescription": "Déclaration des voyageurs, statistiques, taxe de séjour et registre des voyageurs",
      "complianceTitle": "Conformité",
      "customDomainDescription": "Publiez votre site Places sur votre propre domaine",
      "customDomainTitle": "Domaine personnalisé",
      "generalDescription": "Nom, adresse, description et détails",
      "generalTitle": "Général",
      "groupAccount": "Compte",
      "groupGuests": "Voyageurs",
      "groupProperty": "Établissement",
      "guestEmailsDescription": "Ce que nous envoyons automatiquement à vos voyageurs, et depuis quelle adresse",
      "guestEmailsTitle": "E-mails aux voyageurs",
      "guestPortalDescription": "Ce que les voyageurs lisent sur leur page séjour, avec aperçu : accès, règlement intérieur, Wi-Fi",
      "guestPortalTitle": "Portail voyageur",
      "guestPreviewDescription": "Voyez la page séjour comme un voyageur la voit, avant l’arrivée, pendant le séjour et après le départ",
      "guestPreviewTitle": "Aperçu voyageur",
      "guestRegistryDescription": "Registre légal des personnes hébergées, avec export CSV",
      "guestRegistryTitle": "Registre des voyageurs",
      "importsDescription": "Les réservations que votre application d’IA a copiées depuis votre système actuel, comparées à ses totaux lorsqu’il les affiche",
      "importsTitle": "Réservations importées",
      "membersDescription": "Gérez qui a accès à cet établissement",
      "membersTitle": "Membres",
      "messagingDescription": "Où les voyageurs vous contactent, et les e-mails que nous envoyons pour vous",
      "messagingTitle": "Messagerie",
      "notFoundTitle": "Établissement",
      "parkingDescription": "Où se garent les voyageurs, affiché avant et pendant leur séjour",
      "parkingTitle": "Parking",
      "photosDescription": "Les photos de la page publique de votre établissement",
      "photosTitle": "Photos",
      "pricingDescription": "Prix par nuit, séjour minimum et nuits fermées de vos logements",
      "pricingTitle": "Tarification",
      "roomsDescription": "Logements, prix, dates bloquées et canaux synchronisés",
      "roomsTitle": "Logements et tarifs",
      "sectionExtras": "Services",
      "sectionHousekeeping": "Entretien",
      "sectionInventory": "Ce que vous vendez",
      "sectionMoving": "Passage à Vidimo",
      "sectionPeople": "Personnes",
      "sectionPublicPage": "Page publique",
      "sectionRecords": "Registres",
      "sectionSentAutomatically": "Envois automatiques",
      "sectionStayPage": "Page séjour",
      "siteDescription": "Votre page publique : son contenu, ses photos et son domaine, et les paiements par carte",
      "siteTitle": "Site web",
      "stayDescription": "Ce que les voyageurs lisent avant et pendant leur séjour, ainsi que le parking et le petit-déjeuner",
      "stayTitle": "Séjour voyageur",
      "teamDescription": "Membres, règles et listes de contrôle du ménage, et qui a modifié quoi",
      "teamTitle": "Équipe",
      "title": "Paramètres",
      "unitsDescription": "Gérez les logements et les types de logement",
      "unitsTitle": "Logements",
      "websiteDescription": "Histoire, points forts, avis et FAQ de votre page publique",
      "websiteTitle": "Contenu de la page"
    },
    "propertyUnitsView": {
      "clearSearch": "Effacer la recherche",
      "createUnit": "Créer un logement",
      "emptyDescription": "Créez votre premier logement pour commencer.",
      "emptyTitle": "Aucun logement pour l’instant",
      "maxGuests": "{count, plural, one {{count} voyageur} other {{count} voyageurs}}",
      "noMatchDescription": "Essayez un autre terme ou effacez la recherche.",
      "noMatchTitle": "Aucun logement ne correspond à votre recherche",
      "searchPlaceholder": "Rechercher un logement…",
      "title": "Logements"
    },
    "propertyWebsiteView": {
      "activitiesIntroLabel": "Introduction",
      "activitiesIntroPlaceholder": "Que faire à proximité ?",
      "activityBlurbPlaceholder": "Sur la rivière émeraude",
      "activityTitlePlaceholder": "Kayak",
      "addActivity": "Ajouter une activité",
      "addDistance": "Ajouter une distance",
      "addHighlight": "Ajouter un point fort",
      "addQuestion": "Ajouter une question",
      "addReview": "Ajouter un avis",
      "defaultsToPropertyName": "Par défaut, le nom de l’établissement",
      "enquiryLabel": "Afficher un bouton de contact WhatsApp",
      "errorImageNotUploaded": "Impossible d’importer l’image",
      "errorNotLoaded": "Impossible de charger le contenu de votre site",
      "errorNotSaved": "Impossible d’enregistrer vos modifications",
      "facebookLabel": "URL Facebook",
      "faqAnswerPlaceholder": "Réponse",
      "faqQuestionPlaceholder": "Question",
      "headlineLabel": "Titre personnalisé",
      "highlightIconPlaceholder": "Icône (ex. waves)",
      "highlightLabelPlaceholder": "Piscine",
      "highlightSublabelPlaceholder": "Ouverte de mai à novembre",
      "instagramLabel": "Compte Instagram",
      "instagramPlaceholder": "votrehotel",
      "intro": "Tout ce qui figure ici apparaît sur la page publique de votre établissement. Laissez une section vide pour la masquer.",
      "loadFailed": "Impossible de charger le contenu de votre site.",
      "locationIntroLabel": "Présentation du quartier",
      "locationIntroPlaceholder": "Ce qu’il y a à proximité, en une ou deux phrases",
      "nearbyLabelPlaceholder": "Place du village",
      "nearbyValuePlaceholder": "2 min à pied",
      "off": "Désactivé",
      "on": "Activé",
      "remove": "Supprimer",
      "removeImage": "Supprimer l’image",
      "replacePhoto": "Remplacer la photo",
      "reviewAuthorPlaceholder": "Nom",
      "reviewLocationPlaceholder": "Ville (facultatif)",
      "reviewQuotePlaceholder": "Ce qu’a dit le voyageur",
      "reviewRatingPlaceholder": "Note de 1 à 5",
      "reviewSourcePlaceholder": "TripAdvisor (facultatif)",
      "saveChanges": "Enregistrer les modifications",
      "saved": "Site mis à jour",
      "sectionEnquiries": "Demandes",
      "sectionFaqs": "FAQ",
      "sectionHero": "En-tête",
      "sectionHighlights": "Points forts",
      "sectionLocation": "Localisation",
      "sectionReviews": "Avis",
      "sectionSearch": "Référencement (SEO)",
      "sectionSocial": "Réseaux sociaux",
      "sectionStory": "Histoire",
      "sectionThingsToDo": "À faire",
      "seoDescriptionLabel": "Méta-description",
      "seoDescriptionPlaceholder": "Une ou deux phrases pour les résultats de recherche",
      "seoTitleLabel": "Titre de page personnalisé",
      "storyImageLabel": "Image de l’histoire",
      "storyLabel": "Votre histoire",
      "storyPlaceholder": "Comment ce lieu est né…",
      "taglineLabel": "Accroche",
      "taglinePlaceholder": "Une phrase courte qui donne envie de séjourner",
      "tiktokLabel": "URL TikTok",
      "title": "Contenu de la page",
      "tryAgain": "Réessayer",
      "uploadPhoto": "Importer une photo",
      "viewPublicPage": "Voir la page publique"
    },
    "registrationCards": {
      "comingBody": "Vidimo prend en charge la déclaration des voyageurs et la taxe de séjour pays par pays, et le pays de votre établissement n’est pas encore couvert. D’ici là, continuez à les gérer comme vous le faites aujourd’hui. Si vous en avez besoin pour {name}, faites-le-nous savoir : nous vous préviendrons dès que ce sera disponible.",
      "comingTitle": "D’autres pays à venir",
      "filesGuests": "déclaration des voyageurs",
      "filesStatistics": "statistiques",
      "filesTouristTax": "taxe de séjour",
      "pickMunicipality": "Choisissez votre commune pour configurer les intégrations.",
      "registrationSubtitle": "Transmission des déclarations aux autorités pour {name}",
      "registrationTitle": "Déclaration des voyageurs",
      "statisticsNotCovered": "Vidimo ne transmet pas encore les statistiques du tourisme pour la région de votre commune : continuez à les envoyer vous-même à votre office régional des statistiques.",
      "statisticsSubtitle": "Déclarations statistiques du tourisme pour {name}",
      "statisticsTitle": "Statistiques"
    },
    "registrationCredentialForm": {
      "beforeYouStart": "Avant de commencer",
      "checkNotice": "À l’enregistrement, Vidimo se connecte à {system} et vérifie une fiche de test. La vérification ne déclare rien.",
      "checkNoticeAsks": "À l’enregistrement, Vidimo se connecte à {system} et vérifie une fiche de test. La vérification ne déclare rien, et Vidimo vous demandera votre accord avant de transmettre un voyageur.",
      "chooseFile": "Choisir un fichier",
      "connect": "Connecter",
      "errorInvalid": "Impossible d’enregistrer. Vérifiez les valeurs saisies et réessayez.",
      "errorPlaceChanged": "Impossible d’enregistrer : {system} n’est pas proposé là où se trouve désormais votre établissement. Vérifiez sa commune.",
      "errorReadFile": "Impossible de lire ce fichier.",
      "errorSave": "Impossible d’enregistrer les identifiants. Merci de réessayer.",
      "fileOnFile": "enregistré",
      "fileOnFileNamed": "{name} enregistré",
      "noFileSelected": "Aucun fichier sélectionné",
      "openAuthority": "Ouvrir {authority}",
      "replaceFile": "Remplacer le fichier",
      "saved": "Identifiants enregistrés",
      "savedAlreadyRefused": "Enregistrés. {system} les avait déjà refusés : ils n’ont pas été revérifiés",
      "savedNoAnswer": "Enregistrés. {system} n’a pas répondu à la vérification",
      "savedNotChecked": "Enregistrés. Pas encore vérifiés",
      "savedRefused": "Enregistrés, mais {system} les a refusés",
      "savedRefusedAccount": "Enregistrés, mais {system} a refusé la vérification pour ce compte",
      "savedUnreadable": "Enregistrés, mais Vidimo n’a pas pu les lire",
      "savedWorks": "Enregistrés. Votre compte fonctionne",
      "secretOnFilePlaceholder": "•••••••• enregistré. Laissez vide pour le conserver.",
      "update": "Mettre à jour"
    },
    "integrationPage": {
      "changeMunicipality": "Modifier la commune dans Conformité",
      "deadline": "Échéance",
      "deadlineFromArrival": "{hours, plural, one {{hours} h après l’arrivée} other {{hours} h après l’arrivée}}",
      "deadlineFromArrivalWithDeparture": "{hours, plural, one {{hours} h après l’arrivée ; départ également déclaré} other {{hours} h après l’arrivée ; départ également déclaré}}",
      "deadlineShortStay": "{hours, plural, one {{hours} h} other {{hours} h}} si le séjour dure {maxStayHours, plural, one {{maxStayHours} h} other {{maxStayHours} h}} ou moins",
      "disconnectAccount": "Vous pouvez déconnecter le compte configuré précédemment.",
      "lawRequires": "Ce que la loi exige",
      "loginTitle": "Connexion à {system}",
      "municipality": "Commune",
      "noMunicipality": "Choisissez la commune de votre établissement pour que Vidimo sache que {system} s’y applique.",
      "notFound": "Intégration introuvable",
      "notOffered": "{system} n’est pas proposé dans le pays de votre établissement. Vérifiez son adresse.",
      "notPicked": "Pas encore choisie",
      "pickMunicipality": "Choisir la commune dans Conformité",
      "propertyTitle": "Votre hébergement sur {system}",
      "regionMoved": "Ces identifiants concernent la région {onFile}, mais votre commune relève de la région {current}. Mettez-les à jour avec votre compte pour la région {current}.",
      "regionNotCovered": "Vidimo ne transmet pas encore les statistiques pour la région de votre commune.",
      "reportsTo": "Relève de",
      "requiredFields": "Requis pour chaque voyageur déclaré",
      "requiredOfHead": "{field} (chef de famille ou de groupe)",
      "scopeAllGuests": "Tous les voyageurs",
      "scopeForeignGuestsOnly": "Voyageurs étrangers uniquement",
      "setBy": "Fixé par <bases></bases>",
      "who": "Qui"
    },
    "roleSelect": {
      "changeRoleFrom": "Changer le rôle {role}",
      "title": "Changer de rôle"
    },
    "searchSortBar": {
      "sortAscending": "Trier de A à Z (cliquez pour Z à A)",
      "sortDescending": "Trier de Z à A (cliquez pour A à Z)"
    },
    "settingsRowStates": {
      "breakfastOff": "Désactivé",
      "breakfastOn": "Activé",
      "members": "{count, plural, one {# personne} other {# personnes}}",
      "parking": "{count, plural, =0 {Aucune pour l’instant} one {# place} other {# places}}",
      "photos": "{count, plural, =0 {Aucune pour l’instant} one {# photo} other {# photos}}",
      "units": "{count, plural, =0 {Aucun pour l’instant} one {# logement} other {# logements}}"
    },
    "signInMethods": {
      "apple": "Apple",
      "credential": "E-mail et mot de passe",
      "google": "Google"
    },
    "signInSecuritySection": {
      "changePassword": "Changer le mot de passe",
      "connect": "Connecter",
      "description": "Les moyens d’ouvrir ce compte. Ajoutez-en un deuxième pour ne jamais rester bloqué si un fournisseur est indisponible.",
      "errorLoad": "Impossible de charger vos modes de connexion. Vérifiez votre connexion et réessayez.",
      "errorOffline": "Vous êtes hors ligne : vos modes de connexion ne peuvent pas être chargés pour le moment.",
      "errorPasswordNotChanged": "Impossible de changer votre mot de passe. Réessayez.",
      "errorSessionNotFresh": "Pour votre sécurité, déconnectez-vous puis reconnectez-vous avant de supprimer un mode de connexion.",
      "errorUnlinkFailed": "Impossible de supprimer ce mode de connexion.",
      "errorWrongCurrentPassword": "Ce n’est pas votre mot de passe actuel. Réessayez.",
      "loading": "Chargement de vos modes de connexion…",
      "remove": "Supprimer",
      "setPassword": "Définir un mot de passe",
      "statusConnected": "Connecté",
      "statusNoPassword": "Aucun mot de passe",
      "statusNotConnected": "Non connecté",
      "statusOnlyMethod": "Votre seul moyen de connexion",
      "statusPasswordSet": "Mot de passe défini",
      "title": "Connexion et sécurité"
    },
    "staffAvailabilityForm": {
      "addTimeOff": "Ajouter une absence",
      "addWindow": "Ajouter un créneau",
      "dayLabel": "Jour",
      "endLabel": "Fin <optional>(facultatif)</optional>",
      "errorTimeOffNotAdded": "Impossible d’ajouter l’absence. Réessayez.",
      "errorTimeOffNotRemoved": "Impossible de supprimer l’absence. Elle a été rétablie.",
      "errorWindowNotAdded": "Impossible d’ajouter les horaires. Réessayez.",
      "errorWindowNotRemoved": "Impossible de supprimer ces horaires. Ils ont été rétablis.",
      "fromLabel": "De",
      "noTimeOff": "Aucune absence enregistrée.",
      "noWindows": "Aucun créneau pour l’instant : {name} apparaît comme indisponible partout.",
      "noteLabel": "Note",
      "notePlaceholder": "Facultatif (ex. dentiste)",
      "removeTimeOff": "Supprimer l’absence",
      "removeWindow": "Supprimer le créneau",
      "startLabel": "Début",
      "timeOffTitle": "Absences",
      "title": "Disponibilités",
      "toLabel": "À",
      "viewOnly": "Lecture seule : les disponibilités sont définies par un propriétaire ou un gérant.",
      "weeklyDescription": "{name} est disponible sur ces créneaux. En dehors, vous pouvez toujours lui affecter ponctuellement une tâche à la main.",
      "weeklyTitle": "Disponibilités hebdomadaires",
      "windowRange": "{day} {start}–{end}"
    },
    "staffTaskFunctionsForm": {
      "description": "Une règle de ménage qui exige l’une de ces compétences ne choisit qu’une personne qui la possède. Vous pouvez toujours affecter n’importe qui à la main.",
      "errorNotSaved": "Impossible d’enregistrer cette modification. Réessayez.",
      "title": "Ce que cette personne sait faire"
    },
    "statisticsFilingsHistory": {
      "description": "Déclarations de nuitées transmises à votre office régional des statistiques du tourisme.",
      "errorRetry": "Impossible de relancer la déclaration. Réessayez.",
      "reference": "Référence : {reference}",
      "retry": "Réessayer",
      "retryFailedAgain": "La déclaration a de nouveau échoué.",
      "retryFiled": "Déclaration statistique transmise.",
      "retryNotWaiting": "Cette déclaration ne nécessite plus d’action de votre part.",
      "statusActionNeeded": "Action requise",
      "statusCanceled": "Annulée",
      "statusFiled": "Confirmée",
      "statusFiling": "Envoi en cours…",
      "statusRetrying": "Nouvelle tentative",
      "statusScheduled": "Programmée",
      "statusSubmitted": "Transmise",
      "title": "Déclarations statistiques"
    },
    "status": {
      "actionNeeded": "Action requise",
      "connected": "Connecté",
      "disabled": "Désactivé",
      "inPreparation": "En développement",
      "needsAttention": "Action requise",
      "notConnected": "Non connecté",
      "off": "Désactivé",
      "settingUp": "Configuration",
      "setupUnfinished": "Configuration inachevée"
    },
    "stayTimesSection": {
      "checkIn": "Arrivée à partir de",
      "checkOut": "Départ avant"
    },
    "taskCalendarFeedSection": {
      "cancel": "Annuler",
      "copyLink": "Copier le lien",
      "create": "Créer un lien d’agenda",
      "createPending": "Création du lien…",
      "description": "Suivez les tâches qui vous sont affectées dans Google Agenda, Calendrier Apple ou Outlook.",
      "errorCopy": "Impossible de copier le lien",
      "errorCreate": "Impossible de créer votre lien d’agenda. Réessayez.",
      "errorLoad": "Impossible de charger votre lien d’agenda. Vérifiez votre connexion et réessayez.",
      "errorOffline": "Vous êtes hors ligne : votre lien d’agenda ne peut pas être chargé pour le moment.",
      "errorRegenerate": "Impossible de créer un nouveau lien. Réessayez.",
      "errorTurnOff": "Impossible de désactiver votre lien. Réessayez.",
      "linkCopied": "Lien d’agenda copié",
      "linkLabel": "Lien d’agenda",
      "loading": "Chargement de votre lien d’agenda…",
      "newLink": "Nouveau lien",
      "offlineActionsNote": "Vous êtes hors ligne. La copie fonctionne toujours ; créer un nouveau lien ou le désactiver nécessite une connexion.",
      "offlineCreateNote": "Vous êtes hors ligne. La création d’un lien nécessite une connexion.",
      "privacyNote": "Toute personne disposant de ce lien peut voir vos tâches. S’il circule, créez-en un nouveau.",
      "regenerateConfirm": "Créer un nouveau lien",
      "regenerateDescription": "Votre lien actuel cesse immédiatement de fonctionner, et tout agenda qui l’utilise ne se met plus à jour tant que vous n’y ajoutez pas le nouveau.",
      "regeneratePending": "Création du lien…",
      "regenerateTitle": "Créer un nouveau lien ?",
      "subscribeHelp": "Ajoutez-le dans votre application d’agenda comme agenda depuis une URL. Les applications d’agenda vérifient les changements à leur propre rythme, ce qui peut prendre quelques heures.",
      "title": "Agenda des tâches",
      "turnOff": "Désactiver",
      "turnOffConfirm": "Désactiver",
      "turnOffDescription": "Votre lien cesse immédiatement de fonctionner, et tout agenda qui l’utilise ne se met plus à jour. Vous pouvez créer un nouveau lien ici à tout moment.",
      "turnOffPending": "Désactivation…",
      "turnOffTitle": "Désactiver votre lien d’agenda ?"
    },
    "taskRulesPage": {
      "anyone": "N’importe qui",
      "assignTo": "Affecter à",
      "defaultOperator": "Un agent de terrain (par défaut)",
      "defaultReceptionist": "Un réceptionniste (par défaut)",
      "errorSave": "Impossible d’enregistrer cette règle. Réessayez.",
      "fallbackOperator": "Aucun agent de terrain de cet établissement n’a de disponibilités définies : ces tâches sont confiées à un propriétaire ou à un gérant disponible à ce moment-là, et restent non affectées si aucun ne l’est. Pour les confier plutôt à un agent de terrain, définissez ses disponibilités dans Membres.",
      "fallbackReceptionist": "Aucun réceptionniste de cet établissement n’a de disponibilités définies : ces tâches sont confiées à un propriétaire ou à un gérant disponible à ce moment-là, et restent non affectées si aucun ne l’est. Pour les confier plutôt à un réceptionniste, définissez ses disponibilités dans Membres.",
      "formerMember": "Une personne qui a quitté cet établissement",
      "functionHint": "Définissez les compétences de chacun dans Membres.",
      "functionLabel": "Doit savoir faire",
      "hintAny": "Toutes les autres tâches de ménage, y compris celles créées à la main.",
      "hintDefaultOperator": "Confiée à l’agent de terrain disponible à ce moment-là qui a le moins de tâches dans la journée. Si aucun agent de terrain n’est disponible, elle est confiée à un propriétaire ou à un gérant disponible. Si personne ne l’est, elle reste non affectée.",
      "hintDefaultReceptionist": "Confiée au réceptionniste disponible à ce moment-là qui a le moins de tâches dans la journée. Si aucun réceptionniste n’est disponible, elle est confiée à un propriétaire ou à un gérant disponible. Si personne ne l’est, elle reste non affectée.",
      "hintFollowsAny": "Suit la règle de toutes les autres tâches de ménage, ci-dessous.",
      "loading": "Chargement des affectations de chaque ménage…",
      "noOperator": "Aucun agent de terrain, propriétaire ou gérant de cet établissement n’a de disponibilités définies : ces tâches restent non affectées. Définissez les disponibilités dans Membres.",
      "noReceptionist": "Aucun réceptionniste, propriétaire ou gérant de cet établissement n’a de disponibilités définies : ces tâches restent non affectées. Définissez les disponibilités dans Membres.",
      "noRuleFollowsAny": "Comme toutes les autres tâches de ménage",
      "noRuleKindDefaults": "Réglage par défaut de chaque type",
      "nobodyYet": "Personne pour l’instant",
      "person": "Personne",
      "personHasLeft": "Cette personne a quitté l’établissement : cette règle n’affecte donc personne. Choisissez quelqu’un d’autre.",
      "personHint": "Cette personne reçoit la tâche même en cas d’absence : un avertissement s’affiche sur la tâche.",
      "summaryOperator": "Un agent de terrain",
      "summaryOwnerOrManager": "Un propriétaire ou un gérant",
      "summaryReceptionist": "Un réceptionniste",
      "summaryUnassigned": "Non affectée",
      "unavailableDescription": "Vidimo ne peut pas les charger sur cet appareil. Touchez Réessayer : l’application sera rechargée.",
      "unavailableTitle": "Impossible de modifier les règles de tâches pour le moment"
    },
    "taxReturns": {
      "badgeMore": "Reste à payer",
      "badgeOpen": "À payer",
      "badgePaid": "Payée",
      "badgeRunning": "Ce mois-ci",
      "description": "La taxe de séjour de chaque mois, taxe de promotion comprise, calculée sur les séjours dont la dernière nuit tombe ce mois-là. Reversez-la à la commune au plus tard à l’échéance, puis marquez-la ici comme payée. Si un voyageur vous a réglé la taxe avant ce mois-là, elle est à reverser le mois qui suit ce paiement.",
      "errorMarkPaid": "Impossible de la marquer comme payée. Réessayez.",
      "markPaid": "Marquer comme payée",
      "markedPaid": "Marquée comme payée.",
      "overpaid": "Vous avez payé {amount} de plus que le montant désormais dû pour ces séjours.",
      "stays": "{count, plural, one {# séjour} other {# séjours}}",
      "summaryMore": "Encore {amount} à payer au plus tard le {date}",
      "summaryOpen": "{amount} à payer au plus tard le {date}",
      "summaryPaid": "Payé : {amount}",
      "summaryRunning": "{amount} pour l’instant, échéance le {date}",
      "title": "Paiements de la taxe de séjour",
      "uncomputed": "{count, plural, one {# séjour n’est pas encore compris dans le montant : sa taxe reste à calculer} other {# séjours ne sont pas encore compris dans le montant : leur taxe reste à calculer}}."
    },
    "taxRules": {
      "ageFrom": "les {age} ans et plus",
      "ageRange": "les {from} à {to} ans",
      "ageUnder": "les moins de {age} ans",
      "chargesNothing": "Cette commune ne perçoit pas de taxe de séjour",
      "checked": "Vérifié le {date}",
      "from": "À partir du {date} : {rule}",
      "maxNights": "{count, plural, one {dans la limite d’une nuit par séjour} other {dans la limite de # nuits par séjour}}",
      "paysFree": "exonération pour {ages}",
      "paysHalf": "demi-tarif pour {ages}",
      "paysPercent": "{percent} du taux pour {ages}",
      "perPersonNight": "{amounts} par personne et par nuit",
      "rateCategory": "{category} : {rate}",
      "ratePercent": "{percent} du prix, dans la limite de {cap}",
      "awaitsFacility": "Dans votre commune, la taxe de séjour dépend de l’emplacement de votre hébergement, de son type ou de son exploitant. Vidimo retrouve ces informations dans le registre grâce au numéro saisi dans « {field} » sur la page {system}, et affiche la taxe dès que ce numéro y correspond à votre hébergement.",
      "errorLoad": "Impossible de charger la taxe de séjour. Réessayez.",
      "notCovered": "Vidimo ne connaît pas encore la taxe de séjour applicable là où se trouve cet établissement : ses réservations n’affichent donc aucune taxe pour l’instant.",
      "source": "Source",
      "withSurcharge": "{rate} + {surcharge} {label}",
      "zone": "Tarif pour {zone}"
    },
    "timezoneField": {
      "hint": "Utilisé pour les heures d’arrivée et de départ et la planification",
      "label": "Fuseau horaire",
      "placeholder": "Choisir un fuseau horaire"
    },
    "unitForm": {
      "amenitiesLabel": "Équipements",
      "amenitiesPlaceholder": "Choisir les équipements",
      "babyCots": "Lits bébé",
      "cancel": "Annuler",
      "codeHintAuto": "{count, plural, one {Rempli automatiquement à partir du nom du logement. Saisissez-en un autre pour le remplacer ; videz le champ pour revenir au remplissage automatique. # caractère max.} other {Rempli automatiquement à partir du nom du logement. Saisissez-en un autre pour le remplacer ; videz le champ pour revenir au remplissage automatique. # caractères max.}}",
      "codeHintManual": "{count, plural, one {Étiquette compacte pour le calendrier et les listes de tâches. Ex. 101, APH-SV. Videz ce champ pour suivre automatiquement le nom du logement. # caractère max.} other {Étiquette compacte pour le calendrier et les listes de tâches. Ex. 101, APH-SV. Videz ce champ pour suivre automatiquement le nom du logement. # caractères max.}}",
      "codeLabel": "Code court",
      "codePlaceholder": "ex. 101 ou APH",
      "cotsAndExtraBeds": "Lits bébé et lits d’appoint",
      "createSubtitle": "Ajoutez un nouveau logement réservable à cet établissement",
      "createTitle": "Créer un logement",
      "deleteDescription": "Supprimez définitivement ce logement. Les réservations liées devront peut-être être mises à jour. Cette action est irréversible.",
      "deleteLabel": "Supprimer le logement",
      "descriptionHint": "Apparaît sur la page publique de la chambre et l’aide à ressortir dans les recherches.",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Décrivez cette chambre : la vue, la lumière, ce qui la rend unique. Affiché sur la page publique de la chambre.",
      "duplicate": "Dupliquer le logement",
      "editSubtitle": "Gérez les détails du logement",
      "editTitle": "Modifier le logement",
      "errorDelete": "Impossible de supprimer le logement. Réessayez.",
      "errorDuplicate": "Impossible de dupliquer le logement. Réessayez.",
      "errorSave": "Impossible d’enregistrer le logement. Réessayez.",
      "extraBeds": "Lits d’appoint",
      "maxAdults": "Adultes max.",
      "maxChildren": "Enfants max.",
      "maxChildrenPayable": "Enfants (tarif payant)",
      "maxGuests": "Voyageurs max.",
      "nameLabel": "Nom",
      "namePlaceholder": "ex. Chambre 101 ou Appartement A",
      "occupancy": "Capacité",
      "save": "Enregistrer",
      "sizeLabel": "Surface",
      "sizePlaceholder": "ex. 25",
      "sizeUnitLabel": "Unité",
      "smokingAllowed": "Fumeur",
      "smokingLabel": "Politique tabac",
      "smokingNonSmoking": "Non-fumeur",
      "smokingPlaceholder": "Choisir une politique",
      "smokingUnknown": "Inconnue",
      "unitTypeLabel": "Type de logement",
      "unitTypePlaceholder": "Choisir un type de logement"
    },
    "unitsEdit": {
      "notFound": "Logement introuvable"
    },
    "unlinkMethodDialog": {
      "cancel": "Annuler",
      "confirm": "Supprimer",
      "confirmPending": "Suppression…",
      "description": "Vous ne pourrez plus vous connecter avec {method}. Vos autres modes de connexion continuent de fonctionner, et vous pourrez le reconnecter depuis cet écran.",
      "title": "Supprimer {method} ?"
    },
    "wifiSection": {
      "hidePassword": "Masquer le mot de passe Wi-Fi",
      "hint": "Affiché aux voyageurs à partir du jour d’arrivée, dès que le nom du réseau et le mot de passe sont renseignés. Le mot de passe n’est jamais inclus dans les brouillons de l’IA.",
      "label": "Wi-Fi",
      "passwordLabel": "Mot de passe Wi-Fi",
      "passwordPlaceholder": "Mot de passe",
      "revealPassword": "Afficher le mot de passe Wi-Fi",
      "ssidLabel": "Nom du réseau Wi-Fi",
      "ssidPlaceholder": "Nom du réseau"
    }
  },

  "setup": {
    "setupBookingsStep": {
      "continue": "Continuer",
      "description": "Votre application d’IA peut les importer dans Vidimo, pour ne pas avoir à tenir deux calendriers.",
      "fresh": "Non, je pars de zéro",
      "import": "Oui, je veux les importer",
      "imported": "Réservations importées depuis {source}.",
      "openImports": "Ouvrir « Réservations importées »",
      "results": "Vous pouvez aussi le faire plus tard depuis un ordinateur. Le prompt à copier et les résultats de vos imports vous attendent dans les paramètres.",
      "skip": "Plus tard",
      "title": "Gérez-vous déjà vos réservations dans un autre système ?"
    },
    "setupEmptyState": {
      "calendarDescription": "Terminez la configuration de votre établissement et de vos logements pour voir vos réservations dans le calendrier.",
      "calendarTitle": "Votre calendrier des réservations s’affichera ici",
      "chatsDescription": "Terminez la configuration de votre établissement : les messages des voyageurs, les réservations et les réponses de l’IA arriveront ici.",
      "chatsTitle": "Vos conversations avec les voyageurs seront ici",
      "setUp": "Configurer votre établissement",
      "skip": "Plus tard",
      "tasksDescription": "Terminez la configuration de votre établissement pour confier le ménage, les arrivées et la maintenance à votre équipe.",
      "tasksTitle": "Les tâches de votre équipe s’afficheront ici",
      "todayDescription": "Terminez la configuration de votre établissement : les arrivées, les départs et les voyageurs sur place de chaque jour s’afficheront ici.",
      "todayTitle": "Votre journée commencera ici"
    },
    "setupEssentialsStep": {
      "addressHint": "Recherchez et sélectionnez l’adresse pour situer l’établissement et renseigner le pays.",
      "addressLabel": "Adresse",
      "addressPlaceholder": "Rechercher l’adresse de l’établissement…",
      "continue": "Enregistrer et continuer",
      "description": "L’essentiel sur lequel comptent vos voyageurs et votre équipe. Vous pourrez tout affiner plus tard dans les paramètres.",
      "errorNotSaved": "Impossible d’enregistrer les informations de l’établissement. Réessayez.",
      "nameLabel": "Nom de l’établissement *",
      "namePlaceholder": "Saisissez le nom de l’établissement",
      "timezoneConfirm": "Confirmer",
      "timezoneDetected": "Détecté depuis cet appareil : non enregistré tant que vous ne le confirmez pas ou ne choisissez pas d’adresse.",
      "timezoneHint": "Utilisé pour les heures d’arrivée et de départ et la planification.",
      "timezoneLabel": "Fuseau horaire",
      "timezonePlaceholder": "Choisir un fuseau horaire",
      "title": "L’essentiel de l’établissement"
    },
    "setupStepLayout": {
      "back": "Retour",
      "saving": "Enregistrement…",
      "skip": "Passer"
    },
    "setupSummaryStep": {
      "addressLabel": "Adresse",
      "bookingsImported": "Importées depuis {source}",
      "bookingsLabel": "Réservations",
      "bookingsNone": "Aucune à importer",
      "bookingsNotYet": "Pas encore",
      "descriptionComplete": "Tout est prêt. Votre établissement peut tourner.",
      "descriptionIncomplete": "Vous pouvez terminer maintenant et compléter l’essentiel restant à tout moment depuis les paramètres.",
      "finish": "Terminer la configuration",
      "finishAnyway": "Terminer quand même",
      "invitesNone": "Aucune invitation pour l’instant (facultatif)",
      "invitesPending": "{count, plural, one {{count} invitation en attente} other {{count} invitations en attente}}",
      "nameLabel": "Nom de l’établissement",
      "notSet": "Pas encore défini",
      "teamLabel": "Équipe",
      "timezoneLabel": "Fuseau horaire",
      "title": "Récapitulatif",
      "unitsAdded": "{count, plural, one {{count} logement ajouté} other {{count} logements ajoutés}}",
      "unitsLabel": "Logements",
      "unitsNone": "Ajoutez au moins un logement"
    },
    "setupTeamStep": {
      "continue": "Continuer",
      "description": "Invitez un collègue à vous aider à gérer l’établissement. C’est facultatif : vous pourrez toujours le faire plus tard.",
      "emailHint": "Nous lui enverrons par e-mail un lien pour rejoindre l’équipe, avec un code d’invitation à saisir dans l’application.",
      "emailLabel": "E-mail",
      "emailPlaceholder": "nom@exemple.fr",
      "errorNotSent": "Impossible d’envoyer l’invitation.",
      "invitationPending": "{role} · invitation en attente",
      "invitationSent": "Invitation envoyée",
      "noPermission": "Vous n’avez pas l’autorisation d’inviter des membres dans cet établissement.",
      "roleLabel": "Rôle",
      "rolePlaceholder": "Choisir un rôle",
      "send": "Envoyer l’invitation",
      "sending": "Envoi…",
      "skip": "Plus tard",
      "title": "Invitez votre équipe"
    },
    "setupUnitsStep": {
      "add": "Ajouter un logement",
      "adding": "Ajout…",
      "continue": "Continuer",
      "description": "Ajoutez les chambres ou appartements que les voyageurs peuvent réserver. Il en faut au moins un ; vous pourrez en ajouter à tout moment dans les paramètres.",
      "errorNotAdded": "Impossible d’ajouter le logement. Réessayez.",
      "errorNotRemoved": "Impossible de supprimer le logement. Réessayez.",
      "maxGuestsLabel": "Voyageurs max.",
      "nameLabel": "Nom du logement",
      "namePlaceholder": "ex. Chambre 101 ou Appartement A",
      "remove": "Supprimer {name}",
      "skip": "Plus tard",
      "title": "Logements",
      "typeLabel": "Type",
      "typePlaceholder": "Choisir un type",
      "typeSleeps": "{count, plural, one {{type} · {count} couchage} other {{type} · {count} couchages}}",
      "unitFallback": "Logement"
    },
    "setupWizard": {
      "skipSetup": "Passer la configuration",
      "stepBookings": "Réservations",
      "stepEssentials": "Essentiel",
      "stepReview": "Récapitulatif",
      "stepTeam": "Équipe",
      "stepUnits": "Logements",
      "subtitle": "Préparez votre établissement",
      "titleNamed": "Configurer {name}",
      "titleUnnamed": "Configurer votre établissement"
    }
  },

  "shell": {
    "appHeader": {
      "search": "Rechercher"
    },
    "appNavRail": {
      "label": "Navigation principale"
    },
    "auditFormatting": {
      "fieldLabel": {
        "assignedTo": "personne affectée",
        "description": "description",
        "endAt": "départ",
        "expectedArrivalTime": "heure d’arrivée prévue",
        "linkedGuest": "Lien voyageur",
        "mergedDuplicate": "Fusion",
        "startAt": "arrivée",
        "status": "statut",
        "taxNote": "note fiscale",
        "title": "titre",
        "type": "type",
        "unitId": "logement"
      },
      "fromTo": "de {from} à {to}",
      "none": "aucun",
      "withheldChange": "{kind, select, added {ajouté} removed {supprimé} other {modifié}}",
      "withheldField": "{field} {kind, select, added {ajouté} removed {supprimé} other {modifié}}"
    },
    "auditTimeline": {
      "bySupport": "Assistance Vidimo pour le compte de {actor}",
      "changeTo": "à",
      "headline": {
        "guestCreate": "Voyageur ajouté : {summary}",
        "guestDelete": "Voyageur supprimé : {summary}",
        "guestUpdate": "Voyageur modifié : {summary}",
        "rateCreate": "Tarifs ajoutés : {summary}",
        "rateDelete": "Tarifs supprimés : {summary}",
        "rateUpdate": "Tarifs modifiés : {summary}",
        "reservationCreate": "Réservation ajoutée : {summary}",
        "reservationDelete": "Réservation supprimée : {summary}",
        "reservationUpdate": "Réservation modifiée : {summary}",
        "taskCreate": "Tâche ajoutée : {summary}",
        "taskDelete": "Tâche supprimée : {summary}",
        "taskMissTakenBack": "Tâche de nouveau à faire : le voyageur n’est finalement pas arrivé",
        "taskMissed": "Tâche manquée : le voyageur est arrivé avant qu’elle soit faite",
        "taskUpdate": "Tâche modifiée : {summary}"
      },
      "byVidimo": "Vidimo",
      "onBehalf": "{agent} (assistance Vidimo) pour le compte de {actor}",
      "open": {
        "guest": "Ouvrir le voyageur",
        "reservation": "Ouvrir la réservation",
        "task": "Ouvrir la tâche"
      },
      "title": "Activité",
      "unknownActor": "Inconnu"
    },
    "avatarUpload": {
      "chooseImage": "Choisir une image",
      "errorUpload": "Impossible d’envoyer l’image. Merci de réessayer."
    },
    "connectionStatusBanner": {
      "backendUnreachable": "Vidimo est injoignable. Vos modifications se synchroniseront dès son retour.",
      "changesNotSent": "Certaines modifications n’ont pas encore été envoyées. Gardez l’application ouverte pendant que nous réessayons.",
      "deviceOffline": "Vous êtes hors ligne. Vos modifications se synchroniseront à votre retour."
    },
    "copyRecordLink": {
      "copied": "Lien copié",
      "errorNotCopied": "Impossible de copier le lien"
    },
    "deviceReplica": {
      "clearDatabase": {
        "cancel": "Conserver",
        "confirm": "Effacer quand même",
        "unsynced": "{count, plural, one {{count} modification sur cet appareil n’est pas encore synchronisée. Si vous effacez maintenant, elle sera supprimée de cet appareil et n’arrivera jamais sur Vidimo.} other {{count} modifications sur cet appareil ne sont pas encore synchronisées. Si vous effacez maintenant, elles seront supprimées de cet appareil et n’arriveront jamais sur Vidimo.}}",
        "unsyncedUnknown": "Certaines modifications sur cet appareil ne sont peut-être pas encore synchronisées. Si vous effacez maintenant, elles seront supprimées de cet appareil et n’arriveront jamais sur Vidimo."
      },
      "signOut": {
        "cancel": "Rester connecté",
        "confirm": "Se déconnecter quand même",
        "unsynced": "{count, plural, one {{count} modification sur cet appareil n’est pas encore synchronisée. Si vous vous déconnectez maintenant, elle sera supprimée de cet appareil et n’arrivera jamais sur Vidimo.} other {{count} modifications sur cet appareil ne sont pas encore synchronisées. Si vous vous déconnectez maintenant, elles seront supprimées de cet appareil et n’arriveront jamais sur Vidimo.}}",
        "unsyncedUnknown": "Certaines modifications sur cet appareil ne sont peut-être pas encore synchronisées. Si vous vous déconnectez maintenant, elles seront supprimées de cet appareil et n’arriveront jamais sur Vidimo."
      },
      "signOutFailed": "Impossible de vous déconnecter. Vérifiez votre connexion et réessayez.",
      "signOutOffline": "Vous êtes hors ligne. Connectez-vous à Internet pour vous déconnecter ; tout reste sur cet appareil d’ici là.",
      "unsyncedTitle": "Modifications non synchronisées"
    },
    "errorBoundary": {
      "description": "Rechargez l’application pour continuer.",
      "reload": "Recharger l’application",
      "title": "Une erreur est survenue"
    },
    "loading": "Chargement…",
    "mrzScanner": {
      "alreadyOnBooking": "{name} figure déjà sur cette réservation. {outcome}",
      "confirm": "Confirmer",
      "correctBody": "En enregistrant, vous renvoyez les informations corrigées pour toute déclaration encore due ou refusée ; une déclaration déjà acceptée par l’autorité n’est pas renvoyée.",
      "correctionSaved": "Fiche du voyageur enregistrée.",
      "errorNoReservation": "Impossible de savoir de quelle réservation il s’agit. Rouvrez la réservation et réessayez.",
      "errorNotAccepted": "Les informations n’ont pas été acceptées. Comparez-les au document et réessayez.",
      "errorNotOnBooking": "Cette personne ne figure plus sur cette réservation. Rouvrez la réservation pour voir qui y figure.",
      "errorPartyFull": "Cette réservation compte déjà tous les voyageurs attendus. Pour ajouter quelqu’un, augmentez d’abord le nombre d’adultes, d’enfants ou de bébés. Pour scanner une personne déjà sur la réservation, touchez l’icône de pièce d’identité sur sa ligne.",
      "errorReservationNotActive": "Cette réservation n’accepte plus d’enregistrement.",
      "errorTimedOut": "Cela prend plus de temps que prévu, mais les informations ont peut-être quand même été enregistrées. Ouvrez la « Fiche du voyageur » avant de les enregistrer à nouveau.",
      "errorUnreachable": "Impossible de joindre le serveur. Vérifiez votre connexion et réessayez.",
      "guestPickerLabel": "À qui appartient cette pièce d’identité ?",
      "noGuests": "Cette réservation n’a pas encore de voyageur : le premier scan l’ajoutera.",
      "outcomeActionNeeded": "Enregistré, mais la déclaration demande encore votre attention : ouvrez la « Fiche du voyageur » pour savoir quoi faire.",
      "outcomeFiled": "Enregistré et déclaré. L’autorité l’a confirmé.",
      "outcomeNone": "Document enregistré sur le voyageur.",
      "outcomeSubmitted": "Enregistré et transmis. En attente de confirmation.",
      "savedBlockedAuth": "Enregistré. La déclaration attend encore que vous reconnectiez le compte officiel de l’établissement (identifiants à ressaisir).",
      "savedBlockedFiledByHost": "Enregistré. Vous avez fait vous-même l’autre déclaration de ce voyageur : faites donc aussi celle-ci vous-même auprès de l’autorité.",
      "savedBlockedMissingData": "Enregistré, mais la déclaration demande encore des informations qu’elle n’a pas.",
      "savedBlockedNoConnector": "Enregistré. Vidimo ne déclare pas ce voyageur : déclarez-le vous-même auprès de l’autorité avant l’échéance.",
      "savedBlockedOtherFacility": "Enregistré. La fiche de ce voyageur a été déclarée sous un autre numéro RNO. Si le voyageur n’a pas séjourné dans l’hébergement auquel ce numéro est attribué, annulez-la sur le portail de l’autorité et déclarez-le sous le numéro actuel. Sinon, terminez-la sous ce numéro.",
      "savedBlockedUnknown": "Enregistré, mais la déclaration demande encore votre attention.",
      "savedBlockedValidation": "Enregistré, mais l’autorité rejette toujours la déclaration.",
      "scanner": {
        "back": "Retour",
        "cameraFailed": "Impossible de démarrer l’appareil photo. Vérifiez ses autorisations et réessayez.",
        "cancelScan": "Annuler le scan",
        "checkingRequirements": "Vérification de ce qu’exige la déclaration de ce séjour…",
        "chooseOneOf": "Choisissez {choices}.",
        "chooseWho": "Choisissez qui s’enregistre.",
        "close": "Fermer",
        "countryClear": "Effacer",
        "documentNumberPlaceholder": "Numéro du document",
        "doubleCheck": "Vérifiez bien : {fields}",
        "failedBody": "Ça arrive tout le temps. Choisissez la solution la plus simple :",
        "failedTitle": "Impossible de lire cette pièce d’identité",
        "guestFallback": "Voyageur {id}",
        "manualBody": "Recopiez-les depuis le document : elles doivent correspondre exactement.",
        "manualSubmit": "Enregistrer les informations",
        "manualTitle": "Saisir les informations de la pièce",
        "missingLicense": "Le scan de documents n’est pas disponible pour le moment. Contactez votre hôte.",
        "noCamera": "Pas d’appareil photo ? Saisissez les informations à la main",
        "openingCamera": "Ouverture de l’appareil photo…",
        "optional": "Facultatif",
        "personalNumberPlaceholder": "Tel qu’indiqué sur le document",
        "pickGuest": "Choisissez à qui correspondent ces informations.",
        "regimeFieldsIntro": "Requis pour déclarer le séjour ici, et absent du document.",
        "required": "Obligatoire",
        "retake": "Scanner à nouveau",
        "reviewBody": "Lu depuis le document, sur votre téléphone. Corrigez ce qui semble faux : tout doit correspondre exactement.",
        "reviewTitle": "Vérifiez la correspondance avec la pièce",
        "scanBody": "Placez la page avec la photo dans le cadre. La lecture se fait automatiquement, inutile d’appuyer.",
        "scanButton": "Scanner un passeport ou une pièce d’identité",
        "scanEyebrow": "Scanner une pièce d’identité",
        "scanTarget": "Pour",
        "scanTitle": "Scannez le passeport ou la carte d’identité du voyageur",
        "scanned": "✓ Scanné",
        "select": "Choisir",
        "selectSex": "Choisir le sexe",
        "submitFailed": "Impossible d’envoyer votre enregistrement.",
        "submitting": "Envoi…",
        "tryAgainSub": "Plus de lumière, moins de reflets, tenez-la à plat",
        "tryAgainTitle": "Réessayer",
        "typeInsteadSub": "Saisissez ce qui est imprimé sur le document",
        "typeInsteadTitle": "Saisir les informations à la place",
        "view": {
          "cameraAccessDenied": "Accès à l’appareil photo refusé",
          "closeScanner": "Fermer le scanner",
          "holdSteady": "Ne bougez plus…",
          "loadImageFailed": "Échec du chargement de l’image",
          "positionMRZ": "Placez la bande MRZ dans le cadre",
          "rotateDevice": "Tournez votre appareil en mode portrait",
          "scanSuccess": "Bande MRZ scannée ✓",
          "switchCamera": "Changer d’appareil photo",
          "toggleFlash": "Activer/désactiver le flash"
        }
      }
    },
    "notFound": {
      "description": "Ce lien ne mène nulle part dans Vidimo. Il est peut-être obsolète ou mal saisi.",
      "goToToday": "Aller à Aujourd’hui",
      "title": "Page introuvable"
    },
    "osHelpers": {
      "cancel": "Annuler",
      "settings": "Réglages"
    },
    "pageHeader": {
      "back": "Retour"
    },
    "parkedDrawerBar": {
      "close": "Fermer le détail",
      "reopen": "Rouvrir {name}"
    },
    "paywallGate": {
      "errorOwnerOnly": "Seul le propriétaire de l’établissement peut configurer la facturation.",
      "lapsedNativeDescription": "Cet établissement est en pause. Rien n’a été supprimé, et l’accès revient dès que l’abonnement est de nouveau actif.",
      "lapsedNotice": "L’abonnement de cet établissement a expiré. Demandez au propriétaire de le renouveler.",
      "lapsedTitle": "Votre abonnement a pris fin",
      "noSubscriptionDescription": "Il faut un abonnement actif. Vos données restent en sécurité d’ici là.",
      "noSubscriptionTitle": "Cet établissement n’est pas encore actif",
      "pastDueNative": "Le paiement a échoué. L’accès pourrait bientôt prendre fin.",
      "propertySettings": "Paramètres de l’établissement",
      "signOut": "Se déconnecter",
      "trialActive": "Essai gratuit en cours.",
      "trialDaysLeft": "Essai gratuit : encore {days, plural, one {# jour} other {# jours}}."
    },
    "persisted": {
      "lateRollback": "Une modification enregistrée à l’instant n’a pas été prise en compte. Vérifiez-la et réessayez."
    },
    "placePicker": {
      "errorDetails": "Impossible de charger cette adresse. Essayez un autre résultat.",
      "errorLookup": "La recherche d’adresse a échoué. Vérifiez votre connexion.",
      "poweredByGoogle": "Fourni par Google",
      "searching": "Recherche…",
      "unavailable": "Recherche d’adresse indisponible"
    },
    "powersyncUploadFeedback": {
      "breakfastAlreadySetUp": "Le petit-déjeuner a déjà été configuré sur un autre appareil : votre modification n’a pas été enregistrée.",
      "discarded": "Certaines modifications n’ont pas pu être enregistrées et ont été annulées.",
      "discardedEntity": "Certaines modifications ({label}) n’ont pas pu être enregistrées et ont été annulées.",
      "labels": {
        "availability": "disponibilités",
        "breakfast": "paramètres du petit-déjeuner",
        "charge": "prestation",
        "conversation": "conversation",
        "guest": "voyageur",
        "message": "message",
        "payment": "paiement",
        "pricing": "tarification",
        "property": "établissement",
        "reaction": "réaction",
        "reservation": "réservation",
        "suggestion": "suggestion",
        "task": "tâche",
        "timeOff": "absence",
        "unit": "logement"
      },
      "revertAfterFiling": "L’arrivée de ces voyageurs a déjà été déclarée : la réservation ne peut plus repasser à un statut antérieur à l’arrivée."
    },
    "prerenderRoutes": {
      "signupMetaDescription": "Créez un compte Vidimo pour gérer vos établissements, vos réservations, la messagerie voyageurs et les arrivées depuis un seul endroit.",
      "signupTitle": "Créer un compte · Vidimo"
    },
    "primaryTabs": {
      "calendar": "Calendrier",
      "chats": "Messages",
      "guests": "Voyageurs",
      "tasks": "Tâches",
      "today": "Aujourd’hui"
    },
    "propertyFacet": {
      "addProperty": "Ajouter un établissement",
      "allProperties": "Tous les établissements",
      "colorLabel": "Couleur de l’établissement {name}",
      "empty": "Aucun établissement disponible.",
      "only": "Seulement",
      "onlyLabel": "Afficher seulement {name}",
      "settingsLabel": "Paramètres de {name}",
      "title": "Vos établissements"
    },
    "rowPending": {
      "syncing": "{kind, select, guest {Synchronisation du voyageur…} member {Synchronisation du membre…} parking {Synchronisation du parking…} reservation {Synchronisation de la réservation…} staffMember {Synchronisation du membre de l’équipe…} task {Synchronisation de la tâche…} unit {Synchronisation du logement…} other {Synchronisation…}}"
    },
    "scopeChip": {
      "allProperties": "Tous les établissements",
      "clearFilters": "Effacer<suffix> {count, plural, one {# filtre} other {# filtres}}</suffix>",
      "clearFiltersLabel": "Effacer {count, plural, one {# filtre} other {# filtres}}",
      "noProperties": "Aucun établissement",
      "propertyCount": "{count, plural, one {# établissement} other {# établissements}}",
      "scopeLabel": "Périmètre : {label}",
      "scopeLabelFiltered": "Périmètre : {label} ({count, plural, one {# filtre actif} other {# filtres actifs}})"
    },
    "scopeDrawer": {
      "title": "Périmètre"
    },
    "searchOverlay": {
      "close": "Fermer la recherche",
      "emptyDescription": "Recherchez des voyageurs, des membres de l’équipe, des réservations et des tâches",
      "guestFallback": "Voyageur",
      "noResultsDescription": "Essayez un autre terme",
      "noResultsTitle": "Aucun résultat",
      "placeholder": "Voyageurs, équipe, réservations, tâches…",
      "reservationFallback": "Réservation",
      "taskSubtitle": "Tâche",
      "taskSubtitleAssigned": "Tâche • {assignee}",
      "title": "Rechercher"
    },
    "staffFacet": {
      "allStaff": "Toute l’équipe",
      "empty": "Aucun membre de l’équipe disponible.",
      "meSuffix": "(moi)",
      "only": "Seulement",
      "onlyLabel": "Afficher seulement {name}",
      "title": "Équipe"
    },
    "stillLooking": {
      "description": "Il est peut-être encore en cours de synchronisation. S’il n’apparaît pas, il a peut-être été supprimé, ou il appartient à un établissement auquel vous n’avez pas accès.",
      "title": "{kind, select, guest {Recherche de ce voyageur en cours} member {Recherche de ce membre en cours} parking {Recherche de ce parking en cours} reservation {Recherche de cette réservation en cours} staffMember {Recherche de ce membre de l’équipe en cours} task {Recherche de cette tâche en cours} unit {Recherche de ce logement en cours} other {Recherche en cours}}"
    },
    "supportSession": {
      "ended": {
        "description": "Les données du client ont été effacées de cet onglet. Vous pouvez le fermer.",
        "title": "Session d’assistance terminée"
      },
      "failed": {
        "description": "Vérifiez la connexion, puis ouvrez une nouvelle session depuis le CRM.",
        "title": "Impossible d’ouvrir la session"
      },
      "invalid": {
        "description": "Chaque lien ouvre une seule session et reste valable une minute. Ouvrez-en un nouveau depuis le CRM.",
        "title": "Ce lien a expiré ou a déjà été utilisé"
      },
      "opening": "Ouverture de l’application du client…"
    },
    "supportSessionBanner": {
      "exit": "Quitter",
      "viewingAs": "Consultation en tant que {name}, assistance Vidimo"
    },
    "syncingState": {
      "defaultLabel": "Synchronisation de vos conversations…",
      "retry": "Réessayer",
      "retrying": "Nouvelle tentative…",
      "slow": "La synchronisation prend plus de temps que d’habitude…",
      "unreachableDescription": "Vos données se chargeront dès le retour de la connexion. Vérifiez votre connexion Internet ou réessayez dans un instant.",
      "unreachableTitle": "Serveur de synchronisation injoignable"
    },
    "useAcceptInvitation": {
      "errorInvitationNotFound": "Ce code d’invitation n’est plus valide : il a peut-être expiré ou été retiré. Demandez-en un nouveau.",
      "errorNotJoined": "Impossible de rejoindre l’établissement. Vérifiez votre code d’invitation et réessayez.",
      "errorSupportSession": "Impossible de rejoindre un établissement pendant une session d’assistance.",
      "errorWrongRecipient": "Cette invitation a été envoyée à une autre adresse e-mail. Connectez-vous avec cette adresse pour l’accepter.",
      "joined": "Établissement rejoint"
    },
    "useDirtyGuard": {
      "discardPrompt": "Vous avez des modifications non enregistrées. Les abandonner ?"
    },
    "userDrawer": {
      "account": "Compte",
      "accountDescription": "Profil, apparence et calendrier des tâches",
      "accountSection": "Compte",
      "contactSupport": "Contacter l’assistance",
      "contactSupportDescription": "Écrire à l’équipe Vidimo",
      "help": "Aide",
      "helpDescription": "Guides d’utilisation de Vidimo",
      "joinProperty": "Rejoindre un établissement",
      "joinPropertyDescription": "Avec le code d’invitation d’un collègue",
      "legalSection": "Mentions légales",
      "notifications": "Paramètres de notification",
      "notificationsDescription": "Sons des messages, des groupes et des appels",
      "privacy": "Politique de confidentialité",
      "privacyDescription": "Comment Vidimo traite vos données",
      "signOut": "Se déconnecter",
      "signedIn": "Connecté",
      "supportSection": "Assistance",
      "terms": "Conditions d’utilisation",
      "termsDescription": "Le contrat qui encadre votre utilisation de Vidimo",
      "trigger": "Menu utilisateur",
      "triggerWithNews": "Menu utilisateur, avec du nouveau dans Nouveautés",
      "whatsNew": "Nouveautés",
      "whatsNewDescription": "Ce qui a changé dans Vidimo, version par version",
      "whatsNewUnseen": "Nouvelle entrée"
    }
  },

  "stayPreview": {
    "stayPreviewFrame": {
      "frameTitle": "Aperçu de la page séjour du voyageur",
      "loadFailed": "L’aperçu ne s’est pas chargé.",
      "tryAgain": "Réessayer"
    },
    "stayPreviewHost": {
      "preview": "Aperçu",
      "title": "Voir comme un voyageur"
    },
    "stayPreviewPanel": {
      "copyLink": "Copier le lien",
      "errorCopyFailed": "Impossible de copier le lien",
      "linkCopied": "Lien de l’aperçu copié",
      "phaseAfter": "Après le départ",
      "phaseArrivalDay": "Jour d’arrivée",
      "phaseBefore": "Avant l’arrivée",
      "phaseGroupLabel": "Étape du séjour",
      "phaseInStay": "Pendant le séjour",
      "qrCodeLabel": "QR code pour ouvrir cet aperçu sur votre téléphone",
      "sampleNotice": "Un séjour fictif : les dates, les voyageurs et le code d’accès sont des exemples.",
      "scanHint": "Scannez pour ouvrir cet aperçu sur votre téléphone. Il affiche ce que vous avez enregistré."
    }
  },

  "tasks": {
    "completed": {
      "completeFailed": "Impossible de terminer la tâche. Réessayez.",
      "title": "Tâche terminée",
      "undo": "Annuler",
      "undoFailed": "Impossible d’annuler. La tâche reste terminée."
    },
    "completionNote": {
      "dictate": "Dicter une note",
      "hint": "Notez ce qui demande un suivi.",
      "optional": "Facultatif",
      "placeholder": "Saisissez une note…",
      "save": "Enregistrer la note",
      "saveFailed": "Impossible d’enregistrer la note. Réessayez.",
      "saved": "Enregistrée",
      "stopRecording": "Arrêter l’enregistrement",
      "title": "Ajouter une note à la tâche",
      "transcribeFailed": "Impossible de transcrire l’enregistrement. Merci de réessayer.",
      "transcribing": "Transcription…"
    },
    "editTaskForm": {
      "assignedTo": "Affectée à",
      "back": "Retour",
      "backToTasks": "Retour aux tâches",
      "cancel": "Annuler",
      "create": "Créer",
      "created": "Tâche créée.",
      "dateLabel": "Date <hint>(facultatif : laissez vide pour une tâche sans date)</hint>",
      "delete": "Supprimer",
      "deleteDescription": "Elle disparaît pour tout le monde. Pour clore un travail, mieux vaut généralement terminer la tâche : la suppression est réservée à une tâche qui n’aurait jamais dû exister.",
      "deleteTask": "Supprimer la tâche",
      "deleteTitle": "Supprimer cette tâche ?",
      "deleted": "Tâche supprimée",
      "deleting": "Suppression…",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Description de la tâche (facultatif)",
      "endTimeLabel": "Heure de fin",
      "errorNotDeleted": "Impossible de supprimer cette tâche. Merci de réessayer.",
      "errorNotSaved": "Impossible d’enregistrer la tâche. Réessayez.",
      "notFound": "Tâche introuvable",
      "priorityHigh": "Haute",
      "priorityLabel": "Priorité",
      "priorityLow": "Basse",
      "priorityMedium": "Moyenne",
      "propertyLabel": "Établissement",
      "propertyPlaceholder": "Choisir un établissement",
      "save": "Enregistrer",
      "startTimeLabel": "Heure de début",
      "statusLabel": "Statut",
      "titleEdit": "Modifier la tâche",
      "titleLabel": "Titre",
      "titleNew": "Nouvelle tâche",
      "titlePlaceholder": "Titre de la tâche",
      "typeCleaning": "Ménage",
      "typeLabel": "Type",
      "typeMaintenance": "Maintenance",
      "unitLabel": "Logement",
      "unitNeedsProperty": "Choisissez d’abord un établissement",
      "updated": "Tâche mise à jour."
    },
    "staffAssigneeSelect": {
      "assigned": "Affectée",
      "cancel": "Annuler",
      "confirm": "Affecter quand même",
      "confirmDescription": "Cette personne est indiquée comme indisponible sur ce créneau. Vous pouvez quand même l’affecter en cas d’urgence.",
      "confirmDescriptionReason": "Cette personne est indiquée comme indisponible sur ce créneau ({reason}). Vous pouvez quand même l’affecter en cas d’urgence.",
      "confirmTitle": "Affecter {name} quand même ?",
      "filteringNote": "{taskFunction, select, check_in {Membres de l’équipe pouvant gérer les arrivées.} check_out {Membres de l’équipe pouvant gérer les départs.} cleaning {Membres de l’équipe pouvant faire le ménage.} concierge {Membres de l’équipe pouvant assurer la conciergerie.} maintenance {Membres de l’équipe pouvant assurer la maintenance.} other {Membres de l’équipe pouvant assurer : {taskFunction}.}}",
      "noFunction": "{taskFunction, select, check_in {Pas de fonction Arrivée} check_out {Pas de fonction Départ} cleaning {Pas de fonction Ménage} concierge {Pas de fonction Conciergerie} maintenance {Pas de fonction Maintenance} other {Pas de fonction {taskFunction}}}",
      "showEveryone": "Afficher tout le monde",
      "showQualified": "Afficher seulement les personnes qualifiées",
      "unassigned": "Non affectée"
    },
    "taskCues": {
      "label": {
        "infant": "Installer un lit bébé (nourrisson attendu)",
        "pet": "Voyage avec un animal",
        "petWithNotes": "Animal : {notes}"
      },
      "short": {
        "accessibility": "Accessibilité",
        "dietary": "Régime",
        "infant": "Lit bébé",
        "pet": "Animal"
      }
    },
    "taskDetails": {
      "accessibility": "Accessibilité",
      "afterCheckout": "Après le départ à {checkOut}",
      "afterCheckoutBeforeCheckIn": "Après le départ à {checkOut} · Avant l’arrivée à {checkIn}",
      "assignedTo": "Affectée à",
      "assignment": "Affectation",
      "beforeCheckIn": "Avant l’arrivée à {checkIn}",
      "checkIn": "Arrivée",
      "cleaningUpAfter": "Ménage après <guest>{name}</guest>",
      "completionNote": "Note de fin",
      "description": "Description",
      "dietary": "Régime alimentaire",
      "eta": "· arrivée prévue ~{eta}",
      "markDone": "Marquer comme fait",
      "notScheduled": "Non planifiée",
      "openLiveView": "Ouvrir la vue en direct",
      "pets": "Animaux",
      "prepFor": "Préparation pour",
      "specialRequests": "Demandes particulières",
      "startTask": "Commencer la tâche",
      "travellingWithPet": "Voyage avec un animal",
      "unassigned": "Non affectée",
      "unitCode": "Logement {code}",
      "unitCodeAndName": "Logement {code} – {name}",
      "unknownUnit": "Logement inconnu",
      "via": "via",
      "viewFullReservation": "Voir toute la réservation",
      "viewSummary": "Voir le résumé",
      "when": "Quand",
      "where": "Où"
    },
    "taskLiveView": {
      "allStepsDone": "{total, plural, one {L’étape est faite} other {Les {total} étapes sont faites}}",
      "assignment": "Affectation",
      "back": "Retour",
      "backToTasks": "Retour aux tâches",
      "checkInFrom": "Arrivée des voyageurs à partir de {time}",
      "checkInFromWithEta": "Arrivée des voyageurs à partir de {time} · prévue {eta}",
      "checklistTitle": "Liste de ménage",
      "compactCheckIn": "Arrivée {time}",
      "compactEta": "Prévue {time}",
      "edit": "Modifier",
      "errorComplete": "Impossible de terminer la tâche. Réessayez.",
      "errorStart": "Impossible de commencer la tâche. Réessayez.",
      "errorStepUpdate": "Impossible de mettre à jour cette étape. Réessayez.",
      "errorUpdate": "Impossible de mettre à jour la tâche. Réessayez.",
      "finishAnyway": "Terminer quand même",
      "finishHintTask": "Terminez la tâche quand la chambre est prête, rien ne presse.",
      "finishHintTurnover": "Terminez la rotation quand la chambre est prête, rien ne presse.",
      "missedHint": "Le voyageur est arrivé avant que la tâche soit faite. Si elle a bien été faite, passez son statut à Terminée, puis la chambre à Propre.",
      "missedHintAskManager": "Le voyageur est arrivé avant que la tâche soit faite. Si elle a bien été faite, passez son statut à Terminée, puis demandez à un propriétaire ou à un gérant de passer la chambre à Propre.",
      "finishPostCheckout": "Terminer le ménage après départ",
      "finishPreCheckinRefresh": "Terminer le rafraîchissement",
      "finishTurnover": "Terminer la rotation",
      "finished": "Terminé",
      "guestNames": "– {names}",
      "headerTitle": "Tâche",
      "headingKindUnit": "{kind} – {unit}",
      "keepGoing": "Continuer",
      "kindCleaning": "Ménage",
      "kindComplete": "{kind} : terminé",
      "kindMaintenance": "Maintenance",
      "markComplete": "Marquer comme terminée",
      "markedComplete": "Marquée comme terminée",
      "missing": "Cette tâche n’est pas disponible.",
      "notScheduled": "Non planifiée",
      "notesQuote": "« {notes} »",
      "pause": "Pause",
      "prepFor": "Préparation · prochains voyageurs",
      "resume": "Reprendre",
      "someStepsDone": "{total, plural, one {{done} / {total} étape faite} other {{done} / {total} étapes faites}}",
      "startTask": "Commencer la tâche",
      "started": "Commencée",
      "startedAt": "Commencée à {time}",
      "stepsLeftDescription": "Pas encore cochées :",
      "stepsLeftTitle": "{left, plural, one {Terminer avec {left} étape restante ?} other {Terminer avec {left} étapes restantes ?}}",
      "task": "Tâche",
      "taskComplete": "Tâche terminée",
      "todayBefore": "Aujourd’hui, avant {time}",
      "upNext": "Ensuite",
      "upNextFor": "Ensuite · {name}",
      "when": "Quand",
      "where": "Où"
    },
    "taskPrep": {
      "adults": "{count, plural, one {# adulte} other {# adultes}}",
      "children": "{count, plural, one {# enfant} other {# enfants}}",
      "guests": "{count, plural, one {# voyageur} other {# voyageurs}}",
      "infants": "{count, plural, one {# bébé} other {# bébés}}"
    },
    "tasksView": {
      "completeTask": "Terminer {title}",
      "createTask": "Créer une tâche",
      "dateAt": "{date} • {time}",
      "emptyDescription": "Créez une tâche pour commencer",
      "emptyTitle": "Aucune tâche",
      "hideCompleted": "Masquer les tâches terminées",
      "needsOwner": "à affecter",
      "openTask": "Ouvrir {title}",
      "sectionCompleted": "Terminées",
      "sectionMissed": "Manquées",
      "sectionOverdue": "En retard",
      "sectionToday": "Aujourd’hui",
      "sectionUnscheduled": "Non planifiées",
      "sectionUpcoming": "À venir",
      "showCompleted": "Afficher les tâches terminées",
      "switchToColumns": "Passer en vue colonnes",
      "switchToList": "Passer en vue liste",
      "syncing": "Synchronisation de vos tâches…",
      "taskCount": "{count, plural, one {{count} tâche} other {{count} tâches}}",
      "taskCountNeedsOwner": "{count, plural, one {{count} tâche • à affecter} other {{count} tâches • à affecter}}",
      "title": "Tâches",
      "unassigned": "Non affectées",
      "unavailableDescription": "Vidimo ne parvient pas à charger vos tâches sur cet appareil. Touchez Réessayer : l’application sera rechargée.",
      "unavailableTitle": "Impossible d’afficher les tâches pour le moment"
    },
    "waitsForClean": {
      "detail": "La chambre est encore sale. Commencez le rafraîchissement une fois le ménage fait.",
      "title": "En attente du ménage"
    }
  }
}
